const ArabicTokens = {
    name: "arabic",
    selectors: [":lang(ar)"],
    tokens: {
        "font-family-monospace": "Consolas, Menlo, 'Lucida Console', Courier, Monaco, monospace",
        "font-family-primary": "'Anova UI', 'Geeza Pro', 'Helvetica Neue', 'Helvetica', 'Arial,' sans-serif",
        "font-family-secondary": "'Anova', 'Geeza Pro', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-size-body-text-l": "1rem",
        "font-size-body-text-m": "0.875rem",
        "font-size-body-text-s": "0.75rem",
        "font-size-body-text-xl": "1.125rem",
        "font-size-body-text-xs": "0.6875rem",
        "font-size-body-text-xxl": "1.25rem",
        "font-size-body-text-xxs": "0.625rem",
        "font-size-body-text-xxxl": "1.375rem",
        "font-size-body-text-xxxs": "0.5625rem",
        "font-size-body-text-xxxxl": "1.5625rem",
        "font-size-display-text-1": "4.5625rem",
        "font-size-display-text-2": "3.625rem",
        "font-size-display-text-3": "2.5rem",
        "font-size-heading-text-l": "1rem",
        "font-size-heading-text-m": "0.875rem",
        "font-size-heading-text-s": "0.75rem",
        "font-size-heading-text-xl": "1.125rem",
        "font-size-heading-text-xxl": "1.25rem",
        "font-size-heading-text-xxxl": "1.375rem",
        "font-size-heading-text-xxxxl": "1.75rem",
        "font-size-heading-text-xxxxxl": "2.25rem",
        "font-size-heading-text-xxxxxxl": "3.625rem",
        "font-space-letter-spacing": "normal",
        "font-space-letter-spacing-l": "normal",
        "font-space-letter-spacing-m": "normal",
        "font-space-letter-spacing-s": "normal",
        "font-space-letter-spacing-xs": "normal",
        "font-space-line-height": "1.5",
        "font-space-line-height-l": "1.7",
        "font-space-line-height-m": "1.6",
        "font-space-line-height-s": "1.5",
        "font-space-line-height-xl": "1.8",
        "font-space-line-height-xxl": "1.9",
        "font-style-weight-300": "400",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-icon-l": "1rem",
        "size-icon-m": "0.875rem",
        "size-icon-s": "0.75rem",
        "size-icon-xl": "1.125rem",
        "size-icon-xs": "0.75rem",
        "size-icon-xxl": "1.25rem",
        "size-icon-xxs": "0.75rem",
        "size-icon-xxxl": "1.375rem",
        "size-icon-xxxs": "0.75rem",
        "size-icon-xxxxl": "1.5625rem",
        "space-base-l": "1.5rem",
        "space-base-m": "1rem",
        "space-base-null": "0",
        "space-base-s": "0.5rem",
        "space-base-size": "1rem",
        "space-base-xl": "2rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.5625rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "2.875rem",
        "space-base-xxxxl": "3.625rem",
        "space-base-xxxxxl": "4.125rem"
    }
};

const ArabicPseudoTokens = {
    name: "arabicPseudo",
    selectors: [":lang(ar-xx)"],
    tokens: {
        "font-family-monospace": "Consolas, Menlo, 'Lucida Console', Courier, Monaco, monospace",
        "font-family-primary": "'Anova UI', 'PseudoArabic', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-family-secondary": "'Anova', 'PseudoArabic', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-size-body-text-l": "1rem",
        "font-size-body-text-m": "0.875rem",
        "font-size-body-text-s": "0.75rem",
        "font-size-body-text-xl": "1.125rem",
        "font-size-body-text-xs": "0.6875rem",
        "font-size-body-text-xxl": "1.25rem",
        "font-size-body-text-xxs": "0.625rem",
        "font-size-body-text-xxxl": "1.375rem",
        "font-size-body-text-xxxs": "0.5625rem",
        "font-size-body-text-xxxxl": "1.5625rem",
        "font-size-display-text-1": "4.5625rem",
        "font-size-display-text-2": "3.625rem",
        "font-size-display-text-3": "2.5rem",
        "font-size-heading-text-l": "1rem",
        "font-size-heading-text-m": "0.875rem",
        "font-size-heading-text-s": "0.75rem",
        "font-size-heading-text-xl": "1.125rem",
        "font-size-heading-text-xxl": "1.25rem",
        "font-size-heading-text-xxxl": "1.375rem",
        "font-size-heading-text-xxxxl": "1.75rem",
        "font-size-heading-text-xxxxxl": "2.25rem",
        "font-size-heading-text-xxxxxxl": "3.625rem",
        "font-space-letter-spacing": "normal",
        "font-space-letter-spacing-l": "normal",
        "font-space-letter-spacing-m": "normal",
        "font-space-letter-spacing-s": "normal",
        "font-space-letter-spacing-xs": "normal",
        "font-space-line-height": "1.5",
        "font-space-line-height-l": "1.7",
        "font-space-line-height-m": "1.6",
        "font-space-line-height-s": "1.5",
        "font-space-line-height-xl": "1.8",
        "font-space-line-height-xxl": "1.9",
        "font-style-weight-300": "400",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-icon-l": "1rem",
        "size-icon-m": "0.875rem",
        "size-icon-s": "0.75rem",
        "size-icon-xl": "1.125rem",
        "size-icon-xs": "0.75rem",
        "size-icon-xxl": "1.25rem",
        "size-icon-xxs": "0.75rem",
        "size-icon-xxxl": "1.375rem",
        "size-icon-xxxs": "0.75rem",
        "size-icon-xxxxl": "1.5625rem",
        "space-base-l": "1.5rem",
        "space-base-m": "1rem",
        "space-base-null": "0",
        "space-base-s": "0.5rem",
        "space-base-size": "1rem",
        "space-base-xl": "2rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.5625rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "2.875rem",
        "space-base-xxxxl": "3.625rem",
        "space-base-xxxxxl": "4.125rem"
    }
};

const ChineseChinaTokens = {
    name: "chineseChina",
    selectors: [":lang(zh)", ":lang(zh-cn)", ":lang(zh-sg)", ":lang(zh-hans)"],
    tokens: {
        "font-family-monospace": "Consolas, Menlo, 'Lucida Console', Courier, Monaco, monospace",
        "font-family-primary": "'Anova UI', '微软雅黑体', 'Microsoft YaHei New', '微软雅黑', 'Microsoft Yahei', '宋体', 'SimSun', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-family-secondary": "'Anova', '微软雅黑体', 'Microsoft YaHei New', '微软雅黑', 'Microsoft Yahei', '宋体', 'SimSun', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-size-body-text-l": "1.125rem",
        "font-size-body-text-m": "1rem",
        "font-size-body-text-s": "0.875rem",
        "font-size-body-text-xl": "1.25rem",
        "font-size-body-text-xs": "0.8125rem",
        "font-size-body-text-xxl": "1.4375rem",
        "font-size-body-text-xxs": "0.6875rem",
        "font-size-body-text-xxxl": "1.625rem",
        "font-size-body-text-xxxs": "0.625rem",
        "font-size-body-text-xxxxl": "1.8125rem",
        "font-size-display-text-1": "5.1875rem",
        "font-size-display-text-2": "4.125rem",
        "font-size-display-text-3": "2.875rem",
        "font-size-heading-text-l": "1.125rem",
        "font-size-heading-text-m": "1rem",
        "font-size-heading-text-s": "0.875rem",
        "font-size-heading-text-xl": "1.25rem",
        "font-size-heading-text-xxl": "1.4375rem",
        "font-size-heading-text-xxxl": "1.625rem",
        "font-size-heading-text-xxxxl": "2rem",
        "font-size-heading-text-xxxxxl": "2.5625rem",
        "font-size-heading-text-xxxxxxl": "4.125rem",
        "font-space-letter-spacing": "normal",
        "font-space-letter-spacing-l": "normal",
        "font-space-letter-spacing-m": "normal",
        "font-space-letter-spacing-s": "normal",
        "font-space-letter-spacing-xs": "normal",
        "font-space-line-height": "1.5",
        "font-space-line-height-l": "1.7",
        "font-space-line-height-m": "1.6",
        "font-space-line-height-s": "1.5",
        "font-space-line-height-xl": "1.8",
        "font-space-line-height-xxl": "1.9",
        "font-style-expression-italic": "normal",
        "font-style-text-transform-uppercase": "initial",
        "font-style-weight-300": "400",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-icon-l": "1.125rem",
        "size-icon-m": "1rem",
        "size-icon-s": "0.875rem",
        "size-icon-xl": "1.25rem",
        "size-icon-xs": "0.875rem",
        "size-icon-xxl": "1.4375rem",
        "size-icon-xxs": "0.875rem",
        "size-icon-xxxl": "1.625rem",
        "size-icon-xxxs": "0.875rem",
        "size-icon-xxxxl": "1.8125rem",
        "space-base-l": "1.625rem",
        "space-base-m": "1.125rem",
        "space-base-null": "0",
        "space-base-s": "0.5625rem",
        "space-base-size": "1.125rem",
        "space-base-xl": "2.25rem",
        "space-base-xs": "0.3125rem",
        "space-base-xxl": "2.875rem",
        "space-base-xxs": "0.1875rem",
        "space-base-xxxl": "3.25rem",
        "space-base-xxxxl": "4.125rem",
        "space-base-xxxxxl": "4.625rem"
    }
};

const ChineseHongKongTokens = {
    name: "chineseHongKong",
    selectors: [":lang(zh-hk)"],
    tokens: {
        "font-family-monospace": "Consolas, Menlo, 'Lucida Console', Courier, Monaco, monospace",
        "font-family-primary": "'Anova UI', '微軟正黑體', 'Microsoft JhengHei', '黑體-繁', 'Heiti TC', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-family-secondary": "'Anova', '微軟正黑體', 'Microsoft JhengHei', '黑體-繁', 'Heiti TC', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-size-body-text-l": "1.125rem",
        "font-size-body-text-m": "1rem",
        "font-size-body-text-s": "0.875rem",
        "font-size-body-text-xl": "1.25rem",
        "font-size-body-text-xs": "0.8125rem",
        "font-size-body-text-xxl": "1.4375rem",
        "font-size-body-text-xxs": "0.6875rem",
        "font-size-body-text-xxxl": "1.625rem",
        "font-size-body-text-xxxs": "0.625rem",
        "font-size-body-text-xxxxl": "1.8125rem",
        "font-size-display-text-1": "5.1875rem",
        "font-size-display-text-2": "4.125rem",
        "font-size-display-text-3": "2.875rem",
        "font-size-heading-text-l": "1.125rem",
        "font-size-heading-text-m": "1rem",
        "font-size-heading-text-s": "0.875rem",
        "font-size-heading-text-xl": "1.25rem",
        "font-size-heading-text-xxl": "1.4375rem",
        "font-size-heading-text-xxxl": "1.625rem",
        "font-size-heading-text-xxxxl": "2rem",
        "font-size-heading-text-xxxxxl": "2.5625rem",
        "font-size-heading-text-xxxxxxl": "4.125rem",
        "font-space-letter-spacing": "normal",
        "font-space-letter-spacing-l": "normal",
        "font-space-letter-spacing-m": "normal",
        "font-space-letter-spacing-s": "normal",
        "font-space-letter-spacing-xs": "normal",
        "font-space-line-height": "1.5",
        "font-space-line-height-l": "1.7",
        "font-space-line-height-m": "1.6",
        "font-space-line-height-s": "1.5",
        "font-space-line-height-xl": "1.8",
        "font-space-line-height-xxl": "1.9",
        "font-style-expression-italic": "normal",
        "font-style-text-transform-uppercase": "initial",
        "font-style-weight-300": "400",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-icon-l": "1.125rem",
        "size-icon-m": "1rem",
        "size-icon-s": "0.875rem",
        "size-icon-xl": "1.25rem",
        "size-icon-xs": "0.875rem",
        "size-icon-xxl": "1.4375rem",
        "size-icon-xxs": "0.875rem",
        "size-icon-xxxl": "1.625rem",
        "size-icon-xxxs": "0.875rem",
        "size-icon-xxxxl": "1.8125rem",
        "space-base-l": "1.625rem",
        "space-base-m": "1.125rem",
        "space-base-null": "0",
        "space-base-s": "0.5625rem",
        "space-base-size": "1.125rem",
        "space-base-xl": "2.25rem",
        "space-base-xs": "0.3125rem",
        "space-base-xxl": "2.875rem",
        "space-base-xxs": "0.1875rem",
        "space-base-xxxl": "3.25rem",
        "space-base-xxxxl": "4.125rem",
        "space-base-xxxxxl": "4.625rem"
    }
};

const ChinesePseudoTokens = {
    name: "chinesePseudo",
    selectors: [":lang(zh-cn-pseudo)"],
    tokens: {
        "font-family-monospace": "Consolas, Menlo, 'Lucida Console', Courier, Monaco, monospace",
        "font-family-primary": "'Anova UI', '微软雅黑体', 'Microsoft YaHei New', '微软雅黑', 'Microsoft Yahei', '宋体', 'SimSun', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-family-secondary": "'Anova', '微软雅黑体', 'Microsoft YaHei New', '微软雅黑', 'Microsoft Yahei', '宋体', 'SimSun', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-size-body-text-l": "1.125rem",
        "font-size-body-text-m": "1rem",
        "font-size-body-text-s": "0.875rem",
        "font-size-body-text-xl": "1.25rem",
        "font-size-body-text-xs": "0.8125rem",
        "font-size-body-text-xxl": "1.4375rem",
        "font-size-body-text-xxs": "0.6875rem",
        "font-size-body-text-xxxl": "1.625rem",
        "font-size-body-text-xxxs": "0.625rem",
        "font-size-body-text-xxxxl": "1.8125rem",
        "font-size-display-text-1": "5.1875rem",
        "font-size-display-text-2": "4.125rem",
        "font-size-display-text-3": "2.875rem",
        "font-size-heading-text-l": "1.125rem",
        "font-size-heading-text-m": "1rem",
        "font-size-heading-text-s": "0.875rem",
        "font-size-heading-text-xl": "1.25rem",
        "font-size-heading-text-xxl": "1.4375rem",
        "font-size-heading-text-xxxl": "1.625rem",
        "font-size-heading-text-xxxxl": "2rem",
        "font-size-heading-text-xxxxxl": "2.5625rem",
        "font-size-heading-text-xxxxxxl": "4.125rem",
        "font-space-letter-spacing": "normal",
        "font-space-letter-spacing-l": "normal",
        "font-space-letter-spacing-m": "normal",
        "font-space-letter-spacing-s": "normal",
        "font-space-letter-spacing-xs": "normal",
        "font-space-line-height": "1.5",
        "font-space-line-height-l": "1.7",
        "font-space-line-height-m": "1.6",
        "font-space-line-height-s": "1.5",
        "font-space-line-height-xl": "1.8",
        "font-space-line-height-xxl": "1.9",
        "font-style-expression-italic": "normal",
        "font-style-text-transform-uppercase": "initial",
        "font-style-weight-300": "400",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-icon-l": "1.125rem",
        "size-icon-m": "1rem",
        "size-icon-s": "0.875rem",
        "size-icon-xl": "1.25rem",
        "size-icon-xs": "0.875rem",
        "size-icon-xxl": "1.4375rem",
        "size-icon-xxs": "0.875rem",
        "size-icon-xxxl": "1.625rem",
        "size-icon-xxxs": "0.875rem",
        "size-icon-xxxxl": "1.8125rem",
        "space-base-l": "1.625rem",
        "space-base-m": "1.125rem",
        "space-base-null": "0",
        "space-base-s": "0.5625rem",
        "space-base-size": "1.125rem",
        "space-base-xl": "2.25rem",
        "space-base-xs": "0.3125rem",
        "space-base-xxl": "2.875rem",
        "space-base-xxs": "0.1875rem",
        "space-base-xxxl": "3.25rem",
        "space-base-xxxxl": "4.125rem",
        "space-base-xxxxxl": "4.625rem"
    }
};

const CompactDensityChineseVariantsTokens = {
    name: "compact-density-chinese-variants",
    selectors: ["[data-sas-theme='spacious-density']:lang(zh)", "[data-sas-theme='spacious-density']:lang(zh-cn)", "[data-sas-theme='spacious-density']:lang(zh-sg)", "[data-sas-theme='spacious-density']:lang(zh-hans)", "[data-sas-theme='spacious-density']:lang(zh-cn-pseudo)", "[data-sas-theme='spacious-density']:lang(zh-hk)", "[data-sas-theme='spacious-density']:lang(zh-tw)", "[data-sas-theme='spacious-density']:lang(zh-hant)"],
    tokens: {
        "font-size-body-text-l": "1rem",
        "font-size-body-text-m": "0.875rem",
        "font-size-body-text-s": "0.75rem",
        "font-size-body-text-xl": "1.125rem",
        "font-size-body-text-xs": "0.6875rem",
        "font-size-body-text-xxl": "1.25rem",
        "font-size-body-text-xxs": "0.625rem",
        "font-size-body-text-xxxl": "1.375rem",
        "font-size-body-text-xxxs": "0.5625rem",
        "font-size-body-text-xxxxl": "1.5625rem",
        "font-size-display-text-1": "4.5625rem",
        "font-size-display-text-2": "3.625rem",
        "font-size-display-text-3": "2.5rem",
        "font-size-heading-text-l": "1rem",
        "font-size-heading-text-m": "0.875rem",
        "font-size-heading-text-s": "0.75rem",
        "font-size-heading-text-xl": "1.125rem",
        "font-size-heading-text-xxl": "1.25rem",
        "font-size-heading-text-xxxl": "1.375rem",
        "font-size-heading-text-xxxxl": "1.75rem",
        "font-size-heading-text-xxxxxl": "2.25rem",
        "font-size-heading-text-xxxxxxl": "3.625rem",
        "font-space-line-height": "1.4",
        "font-space-line-height-l": "1.6",
        "font-space-line-height-m": "1.5",
        "font-space-line-height-s": "1.4",
        "font-space-line-height-xl": "1.7",
        "font-space-line-height-xxl": "1.8",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "12px",
        "size-border-radius-m": "8px",
        "size-border-radius-s": "4px",
        "size-border-radius-xs": "2px",
        "size-border-radius-xxs": "1px",
        "size-icon-l": "1rem",
        "size-icon-m": "0.875rem",
        "size-icon-s": "0.75rem",
        "size-icon-xl": "1.125rem",
        "size-icon-xs": "0.75rem",
        "size-icon-xxl": "1.25rem",
        "size-icon-xxs": "0.75rem",
        "size-icon-xxxl": "1.375rem",
        "size-icon-xxxs": "0.75rem",
        "size-icon-xxxxl": "1.5625rem",
        "space-base-l": "1.5rem",
        "space-base-m": "1rem",
        "space-base-null": "0",
        "space-base-s": "0.5rem",
        "space-base-size": "1rem",
        "space-base-xl": "2rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.5625rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "2.875rem",
        "space-base-xxxxl": "3.625rem",
        "space-base-xxxxxl": "4.125rem"
    }
};

const CompactDensityEuroSlavicLocalesTokens = {
    name: "compact-density-euro-slavic-locales",
    selectors: ["[data-sas-theme='compact-density']:lang(en)"],
    tokens: {
        "font-size-body-text-l": "0.875rem",
        "font-size-body-text-m": "0.75rem",
        "font-size-body-text-s": "0.6875rem",
        "font-size-body-text-xl": "0.9375rem",
        "font-size-body-text-xs": "0.5625rem",
        "font-size-body-text-xxl": "1.0625rem",
        "font-size-body-text-xxs": "0.5rem",
        "font-size-body-text-xxxl": "1.1875rem",
        "font-size-body-text-xxxs": "0.5625rem",
        "font-size-body-text-xxxxl": "1.375rem",
        "font-size-display-text-1": "3.875rem",
        "font-size-display-text-2": "3.0625re",
        "font-size-display-text-3": "2.1875rem",
        "font-size-heading-text-l": "0.875rem",
        "font-size-heading-text-m": "0.75rem",
        "font-size-heading-text-s": "0.6875rem",
        "font-size-heading-text-xl": "0.9375rem",
        "font-size-heading-text-xxl": "1.0625rem",
        "font-size-heading-text-xxxl": "1.1875rem",
        "font-size-heading-text-xxxxl": "1.5rem",
        "font-size-heading-text-xxxxxl": "1.9375rem",
        "font-size-heading-text-xxxxxxl": "3.0625rem",
        "font-space-line-height": "1.4",
        "font-space-line-height-l": "1.6",
        "font-space-line-height-m": "1.5",
        "font-space-line-height-s": "1.4",
        "font-space-line-height-xl": "1.7",
        "font-space-line-height-xxl": "1.8",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "12px",
        "size-border-radius-m": "8px",
        "size-border-radius-s": "4px",
        "size-border-radius-xs": "2px",
        "size-border-radius-xxs": "1px",
        "size-icon-l": "0.875rem",
        "size-icon-m": "0.75rem",
        "size-icon-s": "0.6875rem",
        "size-icon-xl": "0.9375rem",
        "size-icon-xs": "0.6875rem",
        "size-icon-xxl": "1.0625rem",
        "size-icon-xxs": "0.6875rem",
        "size-icon-xxxl": "1.1875rem",
        "size-icon-xxxs": "0.6875rem",
        "size-icon-xxxxl": "1.375rem",
        "space-base-l": "1.25rem",
        "space-base-m": "0.875rem",
        "space-base-null": "0",
        "space-base-s": "0.4375rem",
        "space-base-size": "1rem",
        "space-base-xl": "1.75rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.25rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "2.5rem",
        "space-base-xxxxl": "3.1875rem",
        "space-base-xxxxxl": "3.625rem"
    }
};

const CompactDensityMenaAsianLocalesTokens = {
    name: "compact-density-mena-asian-locales",
    selectors: ["[data-sas-theme='compact-density']:lang(ar)", "[data-sas-theme='compact-density']:lang(ar-xx)", "[data-sas-theme='compact-density']:lang(he)", "[data-sas-theme='compact-density']:lang(jp)", "[data-sas-theme='compact-density']:lang(ko)", "[data-sas-theme='compact-density']:lang(th)", "[data-sas-theme='compact-density']:lang(vi)", "[data-sas-theme='compact-density']:lang(vi-VN)"],
    tokens: {
        "font-size-body-text-l": "0.875rem",
        "font-size-body-text-m": "0.75rem",
        "font-size-body-text-s": "0.6875rem",
        "font-size-body-text-xl": "0.9375rem",
        "font-size-body-text-xs": "0.5625rem",
        "font-size-body-text-xxl": "1.0625rem",
        "font-size-body-text-xxs": "0.5rem",
        "font-size-body-text-xxxl": "1.1875rem",
        "font-size-body-text-xxxs": "0.4375rem",
        "font-size-body-text-xxxxl": "1.375rem",
        "font-size-display-text-1": "3.875rem",
        "font-size-display-text-2": "3.0625rem",
        "font-size-display-text-3": "2.1875rem",
        "font-size-heading-text-l": "0.875rem",
        "font-size-heading-text-m": "0.75rem",
        "font-size-heading-text-s": "0.6875rem",
        "font-size-heading-text-xl": "0.9375rem",
        "font-size-heading-text-xxl": "1.0625rem",
        "font-size-heading-text-xxxl": "1.1875rem",
        "font-size-heading-text-xxxxl": "1.5rem",
        "font-size-heading-text-xxxxxl": "1.9375rem",
        "font-size-heading-text-xxxxxxl": "3.0625rem",
        "font-space-line-height": "1.4",
        "font-space-line-height-l": "1.6",
        "font-space-line-height-m": "1.5",
        "font-space-line-height-s": "1.4",
        "font-space-line-height-xl": "1.7",
        "font-space-line-height-xxl": "1.8",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "12px",
        "size-border-radius-m": "8px",
        "size-border-radius-s": "4px",
        "size-border-radius-xs": "2px",
        "size-border-radius-xxs": "1px",
        "size-icon-l": "0.875rem",
        "size-icon-m": "0.75rem",
        "size-icon-s": "0.6875rem",
        "size-icon-xl": "0.9375rem",
        "size-icon-xs": "0.6875rem",
        "size-icon-xxl": "1.0625rem",
        "size-icon-xxs": "0.6875rem",
        "size-icon-xxxl": "1.1875rem",
        "size-icon-xxxs": "0.6875rem",
        "size-icon-xxxxl": "1.375rem",
        "space-base-l": "1.25rem",
        "space-base-m": "0.875rem",
        "space-base-null": "0",
        "space-base-s": "0.4375rem",
        "space-base-size": "1rem",
        "space-base-xl": "1.75rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.25rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "2.5rem",
        "space-base-xxxxl": "3.1875rem",
        "space-base-xxxxxl": "3.625rem"
    }
};

const CompactDensityTokens = {
    name: "compact-density",
    selectors: ["[data-sas-theme='compact-density']"],
    tokens: {
        "font-size-body-text-l": "0.875rem",
        "font-size-body-text-m": "0.75rem",
        "font-size-body-text-s": "0.6875rem",
        "font-size-body-text-xl": "0.9375rem",
        "font-size-body-text-xs": "0.5625rem",
        "font-size-body-text-xxl": "1.0625rem",
        "font-size-body-text-xxs": "0.5rem",
        "font-size-body-text-xxxl": "1.1875rem",
        "font-size-body-text-xxxs": "0.5625rem",
        "font-size-body-text-xxxxl": "1.375rem",
        "font-size-display-text-1": "3.875rem",
        "font-size-display-text-2": "3.0625re",
        "font-size-display-text-3": "2.1875rem",
        "font-size-heading-text-l": "0.875rem",
        "font-size-heading-text-m": "0.75rem",
        "font-size-heading-text-s": "0.6875rem",
        "font-size-heading-text-xl": "0.9375rem",
        "font-size-heading-text-xxl": "1.0625rem",
        "font-size-heading-text-xxxl": "1.1875rem",
        "font-size-heading-text-xxxxl": "1.5rem",
        "font-size-heading-text-xxxxxl": "1.9375rem",
        "font-size-heading-text-xxxxxxl": "3.0625rem",
        "font-space-line-height": "1.4",
        "font-space-line-height-l": "1.6",
        "font-space-line-height-m": "1.5",
        "font-space-line-height-s": "1.4",
        "font-space-line-height-xl": "1.7",
        "font-space-line-height-xxl": "1.8",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "12px",
        "size-border-radius-m": "8px",
        "size-border-radius-s": "4px",
        "size-border-radius-xs": "2px",
        "size-border-radius-xxs": "1px",
        "size-icon-l": "0.875rem",
        "size-icon-m": "0.75rem",
        "size-icon-s": "0.6875rem",
        "size-icon-xl": "0.9375rem",
        "size-icon-xs": "0.6875rem",
        "size-icon-xxl": "1.0625rem",
        "size-icon-xxs": "0.6875rem",
        "size-icon-xxxl": "1.1875rem",
        "size-icon-xxxs": "0.6875rem",
        "size-icon-xxxxl": "1.375rem",
        "space-base-l": "1.25rem",
        "space-base-m": "0.875rem",
        "space-base-null": "0",
        "space-base-s": "0.4375rem",
        "space-base-size": "1rem",
        "space-base-xl": "1.75rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.25rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "2.5rem",
        "space-base-xxxxl": "3.1875rem",
        "space-base-xxxxxl": "3.625rem"
    }
};

const DarkTokens = {
    name: "dark",
    selectors: ["[data-sas-theme='dark']"],
    tokens: {
        "brand-color-alert": "hsl(0, 100%, 40%)",
        "brand-color-alert-00": "hsl(0, 0%, 100%)",
        "brand-color-alert-10": "hsl(0, 100%, 98%)",
        "brand-color-alert-100": "hsl(0, 100%, 64%)",
        "brand-color-alert-1000": "hsl(0, 0%, 0%)",
        "brand-color-alert-20": "hsl(0, 100%, 95%)",
        "brand-color-alert-200": "hsl(0, 100%, 59%)",
        "brand-color-alert-30": "hsl(0, 100%, 92%)",
        "brand-color-alert-300": "hsl(0, 100%, 54%)",
        "brand-color-alert-40": "hsl(0, 100%, 88%)",
        "brand-color-alert-400": "hsl(0, 100%, 46%)",
        "brand-color-alert-450": "hsl(0, 100%, 40%)",
        "brand-color-alert-50": "hsl(0, 100%, 84%)",
        "brand-color-alert-500": "hsl(0, 100%, 36%)",
        "brand-color-alert-550": "hsl(0, 100%, 33%)",
        "brand-color-alert-60": "hsl(0, 100%, 79%)",
        "brand-color-alert-600": "hsl(0, 100%, 30%)",
        "brand-color-alert-650": "hsl(0, 100%, 27%)",
        "brand-color-alert-70": "hsl(0, 100%, 76%)",
        "brand-color-alert-700": "hsl(0, 100%, 22%)",
        "brand-color-alert-750": "hsl(0, 100%, 17%)",
        "brand-color-alert-80": "hsl(0, 100%, 72%)",
        "brand-color-alert-800": "hsl(0, 100%, 12%)",
        "brand-color-alert-850": "hsl(0, 100%, 8%)",
        "brand-color-alert-90": "hsl(0, 100%, 68%)",
        "brand-color-alert-900": "hsl(0, 100%, 3%)",
        "brand-color-blue": "hsl(212, 94%, 42%)",
        "brand-color-blue-00": "hsl(212, 0%, 100%)",
        "brand-color-blue-10": "hsl(212, 94%, 97%)",
        "brand-color-blue-100": "hsl(212, 94%, 62%)",
        "brand-color-blue-1000": "hsl(212, 0%, 0%)",
        "brand-color-blue-20": "hsl(212, 94%, 94%)",
        "brand-color-blue-200": "hsl(212, 94%, 57%)",
        "brand-color-blue-30": "hsl(212, 94%, 90%)",
        "brand-color-blue-300": "hsl(212, 94%, 53%)",
        "brand-color-blue-40": "hsl(212, 94%, 88%)",
        "brand-color-blue-400": "hsl(212, 94%, 47%)",
        "brand-color-blue-450": "hsl(212, 94%, 42%)",
        "brand-color-blue-50": "hsl(212, 94%, 83%)",
        "brand-color-blue-500": "hsl(212, 94%, 36%)",
        "brand-color-blue-550": "hsl(212, 94%, 35%)",
        "brand-color-blue-60": "hsl(212, 94%, 78%)",
        "brand-color-blue-600": "hsl(212, 94%, 31%)",
        "brand-color-blue-650": "hsl(212, 94%, 27%)",
        "brand-color-blue-70": "hsl(212, 94%, 76%)",
        "brand-color-blue-700": "hsl(212, 94%, 23%)",
        "brand-color-blue-750": "hsl(212, 94%, 17%)",
        "brand-color-blue-80": "hsl(212, 94%, 72%)",
        "brand-color-blue-800": "hsl(212, 94%, 12%)",
        "brand-color-blue-850": "hsl(212, 94%, 8%)",
        "brand-color-blue-90": "hsl(212, 94%, 68%)",
        "brand-color-blue-900": "hsl(212, 94%, 3%)",
        "brand-color-cranberry": "hsl(329, 60%, 40%)",
        "brand-color-cranberry-00": "hsl(329,60%,100%)",
        "brand-color-cranberry-10": "hsl(329,60%,98%)",
        "brand-color-cranberry-100": "hsl(329,60%,62%)",
        "brand-color-cranberry-1000": "hsl(329,60%,0%)",
        "brand-color-cranberry-20": "hsl(329,60%,97%)",
        "brand-color-cranberry-200": "hsl(329,60%,57%)",
        "brand-color-cranberry-30": "hsl(329,60%,92%)",
        "brand-color-cranberry-300": "hsl(329,60%,55%)",
        "brand-color-cranberry-40": "hsl(329,60%,88%)",
        "brand-color-cranberry-400": "hsl(329,60%,52%)",
        "brand-color-cranberry-450": "hsl(329,60%,40%)",
        "brand-color-cranberry-50": "hsl(329,60%,84%)",
        "brand-color-cranberry-500": "hsl(329,60%,37%)",
        "brand-color-cranberry-550": "hsl(329,60%,32%)",
        "brand-color-cranberry-60": "hsl(329,60%,78%)",
        "brand-color-cranberry-600": "hsl(329,60%,30%)",
        "brand-color-cranberry-650": "hsl(329,60%,27%)",
        "brand-color-cranberry-70": "hsl(329,60%,76%)",
        "brand-color-cranberry-700": "hsl(329,60%,22%)",
        "brand-color-cranberry-750": "hsl(329,60%,16%)",
        "brand-color-cranberry-80": "hsl(329,60%,72%)",
        "brand-color-cranberry-800": "hsl(329,60%,11%)",
        "brand-color-cranberry-850": "hsl(329,60%,9%)",
        "brand-color-cranberry-90": "hsl(329,60%,68%)",
        "brand-color-cranberry-900": "hsl(329,60%,4%)",
        "brand-color-grey": "hsl(219, 12%, 42%)",
        "brand-color-grey-00": "hsl(219, 0%, 100%)",
        "brand-color-grey-10": "hsl(219, 12%, 98%)",
        "brand-color-grey-100": "hsl(219, 12%, 64%)",
        "brand-color-grey-1000": "hsl(219, 0%, 0%)",
        "brand-color-grey-20": "hsl(219, 12%, 96%)",
        "brand-color-grey-200": "hsl(219, 12%, 59%)",
        "brand-color-grey-30": "hsl(219, 12%, 92%)",
        "brand-color-grey-300": "hsl(219, 12%, 55%)",
        "brand-color-grey-40": "hsl(219, 12%, 88%)",
        "brand-color-grey-400": "hsl(219, 12%, 48%)",
        "brand-color-grey-450": "hsl(219, 12%, 42%)",
        "brand-color-grey-50": "hsl(219, 12%, 84%)",
        "brand-color-grey-500": "hsl(219, 12%, 36%)",
        "brand-color-grey-550": "hsl(219, 12%, 33%)",
        "brand-color-grey-60": "hsl(219, 12%, 79%)",
        "brand-color-grey-600": "hsl(219, 12%, 30%)",
        "brand-color-grey-650": "hsl(219, 12%, 27%)",
        "brand-color-grey-70": "hsl(219, 12%, 76%)",
        "brand-color-grey-700": "hsl(219, 12%, 22%)",
        "brand-color-grey-750": "hsl(219, 12%, 17%)",
        "brand-color-grey-80": "hsl(219, 12%, 72%)",
        "brand-color-grey-800": "hsl(219, 12%, 12%)",
        "brand-color-grey-850": "hsl(219, 12%, 8%)",
        "brand-color-grey-90": "hsl(219, 12%, 68%)",
        "brand-color-grey-900": "hsl(219, 12%, 3%)",
        "brand-color-info": "hsl(212, 94%, 42%)",
        "brand-color-info-00": "hsl(212, 0%, 100%)",
        "brand-color-info-10": "hsl(212, 94%, 97%)",
        "brand-color-info-100": "hsl(212, 94%, 62%)",
        "brand-color-info-1000": "hsl(212, 0%, 0%)",
        "brand-color-info-20": "hsl(212, 94%, 94%)",
        "brand-color-info-200": "hsl(212, 94%, 57%)",
        "brand-color-info-30": "hsl(212, 94%, 90%)",
        "brand-color-info-300": "hsl(212, 94%, 53%)",
        "brand-color-info-40": "hsl(212, 94%, 88%)",
        "brand-color-info-400": "hsl(212, 94%, 47%)",
        "brand-color-info-450": "hsl(212, 94%, 42%)",
        "brand-color-info-50": "hsl(212, 94%, 83%)",
        "brand-color-info-500": "hsl(212, 94%, 36%)",
        "brand-color-info-550": "hsl(212, 94%, 35%)",
        "brand-color-info-60": "hsl(212, 94%, 78%)",
        "brand-color-info-600": "hsl(212, 94%, 31%)",
        "brand-color-info-650": "hsl(212, 94%, 27%)",
        "brand-color-info-70": "hsl(212, 94%, 76%)",
        "brand-color-info-700": "hsl(212, 94%, 23%)",
        "brand-color-info-750": "hsl(212, 94%, 17%)",
        "brand-color-info-80": "hsl(212, 94%, 72%)",
        "brand-color-info-800": "hsl(212, 94%, 12%)",
        "brand-color-info-850": "hsl(212, 94%, 8%)",
        "brand-color-info-90": "hsl(212, 94%, 68%)",
        "brand-color-info-900": "hsl(212, 94%, 3%)",
        "brand-color-success": "hsl(123, 46%, 43%)",
        "brand-color-success-00": "hsl(123, 0%, 100%)",
        "brand-color-success-10": "hsl(123, 46%, 98%)",
        "brand-color-success-100": "hsl(123, 46%, 63%)",
        "brand-color-success-1000": "hsl(123, 0%, 0%)",
        "brand-color-success-20": "hsl(123, 46%, 95%)",
        "brand-color-success-200": "hsl(123, 46%, 58%)",
        "brand-color-success-30": "hsl(123, 46%, 90%)",
        "brand-color-success-300": "hsl(123, 46%, 55%)",
        "brand-color-success-40": "hsl(123, 46%, 87%)",
        "brand-color-success-400": "hsl(123, 46%, 48%)",
        "brand-color-success-450": "hsl(123, 46%, 43%)",
        "brand-color-success-50": "hsl(123, 46%, 82%)",
        "brand-color-success-500": "hsl(123, 46%, 36%)",
        "brand-color-success-550": "hsl(123, 46%, 34%)",
        "brand-color-success-60": "hsl(123, 46%, 78%)",
        "brand-color-success-600": "hsl(123, 46%, 30%)",
        "brand-color-success-650": "hsl(123, 46%, 25%)",
        "brand-color-success-70": "hsl(123, 46%, 75%)",
        "brand-color-success-700": "hsl(123, 46%, 22%)",
        "brand-color-success-750": "hsl(123, 46%, 17%)",
        "brand-color-success-80": "hsl(123, 46%, 70%)",
        "brand-color-success-800": "hsl(123, 46%, 12%)",
        "brand-color-success-850": "hsl(123, 46%, 8%)",
        "brand-color-success-90": "hsl(123, 46%, 66%)",
        "brand-color-success-900": "hsl(123, 46%, 3%)",
        "brand-color-warning": "hsl(43, 89%, 44%)",
        "brand-color-warning-00": "hsl(43, 0%, 100%)",
        "brand-color-warning-10": "hsl(43, 89%, 98%)",
        "brand-color-warning-100": "hsl(43, 89%, 64%)",
        "brand-color-warning-1000": "hsl(43, 0%, 0%)",
        "brand-color-warning-20": "hsl(43, 89%, 95%)",
        "brand-color-warning-200": "hsl(43, 89%, 60%)",
        "brand-color-warning-30": "hsl(43, 89%, 92%)",
        "brand-color-warning-300": "hsl(43, 89%, 56%)",
        "brand-color-warning-40": "hsl(43, 89%, 88%)",
        "brand-color-warning-400": "hsl(43, 89%, 52%)",
        "brand-color-warning-450": "hsl(43, 89%, 44%)",
        "brand-color-warning-50": "hsl(43, 89%, 84%)",
        "brand-color-warning-500": "hsl(43, 89%, 39%)",
        "brand-color-warning-550": "hsl(43, 89%, 35%)",
        "brand-color-warning-60": "hsl(43, 89%, 79%)",
        "brand-color-warning-600": "hsl(43, 89%, 31%)",
        "brand-color-warning-650": "hsl(43, 89%, 27%)",
        "brand-color-warning-70": "hsl(43, 89%, 76%)",
        "brand-color-warning-700": "hsl(43, 89%, 24%)",
        "brand-color-warning-750": "hsl(43, 89%, 17%)",
        "brand-color-warning-80": "hsl(43, 89%, 72%)",
        "brand-color-warning-800": "hsl(43, 89%, 12%)",
        "brand-color-warning-850": "hsl(43, 89%, 8%)",
        "brand-color-warning-90": "hsl(43, 89%, 68%)",
        "brand-color-warning-900": "hsl(43, 89%, 3%)",
        "color-accent-background-1": "hsla(212, 94%, 27%)",
        "color-accent-background-2": "hsla(25, 87%, 27%)",
        "color-accent-background-3": "hsla(169, 40%, 27%)",
        "color-accent-background-4": "hsla(317, 74%, 27%)",
        "color-accent-background-5": "hsla(79, 51%, 27%, 1)",
        "color-accent-background-6": "hsla(267, 72%, 30%, 1)",
        "color-accent-background-7": "hsla(48, 80%, 27%, 1)",
        "color-accent-background-8": "hsla(7, 83%, 22%, 1)",
        "color-accent-border-1": "hsla(212, 94%, 62%)",
        "color-accent-border-2": "hsla(25, 87%, 61%)",
        "color-accent-border-3": "hsla(163, 40%, 64%)",
        "color-accent-border-4": "hsla(317, 74%, 64%)",
        "color-accent-border-5": "hsla(79, 51%, 64%, 1)",
        "color-accent-border-6": "hsla(267, 72%, 64%, 1)",
        "color-accent-border-7": "hsla(48, 80%, 64%, 1)",
        "color-accent-border-8": "hsla(7, 83%, 65%, 1)",
        "color-accent-icon-1": "hsla(212, 94%, 84%)",
        "color-accent-icon-2": "hsla(25, 87%, 84%)",
        "color-accent-icon-3": "hsla(169, 40%, 84%)",
        "color-accent-icon-4": "hsla(317, 74%, 84%)",
        "color-accent-icon-5": "hsla(79, 51%, 84%, 1)",
        "color-accent-icon-6": "hsla(266, 72%, 84%, 1)",
        "color-accent-icon-7": "hsla(48, 80%, 84%, 1)",
        "color-accent-icon-8": "hsla(7, 83%, 84%, 1)",
        "color-accent-spectrum-1-00": "hsla(0, 0%, 100%)",
        "color-accent-spectrum-1-10": "hsla(212, 94%, 98%)",
        "color-accent-spectrum-1-100": "hsla(212, 94%, 62%)",
        "color-accent-spectrum-1-1000": "hsla(0, 0%, 0%)",
        "color-accent-spectrum-1-20": "hsla(212, 94%, 95%)",
        "color-accent-spectrum-1-200": "hsla(212, 94%, 59%)",
        "color-accent-spectrum-1-30": "hsla(212, 94%, 92%)",
        "color-accent-spectrum-1-300": "hsla(212, 94%, 54%)",
        "color-accent-spectrum-1-40": "hsla(212, 94%, 88%)",
        "color-accent-spectrum-1-400": "hsla(212, 94%, 46%)",
        "color-accent-spectrum-1-450": "hsla(212, 94%, 40%)",
        "color-accent-spectrum-1-50": "hsla(212, 94%, 84%)",
        "color-accent-spectrum-1-500": "hsla(212, 94%, 36%)",
        "color-accent-spectrum-1-550": "hsla(212, 94%, 33%)",
        "color-accent-spectrum-1-60": "hsla(212, 94%, 79%)",
        "color-accent-spectrum-1-600": "hsla(212, 94%, 30%)",
        "color-accent-spectrum-1-650": "hsla(212, 94%, 27%)",
        "color-accent-spectrum-1-70": "hsla(212, 94%, 76%)",
        "color-accent-spectrum-1-700": "hsla(212, 94%, 22%)",
        "color-accent-spectrum-1-750": "hsla(212, 94%, 17%)",
        "color-accent-spectrum-1-80": "hsla(212, 94%, 72%)",
        "color-accent-spectrum-1-800": "hsla(212, 94%, 12%)",
        "color-accent-spectrum-1-850": "hsla(212, 94%, 8%)",
        "color-accent-spectrum-1-90": "hsla(212, 94%, 68%)",
        "color-accent-spectrum-1-900": "hsla(212, 94%, 3%)",
        "color-accent-spectrum-2-00": "hsla(0, 0%, 100%)",
        "color-accent-spectrum-2-10": "hsla(25, 87%, 98%)",
        "color-accent-spectrum-2-100": "hsla(25, 87%, 61%)",
        "color-accent-spectrum-2-1000": "hsla(0, 0%, 0%)",
        "color-accent-spectrum-2-20": "hsla(25, 87%, 95%)",
        "color-accent-spectrum-2-200": "hsla(25, 87%, 59%)",
        "color-accent-spectrum-2-30": "hsla(25, 87%, 92%)",
        "color-accent-spectrum-2-300": "hsla(25, 87%, 54%)",
        "color-accent-spectrum-2-40": "hsla(25, 87%, 88%)",
        "color-accent-spectrum-2-400": "hsla(25, 87%, 46%)",
        "color-accent-spectrum-2-450": "hsla(25, 87%, 40%)",
        "color-accent-spectrum-2-50": "hsla(25, 87%, 84%)",
        "color-accent-spectrum-2-500": "hsla(25, 87%, 36%)",
        "color-accent-spectrum-2-550": "hsla(25, 87%, 33%)",
        "color-accent-spectrum-2-60": "hsla(25, 87%, 79%)",
        "color-accent-spectrum-2-600": "hsla(25, 87%, 30%)",
        "color-accent-spectrum-2-650": "hsla(25, 87%, 27%)",
        "color-accent-spectrum-2-70": "hsla(25, 87%, 76%)",
        "color-accent-spectrum-2-700": "hsla(25, 87%, 22%)",
        "color-accent-spectrum-2-750": "hsla(25, 87%, 17%)",
        "color-accent-spectrum-2-80": "hsla(25, 87%, 72%)",
        "color-accent-spectrum-2-800": "hsla(25, 87%, 12%)",
        "color-accent-spectrum-2-850": "hsla(25, 87%, 8%)",
        "color-accent-spectrum-2-90": "hsla(25, 87%, 68%)",
        "color-accent-spectrum-2-900": "hsla(25, 87%, 3%)",
        "color-accent-spectrum-3-00": "hsla(0, 0%, 100%)",
        "color-accent-spectrum-3-10": "hsla(169, 40%, 98%)",
        "color-accent-spectrum-3-100": "hsla(163, 40%, 64%)",
        "color-accent-spectrum-3-1000": "hsla(0, 0%, 0%)",
        "color-accent-spectrum-3-20": "hsla(169, 40%, 95%)",
        "color-accent-spectrum-3-200": "hsla(169, 40%, 59%)",
        "color-accent-spectrum-3-30": "hsla(169, 40%, 92%)",
        "color-accent-spectrum-3-300": "hsla(169, 40%, 52%)",
        "color-accent-spectrum-3-40": "hsla(169, 40%, 88%)",
        "color-accent-spectrum-3-400": "hsla(169, 40%, 46%)",
        "color-accent-spectrum-3-450": "hsla(169, 40%, 40%)",
        "color-accent-spectrum-3-50": "hsla(169, 40%, 84%)",
        "color-accent-spectrum-3-500": "hsla(169, 40%, 36%)",
        "color-accent-spectrum-3-550": "hsla(169, 40%, 33%)",
        "color-accent-spectrum-3-60": "hsla(169, 40%, 79%)",
        "color-accent-spectrum-3-600": "hsla(169, 40%, 30%)",
        "color-accent-spectrum-3-650": "hsla(169, 40%, 27%)",
        "color-accent-spectrum-3-70": "hsla(169, 40%, 76%)",
        "color-accent-spectrum-3-700": "hsla(169, 40%, 22%)",
        "color-accent-spectrum-3-750": "hsla(169, 40%, 17%)",
        "color-accent-spectrum-3-80": "hsla(169, 40%, 72%)",
        "color-accent-spectrum-3-800": "hsla(169, 40%, 12%)",
        "color-accent-spectrum-3-850": "hsla(169, 40%, 8%)",
        "color-accent-spectrum-3-90": "hsla(169, 40%, 68%)",
        "color-accent-spectrum-3-900": "hsla(169, 40%, 3%)",
        "color-accent-spectrum-4-00": "hsla(0, 0%, 100%)",
        "color-accent-spectrum-4-10": "hsla(317, 74%, 98%)",
        "color-accent-spectrum-4-100": "hsla(317, 74%, 64%)",
        "color-accent-spectrum-4-1000": "hsla(0, 0%, 0%)",
        "color-accent-spectrum-4-20": "hsla(317, 74%, 95%)",
        "color-accent-spectrum-4-200": "hsla(317, 74%, 59%)",
        "color-accent-spectrum-4-30": "hsla(317, 74%, 92%)",
        "color-accent-spectrum-4-300": "hsla(317, 74%, 54%)",
        "color-accent-spectrum-4-40": "hsla(317, 74%, 88%)",
        "color-accent-spectrum-4-400": "hsla(317, 74%, 46%)",
        "color-accent-spectrum-4-450": "hsla(317, 74%, 40%)",
        "color-accent-spectrum-4-50": "hsla(317, 74%, 84%)",
        "color-accent-spectrum-4-500": "hsla(317, 74%, 36%)",
        "color-accent-spectrum-4-550": "hsla(317, 74%, 33%)",
        "color-accent-spectrum-4-60": "hsla(317, 74%, 79%)",
        "color-accent-spectrum-4-600": "hsla(317, 74%, 30%)",
        "color-accent-spectrum-4-650": "hsla(317, 74%, 27%)",
        "color-accent-spectrum-4-70": "hsla(317, 74%, 76%)",
        "color-accent-spectrum-4-700": "hsla(317, 74%, 22%)",
        "color-accent-spectrum-4-750": "hsla(317, 74%, 17%)",
        "color-accent-spectrum-4-80": "hsla(317, 74%, 71%)",
        "color-accent-spectrum-4-800": "hsla(317, 74%, 12%)",
        "color-accent-spectrum-4-850": "hsla(317, 74%, 8%)",
        "color-accent-spectrum-4-90": "hsla(317, 74%, 68%)",
        "color-accent-spectrum-4-900": "hsla(317, 74%, 3%)",
        "color-accent-spectrum-5-00": "hsla(0, 0%, 100%, 1)",
        "color-accent-spectrum-5-10": "hsla(79, 51%, 98%, 1)",
        "color-accent-spectrum-5-100": "hsla(79, 51%, 64%, 1)",
        "color-accent-spectrum-5-1000": "hsla(0, 0%, 0%, 1)",
        "color-accent-spectrum-5-20": "hsla(79, 51%, 95%, 1)",
        "color-accent-spectrum-5-200": "hsla(79, 51%, 59%, 1)",
        "color-accent-spectrum-5-30": "hsla(79, 51%, 92%, 1)",
        "color-accent-spectrum-5-300": "hsla(79, 51%, 50%, 1)",
        "color-accent-spectrum-5-40": "hsla(79, 51%, 88%, 1)",
        "color-accent-spectrum-5-400": "hsla(79, 51%, 46%, 1)",
        "color-accent-spectrum-5-450": "hsla(79, 51%, 40%, 1)",
        "color-accent-spectrum-5-50": "hsla(79, 51%, 84%, 1)",
        "color-accent-spectrum-5-500": "hsla(79, 51%, 36%, 1)",
        "color-accent-spectrum-5-550": "hsla(79, 51%, 33%, 1)",
        "color-accent-spectrum-5-60": "hsla(79, 51%, 79%, 1)",
        "color-accent-spectrum-5-600": "hsla(79, 51%, 30%, 1)",
        "color-accent-spectrum-5-650": "hsla(79, 51%, 27%, 1)",
        "color-accent-spectrum-5-70": "hsla(79, 51%, 76%, 1)",
        "color-accent-spectrum-5-700": "hsla(79, 51%, 22%, 1)",
        "color-accent-spectrum-5-750": "hsla(79, 51%, 17%, 1)",
        "color-accent-spectrum-5-80": "hsla(79, 51%, 72%, 1)",
        "color-accent-spectrum-5-800": "hsla(79, 51%, 12%, 1)",
        "color-accent-spectrum-5-850": "hsla(79, 51%, 8%, 1)",
        "color-accent-spectrum-5-90": "hsla(79, 51%, 68%, 1)",
        "color-accent-spectrum-5-900": "hsla(79, 51%, 3%, 1)",
        "color-accent-spectrum-6-00": "hsla(0, 0%, 100%, 1)",
        "color-accent-spectrum-6-10": "hsla(266, 72%, 98%, 1)",
        "color-accent-spectrum-6-100": "hsla(267, 72%, 64%, 1)",
        "color-accent-spectrum-6-1000": "hsla(0, 0%, 0%, 1)",
        "color-accent-spectrum-6-20": "hsla(266, 72%, 95%, 1)",
        "color-accent-spectrum-6-200": "hsla(267, 72%, 59%, 1)",
        "color-accent-spectrum-6-30": "hsla(267, 72%, 92%, 1)",
        "color-accent-spectrum-6-300": "hsla(267, 72%, 54%, 1)",
        "color-accent-spectrum-6-40": "hsla(267, 72%, 88%, 1)",
        "color-accent-spectrum-6-400": "hsla(267, 72%, 46%, 1)",
        "color-accent-spectrum-6-450": "hsla(267, 72%, 40%, 1)",
        "color-accent-spectrum-6-50": "hsla(266, 72%, 84%, 1)",
        "color-accent-spectrum-6-500": "hsla(267, 72%, 36%, 1)",
        "color-accent-spectrum-6-550": "hsla(267, 72%, 33%, 1)",
        "color-accent-spectrum-6-60": "hsla(267, 72%, 79%, 1)",
        "color-accent-spectrum-6-600": "hsla(267, 72%, 30%, 1)",
        "color-accent-spectrum-6-650": "hsla(267, 72%, 27%, 1)",
        "color-accent-spectrum-6-70": "hsla(267, 72%, 76%, 1)",
        "color-accent-spectrum-6-700": "hsla(266, 72%, 22%, 1)",
        "color-accent-spectrum-6-750": "hsla(267, 72%, 17%, 1)",
        "color-accent-spectrum-6-80": "hsla(267, 72%, 72%, 1)",
        "color-accent-spectrum-6-800": "hsla(267, 72%, 12%, 1)",
        "color-accent-spectrum-6-850": "hsla(266, 72%, 8%, 1)",
        "color-accent-spectrum-6-90": "hsla(267, 72%, 67%, 1)",
        "color-accent-spectrum-6-900": "hsla(267, 72%, 3%, 1)",
        "color-accent-spectrum-7-00": "hsla(0, 0%, 100%, 1)",
        "color-accent-spectrum-7-10": "hsla(48, 80%, 98%, 1)",
        "color-accent-spectrum-7-100": "hsla(48, 80%, 64%, 1)",
        "color-accent-spectrum-7-1000": "hsla(0, 0%, 0%, 1)",
        "color-accent-spectrum-7-20": "hsla(48, 80%, 95%, 1)",
        "color-accent-spectrum-7-200": "hsla(48, 80%, 59%, 1)",
        "color-accent-spectrum-7-30": "hsla(48, 80%, 92%, 1)",
        "color-accent-spectrum-7-300": "hsla(48, 80%, 54%, 1)",
        "color-accent-spectrum-7-40": "hsla(48, 80%, 88%, 1)",
        "color-accent-spectrum-7-400": "hsla(48, 80%, 48%, 1)",
        "color-accent-spectrum-7-450": "hsla(48, 80%, 40%, 1)",
        "color-accent-spectrum-7-50": "hsla(48, 80%, 84%, 1)",
        "color-accent-spectrum-7-500": "hsla(48, 80%, 36%, 1)",
        "color-accent-spectrum-7-550": "hsla(48, 80%, 33%, 1)",
        "color-accent-spectrum-7-60": "hsla(48, 80%, 79%, 1)",
        "color-accent-spectrum-7-600": "hsla(48, 80%, 30%, 1)",
        "color-accent-spectrum-7-650": "hsla(48, 80%, 27%, 1)",
        "color-accent-spectrum-7-70": "hsla(48, 80%, 76%, 1)",
        "color-accent-spectrum-7-700": "hsla(48, 80%, 22%, 1)",
        "color-accent-spectrum-7-750": "hsla(48, 80%, 17%, 1)",
        "color-accent-spectrum-7-80": "hsla(48, 80%, 72%, 1)",
        "color-accent-spectrum-7-800": "hsla(48, 80%, 12%, 1)",
        "color-accent-spectrum-7-850": "hsla(48, 80%, 8%, 1)",
        "color-accent-spectrum-7-90": "hsla(48, 80%, 68%, 1)",
        "color-accent-spectrum-7-900": "hsla(48, 80%, 3%, 1)",
        "color-accent-spectrum-8-00": "hsla(0, 0%, 100%, 1)",
        "color-accent-spectrum-8-10": "hsla(7, 83%, 98%, 1)",
        "color-accent-spectrum-8-100": "hsla(7, 83%, 65%, 1)",
        "color-accent-spectrum-8-1000": "hsla(0, 0%, 0%, 1)",
        "color-accent-spectrum-8-20": "hsla(7, 83%, 95%, 1)",
        "color-accent-spectrum-8-200": "hsla(7, 83%, 59%, 1)",
        "color-accent-spectrum-8-30": "hsla(7, 83%, 92%, 1)",
        "color-accent-spectrum-8-300": "hsla(7, 83%, 54%, 1)",
        "color-accent-spectrum-8-40": "hsla(7, 83%, 88%, 1)",
        "color-accent-spectrum-8-400": "hsla(7, 83%, 46%, 1)",
        "color-accent-spectrum-8-450": "hsla(7, 83%, 40%, 1)",
        "color-accent-spectrum-8-50": "hsla(7, 83%, 84%, 1)",
        "color-accent-spectrum-8-500": "hsla(7, 83%, 36%, 1)",
        "color-accent-spectrum-8-550": "hsla(7, 83%, 33%, 1)",
        "color-accent-spectrum-8-60": "hsla(7, 83%, 79%, 1)",
        "color-accent-spectrum-8-600": "hsla(7, 83%, 30%, 1)",
        "color-accent-spectrum-8-650": "hsla(7, 83%, 27%, 1)",
        "color-accent-spectrum-8-70": "hsla(7, 83%, 76%, 1)",
        "color-accent-spectrum-8-700": "hsla(7, 83%, 22%, 1)",
        "color-accent-spectrum-8-750": "hsla(7, 83%, 17%, 1)",
        "color-accent-spectrum-8-80": "hsla(7, 83%, 72%, 1)",
        "color-accent-spectrum-8-800": "hsla(7, 83%, 12%, 1)",
        "color-accent-spectrum-8-850": "hsla(7, 83%, 8%, 1)",
        "color-accent-spectrum-8-90": "hsla(7, 83%, 68%, 1)",
        "color-accent-spectrum-8-900": "hsla(7, 83%, 3%, 1)",
        "color-accent-text-1": "hsla(212, 94%, 84%)",
        "color-accent-text-2": "hsla(25, 87%, 84%)",
        "color-accent-text-3": "hsla(169, 40%, 84%)",
        "color-accent-text-4": "hsla(317, 74%, 84%)",
        "color-accent-text-5": "hsla(79, 51%, 84%, 1)",
        "color-accent-text-6": "hsla(266, 72%, 84%, 1)",
        "color-accent-text-7": "hsla(48, 80%, 84%, 1)",
        "color-accent-text-8": "hsla(7, 83%, 84%, 1)",
        "color-action-background-control-alert": "hsl(0, 100%, 8%)",
        "color-action-background-control-disabled": "hsl(219, 12%, 17%)",
        "color-action-background-control-hover": "hsl(219, 12%, 8%)",
        "color-action-background-control-normal": "hsl(219, 12%, 12%)",
        "color-action-background-control-primary": "hsl(212, 94%, 31%)",
        "color-action-background-control-read-only": "hsl(219, 12%, 17%)",
        "color-action-background-control-selected": "hsl(212, 94%, 17%)",
        "color-action-background-control-warning": "hsl(43, 89%, 8%)",
        "color-action-background-emphasis-active": "hsl(219, 12%, 30%)",
        "color-action-background-emphasis-disabled": "hsl(219, 12%, 30%)",
        "color-action-background-emphasis-hover": "hsl(212, 94%, 31%)",
        "color-action-background-emphasis-normal": "hsl(212, 94%, 42%)",
        "color-action-background-emphasis-selected": "hsl(212, 94%, 31%)",
        "color-action-background-emphasis-visited": "hsl(212, 94%, 42%)",
        "color-action-background-focus": "hsl(205, 97%, 63%)",
        "color-action-background-focus-inverse": "hsl(0, 0%, 0%)",
        "color-action-background-on-off-disabled": "hsl(219, 12%, 17%)",
        "color-action-background-on-off-hover": "hsl(219, 12%, 8%)",
        "color-action-background-on-off-normal": "hsl(219, 12%, 17%)",
        "color-action-background-on-off-read-only": "hsl(219, 12%, 12%)",
        "color-action-background-on-off-selected": "hsl(212, 94%, 53%)",
        "color-action-background-on-off-selected-disabled": "hsl(219, 12%, 22%)",
        "color-action-background-standard-active": "hsl(212, 94%, 23%)",
        "color-action-background-standard-disabled": "hsl(219, 12%, 17%)",
        "color-action-background-standard-hover": "hsl(219, 12%, 8%)",
        "color-action-background-standard-normal": "hsl(219, 12%, 12%)",
        "color-action-background-standard-selected": "hsl(212, 94%, 23%)",
        "color-action-background-standard-selected-disabled": "hsl(212, 94%, 12%)",
        "color-action-background-standard-selected-inactive": "hsl(219, 12%, 30%)",
        "color-action-background-standard-visited": "hsl(219, 12%, 12%)",
        "color-action-background-subtle-disabled": "hsla(0, 0%, 0%, 0)",
        "color-action-background-subtle-hover": "hsl(219, 12%, 8%)",
        "color-action-background-subtle-normal": "hsla(0, 0%, 0%, 0)",
        "color-action-background-subtle-selected": "hsl(212, 94%, 23%)",
        "color-action-background-subtle-selected-disabled": "hsl(212, 94%, 12%)",
        "color-action-background-subtle-selected-inactive": "hsl(219, 12%, 30%)",
        "color-action-border-bottom-control-alert": "hsl(0, 100%, 64%)",
        "color-action-border-bottom-control-hover": "hsl(219, 12%, 48%)",
        "color-action-border-bottom-control-normal": "hsl(219, 12%, 48%)",
        "color-action-border-bottom-control-selected": "hsl(212, 94%, 62%)",
        "color-action-border-bottom-control-warning": "hsl(43, 89%, 64%)",
        "color-action-border-control-alert": "hsl(0, 100%, 8%)",
        "color-action-border-control-disabled": "hsl(219, 12%, 17%)",
        "color-action-border-control-hover": "hsl(219, 12%, 8%)",
        "color-action-border-control-normal": "hsl(219, 12%, 48%)",
        "color-action-border-control-read-only": "hsl(219, 12%, 17%)",
        "color-action-border-control-selected": "hsl(212, 94%, 17%)",
        "color-action-border-control-warning": "hsl(43, 89%, 8%)",
        "color-action-border-emphasis-active": "hsl(212, 94%, 31%)",
        "color-action-border-emphasis-disabled": "hsl(219, 12%, 17%)",
        "color-action-border-emphasis-hover": "hsl(212, 94%, 31%)",
        "color-action-border-emphasis-normal": "hsl(212, 94%, 42%)",
        "color-action-border-emphasis-selected": "hsl(212, 94%, 31%)",
        "color-action-border-emphasis-visited": "hsl(212, 94%, 42%)",
        "color-action-border-focus": "hsl(212, 94%, 62%)",
        "color-action-border-focus-inverse": "hsl(212, 0%, 100%)",
        "color-action-border-on-off-disabled": "hsl(219, 12%, 30%)",
        "color-action-border-on-off-hover": "hsl(219, 12%, 48%)",
        "color-action-border-on-off-normal": "hsl(219, 12%, 48%)",
        "color-action-border-on-off-read-only": "hsl(219, 12%, 48%)",
        "color-action-border-on-off-selected": "hsl(212, 94%, 53%)",
        "color-action-border-on-off-selected-disabled": "hsl(219, 12%, 22%)",
        "color-action-border-standard-active": "hsl(212, 94%, 57%)",
        "color-action-border-standard-disabled": "hsl(219, 12%, 17%)",
        "color-action-border-standard-hover": "hsl(219, 12%, 30%)",
        "color-action-border-standard-normal": "hsl(219, 12%, 22%)",
        "color-action-border-standard-selected": "hsl(212, 94%, 57%)",
        "color-action-border-standard-selected-disabled": "hsl(212, 94%, 12%)",
        "color-action-border-standard-selected-inactive": "hsl(219, 12%, 48%)",
        "color-action-border-standard-visited": "hsl(219, 12%, 22%)",
        "color-action-border-subtle-disabled": "hsla(0, 0%, 0%, 0)",
        "color-action-border-subtle-hover": "hsl(219, 12%, 8%)",
        "color-action-border-subtle-normal": "hsla(0, 0%, 0%, 0)",
        "color-action-border-subtle-selected": "hsl(212, 94%, 23%)",
        "color-action-border-subtle-selected-disabled": "hsl(212, 94%, 12%)",
        "color-action-border-subtle-selected-inactive": "hsl(219, 12%, 30%)",
        "color-action-focus": "hsl(212, 94%, 62%)",
        "color-action-icon-control-alert": "hsl(0, 0%, 100%)",
        "color-action-icon-control-disabled": "hsl(219, 12%, 30%)",
        "color-action-icon-control-hover": "hsl(219, 12%, 88%)",
        "color-action-icon-control-normal": "hsl(219, 12%, 88%)",
        "color-action-icon-control-read-only": "hsl(219, 12%, 88%)",
        "color-action-icon-control-selected": "hsl(212, 0%, 100%)",
        "color-action-icon-control-warning": "hsl(43, 0%, 100%)",
        "color-action-icon-emphasis-active": "hsl(212, 0%, 100%)",
        "color-action-icon-emphasis-disabled": "hsl(219, 12%, 30%)",
        "color-action-icon-emphasis-hover": "hsl(212, 94%, 88%)",
        "color-action-icon-emphasis-normal": "hsl(212, 0%, 100%)",
        "color-action-icon-emphasis-selected": "hsl(212, 0%, 100%)",
        "color-action-icon-emphasis-visited": "hsl(212, 0%, 100%)",
        "color-action-icon-on-off-disabled": "hsl(219, 12%, 30%)",
        "color-action-icon-on-off-hover": "hsl(219, 12%, 88%)",
        "color-action-icon-on-off-normal": "hsl(219, 12%, 88%)",
        "color-action-icon-on-off-read-only": "hsl(219, 12%, 88%)",
        "color-action-icon-on-off-selected": "hsl(212, 0%, 100%)",
        "color-action-icon-on-off-selected-disabled": "hsl(219, 12%, 30%)",
        "color-action-icon-standard-active": "hsl(212, 0%, 100%)",
        "color-action-icon-standard-disabled": "hsl(219, 12%, 30%)",
        "color-action-icon-standard-hover": "hsl(219, 12%, 88%)",
        "color-action-icon-standard-normal": "hsl(219, 12%, 88%)",
        "color-action-icon-standard-selected": "hsl(212, 0%, 100%)",
        "color-action-icon-standard-selected-disabled": "hsl(212, 94%, 31%)",
        "color-action-icon-standard-selected-inactive": "hsl(219, 0%, 100%)",
        "color-action-icon-standard-visited": "hsl(219, 12%, 88%)",
        "color-action-icon-subtle-disabled": "hsl(219, 12%, 30%)",
        "color-action-icon-subtle-hover": "hsl(219, 12%, 88%)",
        "color-action-icon-subtle-normal": "hsl(219, 12%, 88%)",
        "color-action-icon-subtle-selected": "hsl(212, 0%, 100%)",
        "color-action-icon-subtle-selected-disabled": "hsl(212, 94%, 31%)",
        "color-action-icon-subtle-selected-inactive": "hsl(219, 0%, 100%)",
        "color-action-link-active": "hsl(219, 12%, 88%)",
        "color-action-link-hover": "hsl(212, 94%, 83%)",
        "color-action-link-normal": "hsl(212, 94%, 83%)",
        "color-action-link-visited": "hsl(212, 94%, 83%)",
        "color-action-text-control-alert": "hsl(0, 0%, 100%)",
        "color-action-text-control-disabled": "hsl(219, 12%, 30%)",
        "color-action-text-control-hover": "hsl(219, 12%, 88%)",
        "color-action-text-control-normal": "hsl(219, 12%, 88%)",
        "color-action-text-control-placeholder": "hsl(219, 12%, 64%)",
        "color-action-text-control-read-only": "hsl(219, 12%, 88%)",
        "color-action-text-control-selected": "hsl(212, 0%, 100%)",
        "color-action-text-control-warning": "hsl(43, 0%, 100%)",
        "color-action-text-emphasis-active": "hsl(212, 0%, 100%)",
        "color-action-text-emphasis-disabled": "hsl(219, 12%, 17%)",
        "color-action-text-emphasis-hover": "hsl(212, 94%, 88%)",
        "color-action-text-emphasis-normal": "hsl(212, 0%, 100%)",
        "color-action-text-emphasis-selected": "hsl(212, 0%, 100%)",
        "color-action-text-emphasis-visited": "hsl(212, 0%, 100%)",
        "color-action-text-on-off-disabled": "hsl(219, 12%, 30%)",
        "color-action-text-on-off-hover": "hsl(219, 12%, 88%)",
        "color-action-text-on-off-normal": "hsl(219, 12%, 88%)",
        "color-action-text-on-off-read-only": "hsl(219, 12%, 88%)",
        "color-action-text-on-off-selected": "hsl(212, 0%, 100%)",
        "color-action-text-on-off-selected-disabled": "hsl(219, 12%, 30%)",
        "color-action-text-standard-active": "hsl(212, 0%, 100%)",
        "color-action-text-standard-disabled": "hsl(219, 12%, 30%)",
        "color-action-text-standard-hover": "hsl(219, 12%, 88%)",
        "color-action-text-standard-normal": "hsl(219, 12%, 88%)",
        "color-action-text-standard-selected": "hsl(212, 0%, 100%)",
        "color-action-text-standard-selected-disabled": "hsl(212, 94%, 31%)",
        "color-action-text-standard-selected-inactive": "hsl(219, 0%, 100%)",
        "color-action-text-standard-visited": "hsl(219, 12%, 88%)",
        "color-action-text-subtle-disabled": "hsl(219, 12%, 30%)",
        "color-action-text-subtle-hover": "hsl(219, 12%, 88%)",
        "color-action-text-subtle-normal": "hsl(219, 12%, 88%)",
        "color-action-text-subtle-selected": "hsl(212, 0%, 100%)",
        "color-action-text-subtle-selected-disabled": "hsl(212, 94%, 31%)",
        "color-action-text-subtle-selected-inactive": "hsl(219, 0%, 100%)",
        "color-alert-00": "hsl(0, 0%, 100%)",
        "color-alert-10": "hsl(0, 100%, 98%)",
        "color-alert-100": "hsl(0, 100%, 64%)",
        "color-alert-1000": "hsl(0, 0%, 0%)",
        "color-alert-20": "hsl(0, 100%, 95%)",
        "color-alert-200": "hsl(0, 100%, 59%)",
        "color-alert-30": "hsl(0, 100%, 92%)",
        "color-alert-300": "hsl(0, 100%, 54%)",
        "color-alert-40": "hsl(0, 100%, 88%)",
        "color-alert-400": "hsl(0, 100%, 46%)",
        "color-alert-450": "hsl(0, 100%, 40%)",
        "color-alert-50": "hsl(0, 100%, 84%)",
        "color-alert-500": "hsl(0, 100%, 36%)",
        "color-alert-550": "hsl(0, 100%, 33%)",
        "color-alert-60": "hsl(0, 100%, 79%)",
        "color-alert-600": "hsl(0, 100%, 30%)",
        "color-alert-650": "hsl(0, 100%, 27%)",
        "color-alert-70": "hsl(0, 100%, 76%)",
        "color-alert-700": "hsl(0, 100%, 22%)",
        "color-alert-750": "hsl(0, 100%, 17%)",
        "color-alert-80": "hsl(0, 100%, 72%)",
        "color-alert-800": "hsl(0, 100%, 12%)",
        "color-alert-850": "hsl(0, 100%, 8%)",
        "color-alert-90": "hsl(0, 100%, 68%)",
        "color-alert-900": "hsl(0, 100%, 3%)",
        "color-body-icon": "hsl(219, 12%, 88%)",
        "color-body-text": "hsl(219, 12%, 88%)",
        "color-container-background-0": "hsl(219, 12%, 17%)",
        "color-container-background-1": "hsl(219, 12%, 12%)",
        "color-container-background-2": "hsl(219, 12%, 8%)",
        "color-container-background-3": "hsl(212, 94%, 36%)",
        "color-container-background-4": "hsl(219, 12%, 30%)",
        "color-container-border-4": "hsl(219, 12%, 42%)",
        "color-dataviz-graph-alt1": "#3C89E0",
        "color-dataviz-graph-alt2": "#D97D3D",
        "color-dataviz-graph-alt3": "#489C8C",
        "color-dataviz-graph-alt4": "#D473B8",
        "color-dataviz-graph-alt5": "#82A637",
        "color-dataviz-graph-alt6": "#9364CF",
        "color-dataviz-graph-alt7": "#C29F16",
        "color-dataviz-graph-alt8": "#D66354",
        "color-dataviz-graph1": "#4398F9",
        "color-dataviz-graph2": "#F28D44",
        "color-dataviz-graph3": "#54B6A4",
        "color-dataviz-graph4": "#EC80CE",
        "color-dataviz-graph5": "#97C03F",
        "color-dataviz-graph6": "#A570E8",
        "color-dataviz-graph7": "#DCB519",
        "color-dataviz-graph8": "#F06F5E",
        "color-dataviz-kpi-alt1": "#A33636",
        "color-dataviz-kpi-alt3": "#B5B041",
        "color-dataviz-kpi-alt5": "#2E8059",
        "color-dataviz-kpi1": "#BD3F3F",
        "color-dataviz-kpi3": "#CFCA4A",
        "color-dataviz-kpi5": "#389A6B",
        "color-display-icon": "hsl(219, 12%, 88%)",
        "color-display-text": "hsl(219, 12%, 88%)",
        "color-heading-icon": "hsl(219, 12%, 88%)",
        "color-heading-text": "hsl(219, 12%, 88%)",
        "color-highlight-text": "hsl(212, 94%, 62%)",
        "color-highlight-text-inverse": "hsl(212, 0%, 0%)",
        "color-icon-neutral": "hsl(219, 12%, 88%)",
        "color-icon-primary": "hsl(212, 94%, 62%)",
        "color-icon-secondary": "hsl(329,60%,30%)",
        "color-info-00": "hsl(212, 0%, 100%)",
        "color-info-10": "hsl(212, 94%, 97%)",
        "color-info-100": "hsl(212, 94%, 62%)",
        "color-info-1000": "hsl(212, 0%, 0%)",
        "color-info-20": "hsl(212, 94%, 94%)",
        "color-info-200": "hsl(212, 94%, 57%)",
        "color-info-30": "hsl(212, 94%, 90%)",
        "color-info-300": "hsl(212, 94%, 53%)",
        "color-info-40": "hsl(212, 94%, 88%)",
        "color-info-400": "hsl(212, 94%, 47%)",
        "color-info-450": "hsl(212, 94%, 42%)",
        "color-info-50": "hsl(212, 94%, 83%)",
        "color-info-500": "hsl(212, 94%, 36%)",
        "color-info-550": "hsl(212, 94%, 35%)",
        "color-info-60": "hsl(212, 94%, 78%)",
        "color-info-600": "hsl(212, 94%, 31%)",
        "color-info-650": "hsl(212, 94%, 27%)",
        "color-info-70": "hsl(212, 94%, 76%)",
        "color-info-700": "hsl(212, 94%, 23%)",
        "color-info-750": "hsl(212, 94%, 17%)",
        "color-info-80": "hsl(212, 94%, 72%)",
        "color-info-800": "hsl(212, 94%, 12%)",
        "color-info-850": "hsl(212, 94%, 8%)",
        "color-info-90": "hsl(212, 94%, 68%)",
        "color-info-900": "hsl(212, 94%, 3%)",
        "color-label-text": "hsl(219, 12%, 59%)",
        "color-neutral": "hsl(219, 12%, 64%)",
        "color-neutral-00": "hsl(219, 0%, 100%)",
        "color-neutral-10": "hsl(219, 12%, 98%)",
        "color-neutral-100": "hsl(219, 12%, 64%)",
        "color-neutral-1000": "hsl(219, 0%, 0%)",
        "color-neutral-20": "hsl(219, 12%, 96%)",
        "color-neutral-200": "hsl(219, 12%, 59%)",
        "color-neutral-30": "hsl(219, 12%, 92%)",
        "color-neutral-300": "hsl(219, 12%, 55%)",
        "color-neutral-40": "hsl(219, 12%, 88%)",
        "color-neutral-400": "hsl(219, 12%, 48%)",
        "color-neutral-450": "hsl(219, 12%, 42%)",
        "color-neutral-50": "hsl(219, 12%, 84%)",
        "color-neutral-500": "hsl(219, 12%, 36%)",
        "color-neutral-550": "hsl(219, 12%, 33%)",
        "color-neutral-60": "hsl(219, 12%, 79%)",
        "color-neutral-600": "hsl(219, 12%, 30%)",
        "color-neutral-650": "hsl(219, 12%, 27%)",
        "color-neutral-70": "hsl(219, 12%, 76%)",
        "color-neutral-700": "hsl(219, 12%, 22%)",
        "color-neutral-750": "hsl(219, 12%, 17%)",
        "color-neutral-80": "hsl(219, 12%, 72%)",
        "color-neutral-800": "hsl(219, 12%, 12%)",
        "color-neutral-850": "hsl(219, 12%, 8%)",
        "color-neutral-90": "hsl(219, 12%, 68%)",
        "color-neutral-900": "hsl(219, 12%, 3%)",
        "color-primary": "hsl(212, 94%, 62%)",
        "color-primary-00": "hsl(212, 0%, 100%)",
        "color-primary-10": "hsl(212, 94%, 97%)",
        "color-primary-100": "hsl(212, 94%, 62%)",
        "color-primary-1000": "hsl(212, 0%, 0%)",
        "color-primary-20": "hsl(212, 94%, 94%)",
        "color-primary-200": "hsl(212, 94%, 57%)",
        "color-primary-30": "hsl(212, 94%, 90%)",
        "color-primary-300": "hsl(212, 94%, 53%)",
        "color-primary-40": "hsl(212, 94%, 88%)",
        "color-primary-400": "hsl(212, 94%, 47%)",
        "color-primary-450": "hsl(212, 94%, 42%)",
        "color-primary-50": "hsl(212, 94%, 83%)",
        "color-primary-500": "hsl(212, 94%, 36%)",
        "color-primary-550": "hsl(212, 94%, 35%)",
        "color-primary-60": "hsl(212, 94%, 78%)",
        "color-primary-600": "hsl(212, 94%, 31%)",
        "color-primary-650": "hsl(212, 94%, 27%)",
        "color-primary-70": "hsl(212, 94%, 76%)",
        "color-primary-700": "hsl(212, 94%, 23%)",
        "color-primary-750": "hsl(212, 94%, 17%)",
        "color-primary-80": "hsl(212, 94%, 72%)",
        "color-primary-800": "hsl(212, 94%, 12%)",
        "color-primary-850": "hsl(212, 94%, 8%)",
        "color-primary-90": "hsl(212, 94%, 68%)",
        "color-primary-900": "hsl(212, 94%, 3%)",
        "color-secondary": "hsl(329,60%,40%)",
        "color-secondary-00": "hsl(329,60%,100%)",
        "color-secondary-10": "hsl(329,60%,98%)",
        "color-secondary-100": "hsl(329,60%,62%)",
        "color-secondary-1000": "hsl(329,60%,0%)",
        "color-secondary-20": "hsl(329,60%,97%)",
        "color-secondary-200": "hsl(329,60%,57%)",
        "color-secondary-30": "hsl(329,60%,92%)",
        "color-secondary-300": "hsl(329,60%,55%)",
        "color-secondary-40": "hsl(329,60%,88%)",
        "color-secondary-400": "hsl(329,60%,52%)",
        "color-secondary-450": "hsl(329,60%,40%)",
        "color-secondary-50": "hsl(329,60%,84%)",
        "color-secondary-500": "hsl(329,60%,37%)",
        "color-secondary-550": "hsl(329,60%,32%)",
        "color-secondary-60": "hsl(329,60%,78%)",
        "color-secondary-600": "hsl(329,60%,30%)",
        "color-secondary-650": "hsl(329,60%,27%)",
        "color-secondary-70": "hsl(329,60%,76%)",
        "color-secondary-700": "hsl(329,60%,22%)",
        "color-secondary-750": "hsl(329,60%,16%)",
        "color-secondary-80": "hsl(329,60%,72%)",
        "color-secondary-800": "hsl(329,60%,11%)",
        "color-secondary-850": "hsl(329,60%,9%)",
        "color-secondary-90": "hsl(329,60%,68%)",
        "color-secondary-900": "hsl(329,60%,4%)",
        "color-status-alert": "hsl(0, 100%, 64%)",
        "color-status-background-alert": "hsl(0, 100%, 8%)",
        "color-status-background-info": "hsl(212, 94%, 8%)",
        "color-status-background-neutral": "hsl(219, 12%, 8%)",
        "color-status-background-success": "hsl(123, 46%, 8%)",
        "color-status-background-warning": "hsl(43, 89%, 8%)",
        "color-status-border-alert": "hsl(0, 100%, 64%)",
        "color-status-border-info": "hsl(212, 94%, 62%)",
        "color-status-border-neutral": "hsl(219, 12%, 64%)",
        "color-status-border-success": "hsl(123, 46%, 63%)",
        "color-status-border-warning": "hsl(43, 89%, 64%)",
        "color-status-icon-alert": "hsl(0, 100%, 72%)",
        "color-status-icon-info": "hsl(212, 94%, 72%)",
        "color-status-icon-neutral": "hsl(219, 12%, 72%)",
        "color-status-icon-success": "hsl(123, 46%, 70%)",
        "color-status-icon-warning": "hsl(43, 89%, 72%)",
        "color-status-info": "hsl(212, 94%, 62%)",
        "color-status-neutral": "hsl(219, 12%, 64%)",
        "color-status-success": "hsl(123, 46%, 63%)",
        "color-status-text-alert": "hsl(0, 100%, 72%)",
        "color-status-text-info": "hsl(212, 94%, 72%)",
        "color-status-text-neutral": "hsl(219, 12%, 72%)",
        "color-status-text-success": "hsl(123, 46%, 70%)",
        "color-status-text-warning": "hsl(43, 89%, 72%)",
        "color-status-warning": "hsl(43, 89%, 64%)",
        "color-success-00": "hsl(123, 0%, 100%)",
        "color-success-10": "hsl(123, 46%, 98%)",
        "color-success-100": "hsl(123, 46%, 63%)",
        "color-success-1000": "hsl(123, 0%, 0%)",
        "color-success-20": "hsl(123, 46%, 95%)",
        "color-success-200": "hsl(123, 46%, 58%)",
        "color-success-30": "hsl(123, 46%, 90%)",
        "color-success-300": "hsl(123, 46%, 55%)",
        "color-success-40": "hsl(123, 46%, 87%)",
        "color-success-400": "hsl(123, 46%, 48%)",
        "color-success-450": "hsl(123, 46%, 43%)",
        "color-success-50": "hsl(123, 46%, 82%)",
        "color-success-500": "hsl(123, 46%, 36%)",
        "color-success-550": "hsl(123, 46%, 34%)",
        "color-success-60": "hsl(123, 46%, 78%)",
        "color-success-600": "hsl(123, 46%, 30%)",
        "color-success-650": "hsl(123, 46%, 25%)",
        "color-success-70": "hsl(123, 46%, 75%)",
        "color-success-700": "hsl(123, 46%, 22%)",
        "color-success-750": "hsl(123, 46%, 17%)",
        "color-success-80": "hsl(123, 46%, 70%)",
        "color-success-800": "hsl(123, 46%, 12%)",
        "color-success-850": "hsl(123, 46%, 8%)",
        "color-success-90": "hsl(123, 46%, 66%)",
        "color-success-900": "hsl(123, 46%, 3%)",
        "color-syntax-text-01": "hsl(219, 0%, 100%)",
        "color-syntax-text-02": "hsl(219, 12%, 88%)",
        "color-syntax-text-03": "hsla(25, 87%, 84%)",
        "color-syntax-text-04": "hsla(7, 83%, 84%, 1)",
        "color-syntax-text-05": "hsla(266, 72%, 84%, 1)",
        "color-syntax-text-06": "hsla(212, 94%, 84%)",
        "color-syntax-text-07": "hsla(317, 74%, 84%)",
        "color-syntax-text-08": "hsla(169, 40%, 84%)",
        "color-syntax-text-09": "hsla(79, 51%, 84%, 1)",
        "color-syntax-text-attribute-name": "hsla(317, 74%, 84%)",
        "color-syntax-text-attribute-value": "hsla(7, 83%, 84%, 1)",
        "color-syntax-text-boolean": "hsla(266, 72%, 84%, 1)",
        "color-syntax-text-character-constant": "hsla(169, 40%, 84%)",
        "color-syntax-text-class-name": "hsla(169, 40%, 84%)",
        "color-syntax-text-comment": "hsla(79, 51%, 84%, 1)",
        "color-syntax-text-control": "hsla(266, 72%, 84%, 1)",
        "color-syntax-text-data": "hsla(25, 87%, 84%)",
        "color-syntax-text-declaration": "hsla(212, 94%, 84%)",
        "color-syntax-text-default": "hsl(219, 0%, 100%)",
        "color-syntax-text-function": "hsla(266, 72%, 84%, 1)",
        "color-syntax-text-identifier": "hsl(219, 0%, 100%)",
        "color-syntax-text-keyword": "hsla(212, 94%, 84%)",
        "color-syntax-text-namespace": "hsla(169, 40%, 84%)",
        "color-syntax-text-normal": "hsl(219, 0%, 100%)",
        "color-syntax-text-numeric-constant": "hsla(169, 40%, 84%)",
        "color-syntax-text-operator": "hsla(317, 74%, 84%)",
        "color-syntax-text-proc-name": "hsla(317, 74%, 84%)",
        "color-syntax-text-property": "hsla(212, 94%, 84%)",
        "color-syntax-text-punctuation": "hsl(219, 12%, 88%)",
        "color-syntax-text-punctuation-brackets": "hsl(219, 12%, 88%)",
        "color-syntax-text-section": "hsla(317, 74%, 84%)",
        "color-syntax-text-separator": "hsl(219, 0%, 100%)",
        "color-syntax-text-source": "hsla(212, 94%, 84%)",
        "color-syntax-text-storage-type": "hsla(212, 94%, 84%)",
        "color-syntax-text-string": "hsla(7, 83%, 84%, 1)",
        "color-syntax-text-tag": "hsla(212, 94%, 84%)",
        "color-syntax-text-variable": "hsla(317, 74%, 84%)",
        "color-tag-background-1": "hsl(212, 94%, 31%)",
        "color-tag-background-2": "hsl(329,60%,30%)",
        "color-tag-background-3": "hsl(219, 12%, 30%)",
        "color-tag-border-1": "hsl(212, 94%, 62%)",
        "color-tag-border-2": "hsl(329,60%,62%)",
        "color-tag-border-3": "hsl(219, 12%, 64%)",
        "color-text-neutral": "hsl(219, 12%, 88%)",
        "color-text-neutral-inverse": "hsl(219, 12%, 12%)",
        "color-text-primary": "hsl(212, 94%, 62%)",
        "color-text-primary-inverse": "hsl(212, 0%, 100%)",
        "color-text-secondary": "hsl(329,60%,30%)",
        "color-thumbnail-fill-1": "hsl(212, 94%, 83%)",
        "color-thumbnail-fill-2": "hsl(212, 94%, 72%)",
        "color-thumbnail-fill-3": "hsl(212, 94%, 57%)",
        "color-thumbnail-fill-4": "hsl(212, 94%, 42%)",
        "color-warning-00": "hsl(43, 0%, 100%)",
        "color-warning-10": "hsl(43, 89%, 98%)",
        "color-warning-100": "hsl(43, 89%, 64%)",
        "color-warning-1000": "hsl(43, 0%, 0%)",
        "color-warning-20": "hsl(43, 89%, 95%)",
        "color-warning-200": "hsl(43, 89%, 60%)",
        "color-warning-30": "hsl(43, 89%, 92%)",
        "color-warning-300": "hsl(43, 89%, 56%)",
        "color-warning-40": "hsl(43, 89%, 88%)",
        "color-warning-400": "hsl(43, 89%, 52%)",
        "color-warning-450": "hsl(43, 89%, 44%)",
        "color-warning-50": "hsl(43, 89%, 84%)",
        "color-warning-500": "hsl(43, 89%, 39%)",
        "color-warning-550": "hsl(43, 89%, 35%)",
        "color-warning-60": "hsl(43, 89%, 79%)",
        "color-warning-600": "hsl(43, 89%, 31%)",
        "color-warning-650": "hsl(43, 89%, 27%)",
        "color-warning-70": "hsl(43, 89%, 76%)",
        "color-warning-700": "hsl(43, 89%, 24%)",
        "color-warning-750": "hsl(43, 89%, 17%)",
        "color-warning-80": "hsl(43, 89%, 72%)",
        "color-warning-800": "hsl(43, 89%, 12%)",
        "color-warning-850": "hsl(43, 89%, 8%)",
        "color-warning-90": "hsl(43, 89%, 68%)",
        "color-warning-900": "hsl(43, 89%, 3%)",
        "color-zero-state-base-fill-1": "hsl(219, 12%, 17%)",
        "color-zero-state-base-fill-2": "hsl(219, 12%, 59%)",
        "color-zero-state-base-fill-3": "hsl(219, 12%, 48%)",
        "color-zero-state-modifier-fill-1": "hsl(219, 12%, 27%)",
        "color-zero-state-modifier-fill-2": "hsl(212, 94%, 62%)",
        "color-zero-state-modifier-fill-3": "hsl(212, 94%, 72%)",
        "color-zero-state-modifier-fill-4": "hsl(219, 12%, 33%)",
        "color-zero-state-modifier-fill-5": "hsl(219, 12%, 72%)",
        "duration-100": "100ms",
        "duration-1000": "1s",
        "duration-200": "200ms",
        "duration-250": "250ms",
        "duration-300": "300ms",
        "duration-400": "400ms",
        "duration-450": "450ms",
        "duration-500": "500ms",
        "duration-700": "700ms",
        "ease-in": "cubic-bezier(0, 0.5, 0.2, 1)",
        "ease-in-out": "cubic-bezier(0.5, 0, 0.2, 1)",
        "ease-out": "cubic-bezier(0.5, 0, 0.8, 1)",
        "font-family-monospace": "Consolas, Menlo, 'Lucida Console', Courier, Monaco, monospace",
        "font-family-primary": "'Anova UI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "font-family-secondary": "'Anova', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "font-size-base-text": "16px",
        "font-size-body-text-l": "1rem",
        "font-size-body-text-m": "0.875rem",
        "font-size-body-text-s": "0.75rem",
        "font-size-body-text-xl": "1.125rem",
        "font-size-body-text-xs": "0.6875rem",
        "font-size-body-text-xxl": "1.25rem",
        "font-size-body-text-xxs": "0.625rem",
        "font-size-body-text-xxxl": "1.375rem",
        "font-size-body-text-xxxs": "0.5625rem",
        "font-size-body-text-xxxxl": "1.5625rem",
        "font-size-display-text-1": "4.5625rem",
        "font-size-display-text-2": "3.625rem",
        "font-size-display-text-3": "2.5rem",
        "font-size-heading-text-l": "1rem",
        "font-size-heading-text-m": "0.875rem",
        "font-size-heading-text-s": "0.75rem",
        "font-size-heading-text-xl": "1.125rem",
        "font-size-heading-text-xxl": "1.25rem",
        "font-size-heading-text-xxxl": "1.375rem",
        "font-size-heading-text-xxxxl": "1.75rem",
        "font-size-heading-text-xxxxxl": "2.25rem",
        "font-size-heading-text-xxxxxxl": "3.625rem",
        "font-size-ratio": "1.125",
        "font-size-ratio-major-second": "1.125",
        "font-size-ratio-major-third": "1.25",
        "font-size-ratio-minor-third": "1.2",
        "font-space-letter-spacing": "normal",
        "font-space-letter-spacing-l": "2px",
        "font-space-letter-spacing-m": "1px",
        "font-space-letter-spacing-s": "normal",
        "font-space-letter-spacing-xs": "-1px",
        "font-space-line-height": "1.4",
        "font-space-line-height-l": "1.6",
        "font-space-line-height-m": "1.5",
        "font-space-line-height-s": "1.4",
        "font-space-line-height-xl": "1.7",
        "font-space-line-height-xxl": "1.8",
        "font-space-word": "normal",
        "font-space-word-l": "2px",
        "font-space-word-m": "normal",
        "font-space-word-s": "1px",
        "font-style-expression": "normal",
        "font-style-expression-italic": "italic",
        "font-style-expression-normal": "normal",
        "font-style-expression-oblique": "oblique",
        "font-style-overflow-wrap": "anywhere",
        "font-style-overflow-wrap-anywhere": "anywhere",
        "font-style-overflow-wrap-break-word": "break-word",
        "font-style-overflow-wrap-normal": "normal",
        "font-style-text-transform": "none",
        "font-style-text-transform-capitalize": "capitalize",
        "font-style-text-transform-lowercase": "lowercase",
        "font-style-text-transform-none": "none",
        "font-style-text-transform-uppercase": "uppercase",
        "font-style-weight-300": "300",
        "font-style-weight-400": "400",
        "font-style-weight-500": "500",
        "font-style-weight-600": "600",
        "font-style-weight-700": "700",
        "font-style-word-break": "break-all",
        "font-style-word-break-break-all": "break-all",
        "font-style-word-break-break-word": "break-word",
        "font-style-word-break-keep-all": "keep-all",
        "font-style-word-break-normal": "normal",
        "shadow-depth-l": "0 8px 12px rgba(0, 0, 0, 0.04), 0 16px 24px rgba(0, 0, 0, 0.08)",
        "shadow-depth-m": "0 2px 4px rgba(0, 0, 0, 0.04), 0 8px 16px rgba(0, 0, 0, 0.08)",
        "shadow-depth-s": "0 2px 2px rgba(0, 0, 0, 0.04), 0 4px 8px rgba(0, 0, 0, 0.08)",
        "shadow-depth-xl": "0 16px 24px rgba(0, 0, 0, 0.04), 0 32px 48px rgba(0, 0, 0, 0.08)",
        "shadow-depth-xs": "0 1px 2px rgba(0, 0, 0, 0.04), 0 2px 4px rgba(0, 0, 0, 0.08)",
        "size-action-border-width-focus": "2px",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-border-width-l": "3px",
        "size-border-width-m": "2px",
        "size-border-width-null": "0",
        "size-border-width-s": "1px",
        "size-container-l": "400px",
        "size-container-m": "320px",
        "size-container-null": "0",
        "size-container-s": "240px",
        "size-container-xl": "640px",
        "size-container-xs": "192px",
        "size-container-xxl": "960px",
        "size-container-xxs": "96px",
        "size-icon-l": "1rem",
        "size-icon-m": "0.875rem",
        "size-icon-s": "0.75rem",
        "size-icon-xl": "1.125rem",
        "size-icon-xs": "0.75rem",
        "size-icon-xxl": "1.25rem",
        "size-icon-xxs": "0.75rem",
        "size-icon-xxxl": "1.375rem",
        "size-icon-xxxs": "0.75rem",
        "size-icon-xxxxl": "1.5625rem",
        "size-outline-width-l": "3px",
        "size-outline-width-m": "2px",
        "size-outline-width-s": "1px",
        "size-outline-width-xl": "4px",
        "size-zero-state-border-width": "1px",
        "space-base-l": "1.5rem",
        "space-base-m": "1rem",
        "space-base-null": "0",
        "space-base-s": "0.5rem",
        "space-base-size": "1rem",
        "space-base-xl": "2rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.5625rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "2.875rem",
        "space-base-xxxxl": "3.625rem",
        "space-base-xxxxxl": "4.125rem",
        "style-action-border-focus": "solid"
    }
};

const EnglishTokens = {
    name: "english",
    selectors: [":lang(en)"],
    tokens: {
        "font-family-monospace": "Consolas, Menlo, 'Lucida Console', Courier, Monaco, monospace",
        "font-family-primary": "'Anova UI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "font-family-secondary": "'Anova', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "font-size-body-text-l": "1rem",
        "font-size-body-text-m": "0.875rem",
        "font-size-body-text-s": "0.75rem",
        "font-size-body-text-xl": "1.125rem",
        "font-size-body-text-xs": "0.6875rem",
        "font-size-body-text-xxl": "1.25rem",
        "font-size-body-text-xxs": "0.625rem",
        "font-size-body-text-xxxl": "1.375rem",
        "font-size-body-text-xxxs": "0.5625rem",
        "font-size-body-text-xxxxl": "1.5625rem",
        "font-size-display-text-1": "4.5625rem",
        "font-size-display-text-2": "3.625rem",
        "font-size-display-text-3": "2.5rem",
        "font-size-heading-text-l": "1rem",
        "font-size-heading-text-m": "0.875rem",
        "font-size-heading-text-s": "0.75rem",
        "font-size-heading-text-xl": "1.125rem",
        "font-size-heading-text-xxl": "1.25rem",
        "font-size-heading-text-xxxl": "1.375rem",
        "font-size-heading-text-xxxxl": "1.75rem",
        "font-size-heading-text-xxxxxl": "2.25rem",
        "font-size-heading-text-xxxxxxl": "3.625rem",
        "font-space-line-height": "1.4",
        "font-space-line-height-l": "1.6",
        "font-space-line-height-m": "1.5",
        "font-space-line-height-s": "1.4",
        "font-space-line-height-xl": "1.7",
        "font-space-line-height-xxl": "1.8",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-icon-l": "1rem",
        "size-icon-m": "0.875rem",
        "size-icon-s": "0.75rem",
        "size-icon-xl": "1.125rem",
        "size-icon-xs": "0.75rem",
        "size-icon-xxl": "1.25rem",
        "size-icon-xxs": "0.75rem",
        "size-icon-xxxl": "1.375rem",
        "size-icon-xxxs": "0.75rem",
        "size-icon-xxxxl": "1.5625rem",
        "space-base-l": "1.5rem",
        "space-base-m": "1rem",
        "space-base-null": "0",
        "space-base-s": "0.5rem",
        "space-base-size": "1rem",
        "space-base-xl": "2rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.5625rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "2.875rem",
        "space-base-xxxxl": "3.625rem",
        "space-base-xxxxxl": "4.125rem"
    }
};

const HebrewTokens = {
    name: "hebrew",
    selectors: [":lang(he)"],
    tokens: {
        "font-family-monospace": "Consolas, Menlo, 'Lucida Console', Courier, Monaco, monospace",
        "font-family-primary": "'Anova UI', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-family-secondary": "'Anova', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-size-body-text-l": "1rem",
        "font-size-body-text-m": "0.875rem",
        "font-size-body-text-s": "0.75rem",
        "font-size-body-text-xl": "1.125rem",
        "font-size-body-text-xs": "0.6875rem",
        "font-size-body-text-xxl": "1.25rem",
        "font-size-body-text-xxs": "0.625rem",
        "font-size-body-text-xxxl": "1.375rem",
        "font-size-body-text-xxxs": "0.5625rem",
        "font-size-body-text-xxxxl": "1.5625rem",
        "font-size-display-text-1": "4.5625rem",
        "font-size-display-text-2": "3.625rem",
        "font-size-display-text-3": "2.5rem",
        "font-size-heading-text-l": "1rem",
        "font-size-heading-text-m": "0.875rem",
        "font-size-heading-text-s": "0.75rem",
        "font-size-heading-text-xl": "1.125rem",
        "font-size-heading-text-xxl": "1.25rem",
        "font-size-heading-text-xxxl": "1.375rem",
        "font-size-heading-text-xxxxl": "1.75rem",
        "font-size-heading-text-xxxxxl": "2.25rem",
        "font-size-heading-text-xxxxxxl": "3.625rem",
        "font-space-line-height": "1.5",
        "font-space-line-height-l": "1.7",
        "font-space-line-height-m": "1.6",
        "font-space-line-height-s": "1.5",
        "font-space-line-height-xl": "1.8",
        "font-space-line-height-xxl": "1.9",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-icon-l": "1rem",
        "size-icon-m": "0.875rem",
        "size-icon-s": "0.75rem",
        "size-icon-xl": "1.125rem",
        "size-icon-xs": "0.75rem",
        "size-icon-xxl": "1.25rem",
        "size-icon-xxs": "0.75rem",
        "size-icon-xxxl": "1.375rem",
        "size-icon-xxxs": "0.75rem",
        "size-icon-xxxxl": "1.5625rem",
        "space-base-l": "1.5rem",
        "space-base-m": "1rem",
        "space-base-null": "0",
        "space-base-s": "0.5rem",
        "space-base-size": "1rem",
        "space-base-xl": "2rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.5625rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "2.875rem",
        "space-base-xxxxl": "3.625rem",
        "space-base-xxxxxl": "4.125rem"
    }
};

const HighContrastTokens = {
    name: "high-contrast",
    selectors: ["[data-sas-theme='high-contrast']"],
    tokens: {
        "brand-color-alert": "hsl(0, 100%, 40%)",
        "brand-color-alert-00": "hsl(0, 0%, 100%)",
        "brand-color-alert-10": "hsl(0, 100%, 98%)",
        "brand-color-alert-100": "hsl(0, 100%, 64%)",
        "brand-color-alert-1000": "hsl(0, 0%, 0%)",
        "brand-color-alert-20": "hsl(0, 100%, 95%)",
        "brand-color-alert-200": "hsl(0, 100%, 59%)",
        "brand-color-alert-30": "hsl(0, 100%, 92%)",
        "brand-color-alert-300": "hsl(0, 100%, 54%)",
        "brand-color-alert-40": "hsl(0, 100%, 88%)",
        "brand-color-alert-400": "hsl(0, 100%, 46%)",
        "brand-color-alert-450": "hsl(0, 100%, 40%)",
        "brand-color-alert-50": "hsl(0, 100%, 84%)",
        "brand-color-alert-500": "hsl(0, 100%, 36%)",
        "brand-color-alert-550": "hsl(0, 100%, 33%)",
        "brand-color-alert-60": "hsl(0, 100%, 79%)",
        "brand-color-alert-600": "hsl(0, 100%, 30%)",
        "brand-color-alert-650": "hsl(0, 100%, 27%)",
        "brand-color-alert-70": "hsl(0, 100%, 76%)",
        "brand-color-alert-700": "hsl(0, 100%, 22%)",
        "brand-color-alert-750": "hsl(0, 100%, 17%)",
        "brand-color-alert-80": "hsl(0, 100%, 72%)",
        "brand-color-alert-800": "hsl(0, 100%, 12%)",
        "brand-color-alert-850": "hsl(0, 100%, 8%)",
        "brand-color-alert-90": "hsl(0, 100%, 68%)",
        "brand-color-alert-900": "hsl(0, 100%, 3%)",
        "brand-color-blue": "hsl(212, 94%, 42%)",
        "brand-color-blue-00": "hsl(212, 0%, 100%)",
        "brand-color-blue-10": "hsl(212, 94%, 97%)",
        "brand-color-blue-100": "hsl(212, 94%, 62%)",
        "brand-color-blue-1000": "hsl(212, 0%, 0%)",
        "brand-color-blue-20": "hsl(212, 94%, 94%)",
        "brand-color-blue-200": "hsl(212, 94%, 57%)",
        "brand-color-blue-30": "hsl(212, 94%, 90%)",
        "brand-color-blue-300": "hsl(212, 94%, 53%)",
        "brand-color-blue-40": "hsl(212, 94%, 88%)",
        "brand-color-blue-400": "hsl(212, 94%, 47%)",
        "brand-color-blue-450": "hsl(212, 94%, 42%)",
        "brand-color-blue-50": "hsl(212, 94%, 83%)",
        "brand-color-blue-500": "hsl(212, 94%, 36%)",
        "brand-color-blue-550": "hsl(212, 94%, 35%)",
        "brand-color-blue-60": "hsl(212, 94%, 78%)",
        "brand-color-blue-600": "hsl(212, 94%, 31%)",
        "brand-color-blue-650": "hsl(212, 94%, 27%)",
        "brand-color-blue-70": "hsl(212, 94%, 76%)",
        "brand-color-blue-700": "hsl(212, 94%, 23%)",
        "brand-color-blue-750": "hsl(212, 94%, 17%)",
        "brand-color-blue-80": "hsl(212, 94%, 72%)",
        "brand-color-blue-800": "hsl(212, 94%, 12%)",
        "brand-color-blue-850": "hsl(212, 94%, 8%)",
        "brand-color-blue-90": "hsl(212, 94%, 68%)",
        "brand-color-blue-900": "hsl(212, 94%, 3%)",
        "brand-color-cranberry": "hsl(329, 60%, 40%)",
        "brand-color-cranberry-00": "hsl(329,60%,100%)",
        "brand-color-cranberry-10": "hsl(329,60%,98%)",
        "brand-color-cranberry-100": "hsl(329,60%,62%)",
        "brand-color-cranberry-1000": "hsl(329,60%,0%)",
        "brand-color-cranberry-20": "hsl(329,60%,97%)",
        "brand-color-cranberry-200": "hsl(329,60%,57%)",
        "brand-color-cranberry-30": "hsl(329,60%,92%)",
        "brand-color-cranberry-300": "hsl(329,60%,55%)",
        "brand-color-cranberry-40": "hsl(329,60%,88%)",
        "brand-color-cranberry-400": "hsl(329,60%,52%)",
        "brand-color-cranberry-450": "hsl(329,60%,40%)",
        "brand-color-cranberry-50": "hsl(329,60%,84%)",
        "brand-color-cranberry-500": "hsl(329,60%,37%)",
        "brand-color-cranberry-550": "hsl(329,60%,32%)",
        "brand-color-cranberry-60": "hsl(329,60%,78%)",
        "brand-color-cranberry-600": "hsl(329,60%,30%)",
        "brand-color-cranberry-650": "hsl(329,60%,27%)",
        "brand-color-cranberry-70": "hsl(329,60%,76%)",
        "brand-color-cranberry-700": "hsl(329,60%,22%)",
        "brand-color-cranberry-750": "hsl(329,60%,16%)",
        "brand-color-cranberry-80": "hsl(329,60%,72%)",
        "brand-color-cranberry-800": "hsl(329,60%,11%)",
        "brand-color-cranberry-850": "hsl(329,60%,9%)",
        "brand-color-cranberry-90": "hsl(329,60%,68%)",
        "brand-color-cranberry-900": "hsl(329,60%,4%)",
        "brand-color-grey": "hsl(219, 12%, 42%)",
        "brand-color-grey-00": "hsl(219, 0%, 100%)",
        "brand-color-grey-10": "hsl(219, 12%, 98%)",
        "brand-color-grey-100": "hsl(219, 12%, 64%)",
        "brand-color-grey-1000": "hsl(219, 0%, 0%)",
        "brand-color-grey-20": "hsl(219, 12%, 96%)",
        "brand-color-grey-200": "hsl(219, 12%, 59%)",
        "brand-color-grey-30": "hsl(219, 12%, 92%)",
        "brand-color-grey-300": "hsl(219, 12%, 55%)",
        "brand-color-grey-40": "hsl(219, 12%, 88%)",
        "brand-color-grey-400": "hsl(219, 12%, 48%)",
        "brand-color-grey-450": "hsl(219, 12%, 42%)",
        "brand-color-grey-50": "hsl(219, 12%, 84%)",
        "brand-color-grey-500": "hsl(219, 12%, 36%)",
        "brand-color-grey-550": "hsl(219, 12%, 33%)",
        "brand-color-grey-60": "hsl(219, 12%, 79%)",
        "brand-color-grey-600": "hsl(219, 12%, 30%)",
        "brand-color-grey-650": "hsl(219, 12%, 27%)",
        "brand-color-grey-70": "hsl(219, 12%, 76%)",
        "brand-color-grey-700": "hsl(219, 12%, 22%)",
        "brand-color-grey-750": "hsl(219, 12%, 17%)",
        "brand-color-grey-80": "hsl(219, 12%, 72%)",
        "brand-color-grey-800": "hsl(219, 12%, 12%)",
        "brand-color-grey-850": "hsl(219, 12%, 8%)",
        "brand-color-grey-90": "hsl(219, 12%, 68%)",
        "brand-color-grey-900": "hsl(219, 12%, 3%)",
        "brand-color-info": "hsl(212, 94%, 42%)",
        "brand-color-info-00": "hsl(212, 0%, 100%)",
        "brand-color-info-10": "hsl(212, 94%, 97%)",
        "brand-color-info-100": "hsl(212, 94%, 62%)",
        "brand-color-info-1000": "hsl(212, 0%, 0%)",
        "brand-color-info-20": "hsl(212, 94%, 94%)",
        "brand-color-info-200": "hsl(212, 94%, 57%)",
        "brand-color-info-30": "hsl(212, 94%, 90%)",
        "brand-color-info-300": "hsl(212, 94%, 53%)",
        "brand-color-info-40": "hsl(212, 94%, 88%)",
        "brand-color-info-400": "hsl(212, 94%, 47%)",
        "brand-color-info-450": "hsl(212, 94%, 42%)",
        "brand-color-info-50": "hsl(212, 94%, 83%)",
        "brand-color-info-500": "hsl(212, 94%, 36%)",
        "brand-color-info-550": "hsl(212, 94%, 35%)",
        "brand-color-info-60": "hsl(212, 94%, 78%)",
        "brand-color-info-600": "hsl(212, 94%, 31%)",
        "brand-color-info-650": "hsl(212, 94%, 27%)",
        "brand-color-info-70": "hsl(212, 94%, 76%)",
        "brand-color-info-700": "hsl(212, 94%, 23%)",
        "brand-color-info-750": "hsl(212, 94%, 17%)",
        "brand-color-info-80": "hsl(212, 94%, 72%)",
        "brand-color-info-800": "hsl(212, 94%, 12%)",
        "brand-color-info-850": "hsl(212, 94%, 8%)",
        "brand-color-info-90": "hsl(212, 94%, 68%)",
        "brand-color-info-900": "hsl(212, 94%, 3%)",
        "brand-color-success": "hsl(123, 46%, 43%)",
        "brand-color-success-00": "hsl(123, 0%, 100%)",
        "brand-color-success-10": "hsl(123, 46%, 98%)",
        "brand-color-success-100": "hsl(123, 46%, 63%)",
        "brand-color-success-1000": "hsl(123, 0%, 0%)",
        "brand-color-success-20": "hsl(123, 46%, 95%)",
        "brand-color-success-200": "hsl(123, 46%, 58%)",
        "brand-color-success-30": "hsl(123, 46%, 90%)",
        "brand-color-success-300": "hsl(123, 46%, 55%)",
        "brand-color-success-40": "hsl(123, 46%, 87%)",
        "brand-color-success-400": "hsl(123, 46%, 48%)",
        "brand-color-success-450": "hsl(123, 46%, 43%)",
        "brand-color-success-50": "hsl(123, 46%, 82%)",
        "brand-color-success-500": "hsl(123, 46%, 36%)",
        "brand-color-success-550": "hsl(123, 46%, 34%)",
        "brand-color-success-60": "hsl(123, 46%, 78%)",
        "brand-color-success-600": "hsl(123, 46%, 30%)",
        "brand-color-success-650": "hsl(123, 46%, 25%)",
        "brand-color-success-70": "hsl(123, 46%, 75%)",
        "brand-color-success-700": "hsl(123, 46%, 22%)",
        "brand-color-success-750": "hsl(123, 46%, 17%)",
        "brand-color-success-80": "hsl(123, 46%, 70%)",
        "brand-color-success-800": "hsl(123, 46%, 12%)",
        "brand-color-success-850": "hsl(123, 46%, 8%)",
        "brand-color-success-90": "hsl(123, 46%, 66%)",
        "brand-color-success-900": "hsl(123, 46%, 3%)",
        "brand-color-warning": "hsl(43, 89%, 44%)",
        "brand-color-warning-00": "hsl(43, 0%, 100%)",
        "brand-color-warning-10": "hsl(43, 89%, 98%)",
        "brand-color-warning-100": "hsl(43, 89%, 64%)",
        "brand-color-warning-1000": "hsl(43, 0%, 0%)",
        "brand-color-warning-20": "hsl(43, 89%, 95%)",
        "brand-color-warning-200": "hsl(43, 89%, 60%)",
        "brand-color-warning-30": "hsl(43, 89%, 92%)",
        "brand-color-warning-300": "hsl(43, 89%, 56%)",
        "brand-color-warning-40": "hsl(43, 89%, 88%)",
        "brand-color-warning-400": "hsl(43, 89%, 52%)",
        "brand-color-warning-450": "hsl(43, 89%, 44%)",
        "brand-color-warning-50": "hsl(43, 89%, 84%)",
        "brand-color-warning-500": "hsl(43, 89%, 39%)",
        "brand-color-warning-550": "hsl(43, 89%, 35%)",
        "brand-color-warning-60": "hsl(43, 89%, 79%)",
        "brand-color-warning-600": "hsl(43, 89%, 31%)",
        "brand-color-warning-650": "hsl(43, 89%, 27%)",
        "brand-color-warning-70": "hsl(43, 89%, 76%)",
        "brand-color-warning-700": "hsl(43, 89%, 24%)",
        "brand-color-warning-750": "hsl(43, 89%, 17%)",
        "brand-color-warning-80": "hsl(43, 89%, 72%)",
        "brand-color-warning-800": "hsl(43, 89%, 12%)",
        "brand-color-warning-850": "hsl(43, 89%, 8%)",
        "brand-color-warning-90": "hsl(43, 89%, 68%)",
        "brand-color-warning-900": "hsl(43, 89%, 3%)",
        "color-accent-background-1": "hsla(212, 94%, 12%)",
        "color-accent-background-2": "hsla(25, 87%, 12%)",
        "color-accent-background-3": "hsla(169, 40%, 12%)",
        "color-accent-background-4": "hsla(317, 74%, 12%)",
        "color-accent-background-5": "hsla(79, 51%, 12%, 1)",
        "color-accent-background-6": "hsla(267, 72%, 17%, 1)",
        "color-accent-background-7": "hsla(48, 80%, 12%, 1)",
        "color-accent-background-8": "hsla(7, 83%, 12%, 1)",
        "color-accent-border-1": "hsla(212, 94%, 62%)",
        "color-accent-border-2": "hsla(25, 87%, 61%)",
        "color-accent-border-3": "hsla(163, 40%, 64%)",
        "color-accent-border-4": "hsla(317, 74%, 64%)",
        "color-accent-border-5": "hsla(79, 51%, 64%, 1)",
        "color-accent-border-6": "hsla(267, 72%, 64%, 1)",
        "color-accent-border-7": "hsla(48, 80%, 64%, 1)",
        "color-accent-border-8": "hsla(7, 83%, 65%, 1)",
        "color-accent-icon-1": "hsla(212, 94%, 84%)",
        "color-accent-icon-2": "hsla(25, 87%, 84%)",
        "color-accent-icon-3": "hsla(169, 40%, 84%)",
        "color-accent-icon-4": "hsla(317, 74%, 84%)",
        "color-accent-icon-5": "hsla(79, 51%, 84%, 1)",
        "color-accent-icon-6": "hsla(266, 72%, 84%, 1)",
        "color-accent-icon-7": "hsla(48, 80%, 84%, 1)",
        "color-accent-icon-8": "hsla(7, 83%, 84%, 1)",
        "color-accent-spectrum-1-00": "hsla(0, 0%, 100%)",
        "color-accent-spectrum-1-10": "hsla(212, 94%, 98%)",
        "color-accent-spectrum-1-100": "hsla(212, 94%, 62%)",
        "color-accent-spectrum-1-1000": "hsla(0, 0%, 0%)",
        "color-accent-spectrum-1-20": "hsla(212, 94%, 95%)",
        "color-accent-spectrum-1-200": "hsla(212, 94%, 59%)",
        "color-accent-spectrum-1-30": "hsla(212, 94%, 92%)",
        "color-accent-spectrum-1-300": "hsla(212, 94%, 54%)",
        "color-accent-spectrum-1-40": "hsla(212, 94%, 88%)",
        "color-accent-spectrum-1-400": "hsla(212, 94%, 46%)",
        "color-accent-spectrum-1-450": "hsla(212, 94%, 40%)",
        "color-accent-spectrum-1-50": "hsla(212, 94%, 84%)",
        "color-accent-spectrum-1-500": "hsla(212, 94%, 36%)",
        "color-accent-spectrum-1-550": "hsla(212, 94%, 33%)",
        "color-accent-spectrum-1-60": "hsla(212, 94%, 79%)",
        "color-accent-spectrum-1-600": "hsla(212, 94%, 30%)",
        "color-accent-spectrum-1-650": "hsla(212, 94%, 27%)",
        "color-accent-spectrum-1-70": "hsla(212, 94%, 76%)",
        "color-accent-spectrum-1-700": "hsla(212, 94%, 22%)",
        "color-accent-spectrum-1-750": "hsla(212, 94%, 17%)",
        "color-accent-spectrum-1-80": "hsla(212, 94%, 72%)",
        "color-accent-spectrum-1-800": "hsla(212, 94%, 12%)",
        "color-accent-spectrum-1-850": "hsla(212, 94%, 8%)",
        "color-accent-spectrum-1-90": "hsla(212, 94%, 68%)",
        "color-accent-spectrum-1-900": "hsla(212, 94%, 3%)",
        "color-accent-spectrum-2-00": "hsla(0, 0%, 100%)",
        "color-accent-spectrum-2-10": "hsla(25, 87%, 98%)",
        "color-accent-spectrum-2-100": "hsla(25, 87%, 61%)",
        "color-accent-spectrum-2-1000": "hsla(0, 0%, 0%)",
        "color-accent-spectrum-2-20": "hsla(25, 87%, 95%)",
        "color-accent-spectrum-2-200": "hsla(25, 87%, 59%)",
        "color-accent-spectrum-2-30": "hsla(25, 87%, 92%)",
        "color-accent-spectrum-2-300": "hsla(25, 87%, 54%)",
        "color-accent-spectrum-2-40": "hsla(25, 87%, 88%)",
        "color-accent-spectrum-2-400": "hsla(25, 87%, 46%)",
        "color-accent-spectrum-2-450": "hsla(25, 87%, 40%)",
        "color-accent-spectrum-2-50": "hsla(25, 87%, 84%)",
        "color-accent-spectrum-2-500": "hsla(25, 87%, 36%)",
        "color-accent-spectrum-2-550": "hsla(25, 87%, 33%)",
        "color-accent-spectrum-2-60": "hsla(25, 87%, 79%)",
        "color-accent-spectrum-2-600": "hsla(25, 87%, 30%)",
        "color-accent-spectrum-2-650": "hsla(25, 87%, 27%)",
        "color-accent-spectrum-2-70": "hsla(25, 87%, 76%)",
        "color-accent-spectrum-2-700": "hsla(25, 87%, 22%)",
        "color-accent-spectrum-2-750": "hsla(25, 87%, 17%)",
        "color-accent-spectrum-2-80": "hsla(25, 87%, 72%)",
        "color-accent-spectrum-2-800": "hsla(25, 87%, 12%)",
        "color-accent-spectrum-2-850": "hsla(25, 87%, 8%)",
        "color-accent-spectrum-2-90": "hsla(25, 87%, 68%)",
        "color-accent-spectrum-2-900": "hsla(25, 87%, 3%)",
        "color-accent-spectrum-3-00": "hsla(0, 0%, 100%)",
        "color-accent-spectrum-3-10": "hsla(169, 40%, 98%)",
        "color-accent-spectrum-3-100": "hsla(163, 40%, 64%)",
        "color-accent-spectrum-3-1000": "hsla(0, 0%, 0%)",
        "color-accent-spectrum-3-20": "hsla(169, 40%, 95%)",
        "color-accent-spectrum-3-200": "hsla(169, 40%, 59%)",
        "color-accent-spectrum-3-30": "hsla(169, 40%, 92%)",
        "color-accent-spectrum-3-300": "hsla(169, 40%, 52%)",
        "color-accent-spectrum-3-40": "hsla(169, 40%, 88%)",
        "color-accent-spectrum-3-400": "hsla(169, 40%, 46%)",
        "color-accent-spectrum-3-450": "hsla(169, 40%, 40%)",
        "color-accent-spectrum-3-50": "hsla(169, 40%, 84%)",
        "color-accent-spectrum-3-500": "hsla(169, 40%, 36%)",
        "color-accent-spectrum-3-550": "hsla(169, 40%, 33%)",
        "color-accent-spectrum-3-60": "hsla(169, 40%, 79%)",
        "color-accent-spectrum-3-600": "hsla(169, 40%, 30%)",
        "color-accent-spectrum-3-650": "hsla(169, 40%, 27%)",
        "color-accent-spectrum-3-70": "hsla(169, 40%, 76%)",
        "color-accent-spectrum-3-700": "hsla(169, 40%, 22%)",
        "color-accent-spectrum-3-750": "hsla(169, 40%, 17%)",
        "color-accent-spectrum-3-80": "hsla(169, 40%, 72%)",
        "color-accent-spectrum-3-800": "hsla(169, 40%, 12%)",
        "color-accent-spectrum-3-850": "hsla(169, 40%, 8%)",
        "color-accent-spectrum-3-90": "hsla(169, 40%, 68%)",
        "color-accent-spectrum-3-900": "hsla(169, 40%, 3%)",
        "color-accent-spectrum-4-00": "hsla(0, 0%, 100%)",
        "color-accent-spectrum-4-10": "hsla(317, 74%, 98%)",
        "color-accent-spectrum-4-100": "hsla(317, 74%, 64%)",
        "color-accent-spectrum-4-1000": "hsla(0, 0%, 0%)",
        "color-accent-spectrum-4-20": "hsla(317, 74%, 95%)",
        "color-accent-spectrum-4-200": "hsla(317, 74%, 59%)",
        "color-accent-spectrum-4-30": "hsla(317, 74%, 92%)",
        "color-accent-spectrum-4-300": "hsla(317, 74%, 54%)",
        "color-accent-spectrum-4-40": "hsla(317, 74%, 88%)",
        "color-accent-spectrum-4-400": "hsla(317, 74%, 46%)",
        "color-accent-spectrum-4-450": "hsla(317, 74%, 40%)",
        "color-accent-spectrum-4-50": "hsla(317, 74%, 84%)",
        "color-accent-spectrum-4-500": "hsla(317, 74%, 36%)",
        "color-accent-spectrum-4-550": "hsla(317, 74%, 33%)",
        "color-accent-spectrum-4-60": "hsla(317, 74%, 79%)",
        "color-accent-spectrum-4-600": "hsla(317, 74%, 30%)",
        "color-accent-spectrum-4-650": "hsla(317, 74%, 27%)",
        "color-accent-spectrum-4-70": "hsla(317, 74%, 76%)",
        "color-accent-spectrum-4-700": "hsla(317, 74%, 22%)",
        "color-accent-spectrum-4-750": "hsla(317, 74%, 17%)",
        "color-accent-spectrum-4-80": "hsla(317, 74%, 71%)",
        "color-accent-spectrum-4-800": "hsla(317, 74%, 12%)",
        "color-accent-spectrum-4-850": "hsla(317, 74%, 8%)",
        "color-accent-spectrum-4-90": "hsla(317, 74%, 68%)",
        "color-accent-spectrum-4-900": "hsla(317, 74%, 3%)",
        "color-accent-spectrum-5-00": "hsla(0, 0%, 100%, 1)",
        "color-accent-spectrum-5-10": "hsla(79, 51%, 98%, 1)",
        "color-accent-spectrum-5-100": "hsla(79, 51%, 64%, 1)",
        "color-accent-spectrum-5-1000": "hsla(0, 0%, 0%, 1)",
        "color-accent-spectrum-5-20": "hsla(79, 51%, 95%, 1)",
        "color-accent-spectrum-5-200": "hsla(79, 51%, 59%, 1)",
        "color-accent-spectrum-5-30": "hsla(79, 51%, 92%, 1)",
        "color-accent-spectrum-5-300": "hsla(79, 51%, 50%, 1)",
        "color-accent-spectrum-5-40": "hsla(79, 51%, 88%, 1)",
        "color-accent-spectrum-5-400": "hsla(79, 51%, 46%, 1)",
        "color-accent-spectrum-5-450": "hsla(79, 51%, 40%, 1)",
        "color-accent-spectrum-5-50": "hsla(79, 51%, 84%, 1)",
        "color-accent-spectrum-5-500": "hsla(79, 51%, 36%, 1)",
        "color-accent-spectrum-5-550": "hsla(79, 51%, 33%, 1)",
        "color-accent-spectrum-5-60": "hsla(79, 51%, 79%, 1)",
        "color-accent-spectrum-5-600": "hsla(79, 51%, 30%, 1)",
        "color-accent-spectrum-5-650": "hsla(79, 51%, 27%, 1)",
        "color-accent-spectrum-5-70": "hsla(79, 51%, 76%, 1)",
        "color-accent-spectrum-5-700": "hsla(79, 51%, 22%, 1)",
        "color-accent-spectrum-5-750": "hsla(79, 51%, 17%, 1)",
        "color-accent-spectrum-5-80": "hsla(79, 51%, 72%, 1)",
        "color-accent-spectrum-5-800": "hsla(79, 51%, 12%, 1)",
        "color-accent-spectrum-5-850": "hsla(79, 51%, 8%, 1)",
        "color-accent-spectrum-5-90": "hsla(79, 51%, 68%, 1)",
        "color-accent-spectrum-5-900": "hsla(79, 51%, 3%, 1)",
        "color-accent-spectrum-6-00": "hsla(0, 0%, 100%, 1)",
        "color-accent-spectrum-6-10": "hsla(266, 72%, 98%, 1)",
        "color-accent-spectrum-6-100": "hsla(267, 72%, 64%, 1)",
        "color-accent-spectrum-6-1000": "hsla(0, 0%, 0%, 1)",
        "color-accent-spectrum-6-20": "hsla(266, 72%, 95%, 1)",
        "color-accent-spectrum-6-200": "hsla(267, 72%, 59%, 1)",
        "color-accent-spectrum-6-30": "hsla(267, 72%, 92%, 1)",
        "color-accent-spectrum-6-300": "hsla(267, 72%, 54%, 1)",
        "color-accent-spectrum-6-40": "hsla(267, 72%, 88%, 1)",
        "color-accent-spectrum-6-400": "hsla(267, 72%, 46%, 1)",
        "color-accent-spectrum-6-450": "hsla(267, 72%, 40%, 1)",
        "color-accent-spectrum-6-50": "hsla(266, 72%, 84%, 1)",
        "color-accent-spectrum-6-500": "hsla(267, 72%, 36%, 1)",
        "color-accent-spectrum-6-550": "hsla(267, 72%, 33%, 1)",
        "color-accent-spectrum-6-60": "hsla(267, 72%, 79%, 1)",
        "color-accent-spectrum-6-600": "hsla(267, 72%, 30%, 1)",
        "color-accent-spectrum-6-650": "hsla(267, 72%, 27%, 1)",
        "color-accent-spectrum-6-70": "hsla(267, 72%, 76%, 1)",
        "color-accent-spectrum-6-700": "hsla(266, 72%, 22%, 1)",
        "color-accent-spectrum-6-750": "hsla(267, 72%, 17%, 1)",
        "color-accent-spectrum-6-80": "hsla(267, 72%, 72%, 1)",
        "color-accent-spectrum-6-800": "hsla(267, 72%, 12%, 1)",
        "color-accent-spectrum-6-850": "hsla(266, 72%, 8%, 1)",
        "color-accent-spectrum-6-90": "hsla(267, 72%, 67%, 1)",
        "color-accent-spectrum-6-900": "hsla(267, 72%, 3%, 1)",
        "color-accent-spectrum-7-00": "hsla(0, 0%, 100%, 1)",
        "color-accent-spectrum-7-10": "hsla(48, 80%, 98%, 1)",
        "color-accent-spectrum-7-100": "hsla(48, 80%, 64%, 1)",
        "color-accent-spectrum-7-1000": "hsla(0, 0%, 0%, 1)",
        "color-accent-spectrum-7-20": "hsla(48, 80%, 95%, 1)",
        "color-accent-spectrum-7-200": "hsla(48, 80%, 59%, 1)",
        "color-accent-spectrum-7-30": "hsla(48, 80%, 92%, 1)",
        "color-accent-spectrum-7-300": "hsla(48, 80%, 54%, 1)",
        "color-accent-spectrum-7-40": "hsla(48, 80%, 88%, 1)",
        "color-accent-spectrum-7-400": "hsla(48, 80%, 48%, 1)",
        "color-accent-spectrum-7-450": "hsla(48, 80%, 40%, 1)",
        "color-accent-spectrum-7-50": "hsla(48, 80%, 84%, 1)",
        "color-accent-spectrum-7-500": "hsla(48, 80%, 36%, 1)",
        "color-accent-spectrum-7-550": "hsla(48, 80%, 33%, 1)",
        "color-accent-spectrum-7-60": "hsla(48, 80%, 79%, 1)",
        "color-accent-spectrum-7-600": "hsla(48, 80%, 30%, 1)",
        "color-accent-spectrum-7-650": "hsla(48, 80%, 27%, 1)",
        "color-accent-spectrum-7-70": "hsla(48, 80%, 76%, 1)",
        "color-accent-spectrum-7-700": "hsla(48, 80%, 22%, 1)",
        "color-accent-spectrum-7-750": "hsla(48, 80%, 17%, 1)",
        "color-accent-spectrum-7-80": "hsla(48, 80%, 72%, 1)",
        "color-accent-spectrum-7-800": "hsla(48, 80%, 12%, 1)",
        "color-accent-spectrum-7-850": "hsla(48, 80%, 8%, 1)",
        "color-accent-spectrum-7-90": "hsla(48, 80%, 68%, 1)",
        "color-accent-spectrum-7-900": "hsla(48, 80%, 3%, 1)",
        "color-accent-spectrum-8-00": "hsla(0, 0%, 100%, 1)",
        "color-accent-spectrum-8-10": "hsla(7, 83%, 98%, 1)",
        "color-accent-spectrum-8-100": "hsla(7, 83%, 65%, 1)",
        "color-accent-spectrum-8-1000": "hsla(0, 0%, 0%, 1)",
        "color-accent-spectrum-8-20": "hsla(7, 83%, 95%, 1)",
        "color-accent-spectrum-8-200": "hsla(7, 83%, 59%, 1)",
        "color-accent-spectrum-8-30": "hsla(7, 83%, 92%, 1)",
        "color-accent-spectrum-8-300": "hsla(7, 83%, 54%, 1)",
        "color-accent-spectrum-8-40": "hsla(7, 83%, 88%, 1)",
        "color-accent-spectrum-8-400": "hsla(7, 83%, 46%, 1)",
        "color-accent-spectrum-8-450": "hsla(7, 83%, 40%, 1)",
        "color-accent-spectrum-8-50": "hsla(7, 83%, 84%, 1)",
        "color-accent-spectrum-8-500": "hsla(7, 83%, 36%, 1)",
        "color-accent-spectrum-8-550": "hsla(7, 83%, 33%, 1)",
        "color-accent-spectrum-8-60": "hsla(7, 83%, 79%, 1)",
        "color-accent-spectrum-8-600": "hsla(7, 83%, 30%, 1)",
        "color-accent-spectrum-8-650": "hsla(7, 83%, 27%, 1)",
        "color-accent-spectrum-8-70": "hsla(7, 83%, 76%, 1)",
        "color-accent-spectrum-8-700": "hsla(7, 83%, 22%, 1)",
        "color-accent-spectrum-8-750": "hsla(7, 83%, 17%, 1)",
        "color-accent-spectrum-8-80": "hsla(7, 83%, 72%, 1)",
        "color-accent-spectrum-8-800": "hsla(7, 83%, 12%, 1)",
        "color-accent-spectrum-8-850": "hsla(7, 83%, 8%, 1)",
        "color-accent-spectrum-8-90": "hsla(7, 83%, 68%, 1)",
        "color-accent-spectrum-8-900": "hsla(7, 83%, 3%, 1)",
        "color-accent-text-1": "hsla(212, 94%, 84%)",
        "color-accent-text-2": "hsla(25, 87%, 84%)",
        "color-accent-text-3": "hsla(169, 40%, 84%)",
        "color-accent-text-4": "hsla(317, 74%, 84%)",
        "color-accent-text-5": "hsla(79, 51%, 84%, 1)",
        "color-accent-text-6": "hsla(266, 72%, 84%, 1)",
        "color-accent-text-7": "hsla(48, 80%, 84%, 1)",
        "color-accent-text-8": "hsla(7, 83%, 84%, 1)",
        "color-action-background-control-alert": "hsl(0, 100%, 12%)",
        "color-action-background-control-disabled": "hsl(219, 0%, 0%)",
        "color-action-background-control-hover": "hsl(219, 12%, 30%)",
        "color-action-background-control-normal": "hsl(219, 12%, 12%)",
        "color-action-background-control-primary": "hsl(219, 0%, 100%)",
        "color-action-background-control-read-only": "hsl(219, 0%, 0%)",
        "color-action-background-control-selected": "hsl(212, 94%, 17%)",
        "color-action-background-control-warning": "hsl(43, 89%, 12%)",
        "color-action-background-emphasis-active": "hsl(212, 94%, 83%)",
        "color-action-background-emphasis-disabled": "hsl(219, 0%, 0%)",
        "color-action-background-emphasis-hover": "hsl(212, 94%, 31%)",
        "color-action-background-emphasis-normal": "hsl(212, 0%, 0%)",
        "color-action-background-emphasis-selected": "hsl(212, 94%, 83%)",
        "color-action-background-emphasis-visited": "hsl(212, 0%, 0%)",
        "color-action-background-focus": "hsl(205, 97%, 76%)",
        "color-action-background-focus-inverse": "hsl(0, 0%, 0%)",
        "color-action-background-on-off-disabled": "hsl(219, 0%, 0%)",
        "color-action-background-on-off-hover": "hsl(219, 12%, 30%)",
        "color-action-background-on-off-normal": "hsl(219, 0%, 0%)",
        "color-action-background-on-off-read-only": "hsl(219, 0%, 0%)",
        "color-action-background-on-off-selected": "hsl(212, 0%, 100%)",
        "color-action-background-on-off-selected-disabled": "hsl(219, 12%, 17%)",
        "color-action-background-standard-active": "hsl(212, 0%, 100%)",
        "color-action-background-standard-disabled": "hsl(219, 0%, 0%)",
        "color-action-background-standard-hover": "hsl(219, 12%, 30%)",
        "color-action-background-standard-normal": "hsl(219, 0%, 0%)",
        "color-action-background-standard-selected": "hsl(212, 0%, 100%)",
        "color-action-background-standard-selected-disabled": "hsl(219, 12%, 17%)",
        "color-action-background-standard-selected-inactive": "hsl(219, 12%, 30%)",
        "color-action-background-standard-visited": "hsl(219, 0%, 0%)",
        "color-action-background-subtle-disabled": "hsla(0, 0%, 0%, 0)",
        "color-action-background-subtle-hover": "hsl(219, 12%, 30%)",
        "color-action-background-subtle-normal": "hsla(0, 0%, 0%, 0)",
        "color-action-background-subtle-selected": "hsl(212, 0%, 100%)",
        "color-action-background-subtle-selected-disabled": "hsl(219, 12%, 17%)",
        "color-action-background-subtle-selected-inactive": "hsl(219, 12%, 30%)",
        "color-action-border-bottom-control-alert": "hsl(0, 100%, 84%)",
        "color-action-border-bottom-control-hover": "hsl(219, 0%, 100%)",
        "color-action-border-bottom-control-normal": "hsl(219, 0%, 100%)",
        "color-action-border-bottom-control-selected": "hsl(212, 94%, 83%)",
        "color-action-border-bottom-control-warning": "hsl(43, 89%, 84%)",
        "color-action-border-control-alert": "hsl(0, 0%, 0%)",
        "color-action-border-control-disabled": "hsl(219, 0%, 0%)",
        "color-action-border-control-hover": "hsl(219, 0%, 100%)",
        "color-action-border-control-normal": "hsl(219, 0%, 100%)",
        "color-action-border-control-read-only": "hsl(219, 0%, 0%)",
        "color-action-border-control-selected": "hsl(212, 94%, 17%)",
        "color-action-border-control-warning": "hsl(43, 89%, 84%)",
        "color-action-border-emphasis-active": "hsl(212, 94%, 83%)",
        "color-action-border-emphasis-disabled": "hsl(219, 0%, 0%)",
        "color-action-border-emphasis-hover": "hsl(212, 0%, 100%)",
        "color-action-border-emphasis-normal": "hsl(212, 94%, 83%)",
        "color-action-border-emphasis-selected": "hsl(212, 94%, 83%)",
        "color-action-border-emphasis-visited": "hsl(212, 94%, 83%)",
        "color-action-border-focus": "hsl(212, 94%, 83%)",
        "color-action-border-focus-inverse": "hsl(212, 0%, 0%)",
        "color-action-border-on-off-disabled": "hsl(219, 12%, 22%)",
        "color-action-border-on-off-hover": "hsl(219, 0%, 100%)",
        "color-action-border-on-off-normal": "hsl(219, 0%, 100%)",
        "color-action-border-on-off-read-only": "hsl(219, 0%, 100%)",
        "color-action-border-on-off-selected": "hsl(212, 0%, 100%)",
        "color-action-border-on-off-selected-disabled": "hsl(219, 12%, 17%)",
        "color-action-border-standard-active": "hsl(212, 0%, 100%)",
        "color-action-border-standard-disabled": "hsl(219, 0%, 0%)",
        "color-action-border-standard-hover": "hsl(219, 0%, 100%)",
        "color-action-border-standard-normal": "hsl(219, 0%, 100%)",
        "color-action-border-standard-selected": "hsl(212, 0%, 100%)",
        "color-action-border-standard-selected-disabled": "hsl(219, 12%, 17%)",
        "color-action-border-standard-selected-inactive": "hsl(219, 12%, 30%)",
        "color-action-border-standard-visited": "hsl(219, 0%, 100%)",
        "color-action-border-subtle-disabled": "hsla(0, 0%, 0%, 0)",
        "color-action-border-subtle-hover": "hsl(219, 12%, 30%)",
        "color-action-border-subtle-normal": "hsla(0, 0%, 0%, 0)",
        "color-action-border-subtle-selected": "hsl(212, 0%, 100%)",
        "color-action-border-subtle-selected-disabled": "hsl(219, 12%, 17%)",
        "color-action-border-subtle-selected-inactive": "hsl(219, 12%, 30%)",
        "color-action-focus": "hsl(212, 94%, 83%)",
        "color-action-icon-control-alert": "hsl(0, 0%, 100%)",
        "color-action-icon-control-disabled": "hsl(219, 12%, 30%)",
        "color-action-icon-control-hover": "hsl(219, 0%, 100%)",
        "color-action-icon-control-normal": "hsl(219, 0%, 100%)",
        "color-action-icon-control-read-only": "hsl(219, 0%, 100%)",
        "color-action-icon-control-selected": "hsl(212, 0%, 100%)",
        "color-action-icon-control-warning": "hsl(43, 0%, 100%)",
        "color-action-icon-emphasis-active": "hsl(212, 0%, 0%)",
        "color-action-icon-emphasis-disabled": "hsl(219, 12%, 30%)",
        "color-action-icon-emphasis-hover": "hsl(212, 0%, 100%)",
        "color-action-icon-emphasis-normal": "hsl(212, 94%, 83%)",
        "color-action-icon-emphasis-selected": "hsl(212, 0%, 0%)",
        "color-action-icon-emphasis-visited": "hsl(212, 94%, 83%)",
        "color-action-icon-on-off-disabled": "hsl(219, 12%, 30%)",
        "color-action-icon-on-off-hover": "hsl(219, 0%, 100%)",
        "color-action-icon-on-off-normal": "hsl(219, 0%, 100%)",
        "color-action-icon-on-off-read-only": "hsl(219, 0%, 100%)",
        "color-action-icon-on-off-selected": "hsl(212, 0%, 0%)",
        "color-action-icon-on-off-selected-disabled": "hsl(219, 12%, 30%)",
        "color-action-icon-standard-active": "hsl(212, 0%, 0%)",
        "color-action-icon-standard-disabled": "hsl(219, 12%, 30%)",
        "color-action-icon-standard-hover": "hsl(219, 0%, 100%)",
        "color-action-icon-standard-normal": "hsl(219, 0%, 100%)",
        "color-action-icon-standard-selected": "hsl(212, 0%, 0%)",
        "color-action-icon-standard-selected-disabled": "hsl(219, 12%, 30%)",
        "color-action-icon-standard-selected-inactive": "hsl(219, 0%, 100%)",
        "color-action-icon-standard-visited": "hsl(219, 0%, 100%)",
        "color-action-icon-subtle-disabled": "hsl(219, 12%, 30%)",
        "color-action-icon-subtle-hover": "hsl(219, 0%, 100%)",
        "color-action-icon-subtle-normal": "hsl(219, 0%, 100%)",
        "color-action-icon-subtle-selected": "hsl(212, 0%, 0%)",
        "color-action-icon-subtle-selected-disabled": "hsl(219, 12%, 30%)",
        "color-action-icon-subtle-selected-inactive": "hsl(219, 0%, 100%)",
        "color-action-link-active": "hsl(219, 0%, 100%)",
        "color-action-link-hover": "hsl(212, 94%, 83%)",
        "color-action-link-normal": "hsl(212, 94%, 83%)",
        "color-action-link-visited": "hsl(212, 94%, 83%)",
        "color-action-text-control-alert": "hsl(0, 0%, 100%)",
        "color-action-text-control-disabled": "hsl(219, 12%, 30%)",
        "color-action-text-control-hover": "hsl(219, 0%, 100%)",
        "color-action-text-control-normal": "hsl(219, 0%, 100%)",
        "color-action-text-control-placeholder": "hsl(219, 0%, 100%)",
        "color-action-text-control-read-only": "hsl(219, 0%, 100%)",
        "color-action-text-control-selected": "hsl(212, 0%, 100%)",
        "color-action-text-control-warning": "hsl(43, 0%, 100%)",
        "color-action-text-emphasis-active": "hsl(212, 0%, 0%)",
        "color-action-text-emphasis-disabled": "hsl(219, 12%, 36%)",
        "color-action-text-emphasis-hover": "hsl(212, 0%, 100%)",
        "color-action-text-emphasis-normal": "hsl(212, 94%, 83%)",
        "color-action-text-emphasis-selected": "hsl(212, 0%, 0%)",
        "color-action-text-emphasis-visited": "hsl(212, 94%, 83%)",
        "color-action-text-on-off-disabled": "hsl(219, 12%, 30%)",
        "color-action-text-on-off-hover": "hsl(219, 0%, 100%)",
        "color-action-text-on-off-normal": "hsl(219, 0%, 100%)",
        "color-action-text-on-off-read-only": "hsl(219, 0%, 100%)",
        "color-action-text-on-off-selected": "hsl(212, 0%, 0%)",
        "color-action-text-on-off-selected-disabled": "hsl(219, 12%, 79%)",
        "color-action-text-standard-active": "hsl(212, 0%, 0%)",
        "color-action-text-standard-disabled": "hsl(219, 12%, 30%)",
        "color-action-text-standard-hover": "hsl(219, 0%, 100%)",
        "color-action-text-standard-normal": "hsl(219, 0%, 100%)",
        "color-action-text-standard-selected": "hsl(212, 0%, 0%)",
        "color-action-text-standard-selected-disabled": "hsl(219, 12%, 30%)",
        "color-action-text-standard-selected-inactive": "hsl(219, 0%, 100%)",
        "color-action-text-standard-visited": "hsl(219, 0%, 100%)",
        "color-action-text-subtle-disabled": "hsl(219, 12%, 30%)",
        "color-action-text-subtle-hover": "hsl(219, 0%, 100%)",
        "color-action-text-subtle-normal": "hsl(219, 0%, 100%)",
        "color-action-text-subtle-selected": "hsl(212, 0%, 0%)",
        "color-action-text-subtle-selected-disabled": "hsl(219, 12%, 30%)",
        "color-action-text-subtle-selected-inactive": "hsl(219, 0%, 100%)",
        "color-alert-00": "hsl(0, 0%, 100%)",
        "color-alert-10": "hsl(0, 100%, 98%)",
        "color-alert-100": "hsl(0, 100%, 64%)",
        "color-alert-1000": "hsl(0, 0%, 0%)",
        "color-alert-20": "hsl(0, 100%, 95%)",
        "color-alert-200": "hsl(0, 100%, 59%)",
        "color-alert-30": "hsl(0, 100%, 92%)",
        "color-alert-300": "hsl(0, 100%, 54%)",
        "color-alert-40": "hsl(0, 100%, 88%)",
        "color-alert-400": "hsl(0, 100%, 46%)",
        "color-alert-450": "hsl(0, 100%, 40%)",
        "color-alert-50": "hsl(0, 100%, 84%)",
        "color-alert-500": "hsl(0, 100%, 36%)",
        "color-alert-550": "hsl(0, 100%, 33%)",
        "color-alert-60": "hsl(0, 100%, 79%)",
        "color-alert-600": "hsl(0, 100%, 30%)",
        "color-alert-650": "hsl(0, 100%, 27%)",
        "color-alert-70": "hsl(0, 100%, 76%)",
        "color-alert-700": "hsl(0, 100%, 22%)",
        "color-alert-750": "hsl(0, 100%, 17%)",
        "color-alert-80": "hsl(0, 100%, 72%)",
        "color-alert-800": "hsl(0, 100%, 12%)",
        "color-alert-850": "hsl(0, 100%, 8%)",
        "color-alert-90": "hsl(0, 100%, 68%)",
        "color-alert-900": "hsl(0, 100%, 3%)",
        "color-body-icon": "hsl(219, 0%, 100%)",
        "color-body-text": "hsl(219, 0%, 100%)",
        "color-container-background-0": "hsl(219, 0%, 0%)",
        "color-container-background-1": "hsl(219, 0%, 0%)",
        "color-container-background-2": "hsl(219, 0%, 0%)",
        "color-container-background-3": "hsl(212, 94%, 35%)",
        "color-container-background-4": "hsl(219, 0%, 100%)",
        "color-container-border-4": "hsl(219, 0%, 100%)",
        "color-dataviz-graph-alt1": "#9CC9FC",
        "color-dataviz-graph-alt2": "#FBB074",
        "color-dataviz-graph-alt3": "#3ADECB",
        "color-dataviz-graph-alt4": "#FFADDA",
        "color-dataviz-graph-alt5": "#A4D053",
        "color-dataviz-graph-alt6": "#E4C7FF",
        "color-dataviz-graph-alt7": "#E0D46B",
        "color-dataviz-graph-alt8": "#FFB1AD",
        "color-dataviz-graph1": "#61A8FA",
        "color-dataviz-graph2": "#F98E39",
        "color-dataviz-graph3": "#1FBBA9",
        "color-dataviz-graph4": "#FF6FBD",
        "color-dataviz-graph5": "#87B532",
        "color-dataviz-graph6": "#C68AFF",
        "color-dataviz-graph7": "#D6C539",
        "color-dataviz-graph8": "#FF7973",
        "color-dataviz-kpi-alt1": "#FFA3A3",
        "color-dataviz-kpi-alt3": "#F1EC7E",
        "color-dataviz-kpi-alt5": "#8FD693",
        "color-dataviz-kpi1": "#FF6464",
        "color-dataviz-kpi3": "#EBE447",
        "color-dataviz-kpi5": "#7bb04a",
        "color-display-icon": "hsl(219, 0%, 100%)",
        "color-display-text": "hsl(219, 0%, 100%)",
        "color-heading-icon": "hsl(219, 0%, 100%)",
        "color-heading-text": "hsl(219, 0%, 100%)",
        "color-highlight-text": "hsl(212, 94%, 83%)",
        "color-highlight-text-inverse": "hsl(212, 0%, 0%)",
        "color-icon-neutral": "hsl(212, 0%, 100%)",
        "color-icon-primary": "hsl(212, 94%, 83%)",
        "color-icon-secondary": "hsl(329,60%,62%)",
        "color-info-00": "hsl(212, 0%, 100%)",
        "color-info-10": "hsl(212, 94%, 97%)",
        "color-info-100": "hsl(212, 94%, 62%)",
        "color-info-1000": "hsl(212, 0%, 0%)",
        "color-info-20": "hsl(212, 94%, 94%)",
        "color-info-200": "hsl(212, 94%, 57%)",
        "color-info-30": "hsl(212, 94%, 90%)",
        "color-info-300": "hsl(212, 94%, 53%)",
        "color-info-40": "hsl(212, 94%, 88%)",
        "color-info-400": "hsl(212, 94%, 47%)",
        "color-info-450": "hsl(212, 94%, 42%)",
        "color-info-50": "hsl(212, 94%, 83%)",
        "color-info-500": "hsl(212, 94%, 36%)",
        "color-info-550": "hsl(212, 94%, 35%)",
        "color-info-60": "hsl(212, 94%, 78%)",
        "color-info-600": "hsl(212, 94%, 31%)",
        "color-info-650": "hsl(212, 94%, 27%)",
        "color-info-70": "hsl(212, 94%, 76%)",
        "color-info-700": "hsl(212, 94%, 23%)",
        "color-info-750": "hsl(212, 94%, 17%)",
        "color-info-80": "hsl(212, 94%, 72%)",
        "color-info-800": "hsl(212, 94%, 12%)",
        "color-info-850": "hsl(212, 94%, 8%)",
        "color-info-90": "hsl(212, 94%, 68%)",
        "color-info-900": "hsl(212, 94%, 3%)",
        "color-label-text": "hsl(219, 0%, 100%)",
        "color-neutral": "hsl(219, 12%, 84%)",
        "color-neutral-00": "hsl(219, 0%, 100%)",
        "color-neutral-10": "hsl(219, 12%, 98%)",
        "color-neutral-100": "hsl(219, 12%, 64%)",
        "color-neutral-1000": "hsl(219, 0%, 0%)",
        "color-neutral-20": "hsl(219, 12%, 96%)",
        "color-neutral-200": "hsl(219, 12%, 59%)",
        "color-neutral-30": "hsl(219, 12%, 92%)",
        "color-neutral-300": "hsl(219, 12%, 55%)",
        "color-neutral-40": "hsl(219, 12%, 88%)",
        "color-neutral-400": "hsl(219, 12%, 48%)",
        "color-neutral-450": "hsl(219, 12%, 42%)",
        "color-neutral-50": "hsl(219, 12%, 84%)",
        "color-neutral-500": "hsl(219, 12%, 36%)",
        "color-neutral-550": "hsl(219, 12%, 33%)",
        "color-neutral-60": "hsl(219, 12%, 79%)",
        "color-neutral-600": "hsl(219, 12%, 30%)",
        "color-neutral-650": "hsl(219, 12%, 27%)",
        "color-neutral-70": "hsl(219, 12%, 76%)",
        "color-neutral-700": "hsl(219, 12%, 22%)",
        "color-neutral-750": "hsl(219, 12%, 17%)",
        "color-neutral-80": "hsl(219, 12%, 72%)",
        "color-neutral-800": "hsl(219, 12%, 12%)",
        "color-neutral-850": "hsl(219, 12%, 8%)",
        "color-neutral-90": "hsl(219, 12%, 68%)",
        "color-neutral-900": "hsl(219, 12%, 3%)",
        "color-primary": "hsl(212, 94%, 83%)",
        "color-primary-00": "hsl(212, 0%, 100%)",
        "color-primary-10": "hsl(212, 94%, 97%)",
        "color-primary-100": "hsl(212, 94%, 62%)",
        "color-primary-1000": "hsl(212, 0%, 0%)",
        "color-primary-20": "hsl(212, 94%, 94%)",
        "color-primary-200": "hsl(212, 94%, 57%)",
        "color-primary-30": "hsl(212, 94%, 90%)",
        "color-primary-300": "hsl(212, 94%, 53%)",
        "color-primary-40": "hsl(212, 94%, 88%)",
        "color-primary-400": "hsl(212, 94%, 47%)",
        "color-primary-450": "hsl(212, 94%, 42%)",
        "color-primary-50": "hsl(212, 94%, 83%)",
        "color-primary-500": "hsl(212, 94%, 36%)",
        "color-primary-550": "hsl(212, 94%, 35%)",
        "color-primary-60": "hsl(212, 94%, 78%)",
        "color-primary-600": "hsl(212, 94%, 31%)",
        "color-primary-650": "hsl(212, 94%, 27%)",
        "color-primary-70": "hsl(212, 94%, 76%)",
        "color-primary-700": "hsl(212, 94%, 23%)",
        "color-primary-750": "hsl(212, 94%, 17%)",
        "color-primary-80": "hsl(212, 94%, 72%)",
        "color-primary-800": "hsl(212, 94%, 12%)",
        "color-primary-850": "hsl(212, 94%, 8%)",
        "color-primary-90": "hsl(212, 94%, 68%)",
        "color-primary-900": "hsl(212, 94%, 3%)",
        "color-secondary": "hsl(329,60%,57%)",
        "color-secondary-00": "hsl(329,60%,100%)",
        "color-secondary-10": "hsl(329,60%,98%)",
        "color-secondary-100": "hsl(329,60%,62%)",
        "color-secondary-1000": "hsl(329,60%,0%)",
        "color-secondary-20": "hsl(329,60%,97%)",
        "color-secondary-200": "hsl(329,60%,57%)",
        "color-secondary-30": "hsl(329,60%,92%)",
        "color-secondary-300": "hsl(329,60%,55%)",
        "color-secondary-40": "hsl(329,60%,88%)",
        "color-secondary-400": "hsl(329,60%,52%)",
        "color-secondary-450": "hsl(329,60%,40%)",
        "color-secondary-50": "hsl(329,60%,84%)",
        "color-secondary-500": "hsl(329,60%,37%)",
        "color-secondary-550": "hsl(329,60%,32%)",
        "color-secondary-60": "hsl(329,60%,78%)",
        "color-secondary-600": "hsl(329,60%,30%)",
        "color-secondary-650": "hsl(329,60%,27%)",
        "color-secondary-70": "hsl(329,60%,76%)",
        "color-secondary-700": "hsl(329,60%,22%)",
        "color-secondary-750": "hsl(329,60%,16%)",
        "color-secondary-80": "hsl(329,60%,72%)",
        "color-secondary-800": "hsl(329,60%,11%)",
        "color-secondary-850": "hsl(329,60%,9%)",
        "color-secondary-90": "hsl(329,60%,68%)",
        "color-secondary-900": "hsl(329,60%,4%)",
        "color-status-alert": "hsl(0, 100%, 84%)",
        "color-status-background-alert": "hsl(0, 0%, 0%)",
        "color-status-background-info": "hsl(212, 0%, 0%)",
        "color-status-background-neutral": "hsl(219, 0%, 0%)",
        "color-status-background-success": "hsl(123, 0%, 0%)",
        "color-status-background-warning": "hsl(43, 0%, 0%)",
        "color-status-border-alert": "hsl(0, 100%, 84%)",
        "color-status-border-info": "hsl(212, 94%, 83%)",
        "color-status-border-neutral": "hsl(219, 12%, 84%)",
        "color-status-border-success": "hsl(123, 46%, 82%)",
        "color-status-border-warning": "hsl(43, 89%, 84%)",
        "color-status-icon-alert": "hsl(0, 100%, 84%)",
        "color-status-icon-info": "hsl(212, 94%, 83%)",
        "color-status-icon-neutral": "hsl(219, 12%, 84%)",
        "color-status-icon-success": "hsl(123, 46%, 82%)",
        "color-status-icon-warning": "hsl(43, 89%, 84%)",
        "color-status-info": "hsl(212, 94%, 83%)",
        "color-status-neutral": "hsl(219, 12%, 84%)",
        "color-status-success": "hsl(123, 46%, 82%)",
        "color-status-text-alert": "hsl(0, 100%, 84%)",
        "color-status-text-info": "hsl(212, 94%, 83%)",
        "color-status-text-neutral": "hsl(219, 12%, 84%)",
        "color-status-text-success": "hsl(123, 46%, 82%)",
        "color-status-text-warning": "hsl(43, 89%, 84%)",
        "color-status-warning": "hsl(43, 89%, 84%)",
        "color-success-00": "hsl(123, 0%, 100%)",
        "color-success-10": "hsl(123, 46%, 98%)",
        "color-success-100": "hsl(123, 46%, 63%)",
        "color-success-1000": "hsl(123, 0%, 0%)",
        "color-success-20": "hsl(123, 46%, 95%)",
        "color-success-200": "hsl(123, 46%, 58%)",
        "color-success-30": "hsl(123, 46%, 90%)",
        "color-success-300": "hsl(123, 46%, 55%)",
        "color-success-40": "hsl(123, 46%, 87%)",
        "color-success-400": "hsl(123, 46%, 48%)",
        "color-success-450": "hsl(123, 46%, 43%)",
        "color-success-50": "hsl(123, 46%, 82%)",
        "color-success-500": "hsl(123, 46%, 36%)",
        "color-success-550": "hsl(123, 46%, 34%)",
        "color-success-60": "hsl(123, 46%, 78%)",
        "color-success-600": "hsl(123, 46%, 30%)",
        "color-success-650": "hsl(123, 46%, 25%)",
        "color-success-70": "hsl(123, 46%, 75%)",
        "color-success-700": "hsl(123, 46%, 22%)",
        "color-success-750": "hsl(123, 46%, 17%)",
        "color-success-80": "hsl(123, 46%, 70%)",
        "color-success-800": "hsl(123, 46%, 12%)",
        "color-success-850": "hsl(123, 46%, 8%)",
        "color-success-90": "hsl(123, 46%, 66%)",
        "color-success-900": "hsl(123, 46%, 3%)",
        "color-syntax-text-01": "hsl(219, 0%, 100%)",
        "color-syntax-text-02": "hsl(219, 12%, 88%)",
        "color-syntax-text-03": "hsla(25, 87%, 84%)",
        "color-syntax-text-04": "hsla(7, 83%, 84%, 1)",
        "color-syntax-text-05": "hsla(266, 72%, 84%, 1)",
        "color-syntax-text-06": "hsla(212, 94%, 84%)",
        "color-syntax-text-07": "hsla(317, 74%, 84%)",
        "color-syntax-text-08": "hsla(169, 40%, 84%)",
        "color-syntax-text-09": "hsla(79, 51%, 84%, 1)",
        "color-syntax-text-attribute-name": "hsla(317, 74%, 84%)",
        "color-syntax-text-attribute-value": "hsla(7, 83%, 84%, 1)",
        "color-syntax-text-boolean": "hsla(266, 72%, 84%, 1)",
        "color-syntax-text-character-constant": "hsla(169, 40%, 84%)",
        "color-syntax-text-class-name": "hsla(169, 40%, 84%)",
        "color-syntax-text-comment": "hsla(79, 51%, 84%, 1)",
        "color-syntax-text-control": "hsla(266, 72%, 84%, 1)",
        "color-syntax-text-data": "hsla(25, 87%, 84%)",
        "color-syntax-text-declaration": "hsla(212, 94%, 84%)",
        "color-syntax-text-default": "hsl(219, 0%, 100%)",
        "color-syntax-text-function": "hsla(266, 72%, 84%, 1)",
        "color-syntax-text-identifier": "hsl(219, 0%, 100%)",
        "color-syntax-text-keyword": "hsla(212, 94%, 84%)",
        "color-syntax-text-namespace": "hsla(169, 40%, 84%)",
        "color-syntax-text-normal": "hsl(219, 0%, 100%)",
        "color-syntax-text-numeric-constant": "hsla(169, 40%, 84%)",
        "color-syntax-text-operator": "hsla(317, 74%, 84%)",
        "color-syntax-text-proc-name": "hsla(317, 74%, 84%)",
        "color-syntax-text-property": "hsla(212, 94%, 84%)",
        "color-syntax-text-punctuation": "hsl(219, 12%, 88%)",
        "color-syntax-text-punctuation-brackets": "hsl(219, 12%, 88%)",
        "color-syntax-text-section": "hsla(317, 74%, 84%)",
        "color-syntax-text-separator": "hsl(219, 0%, 100%)",
        "color-syntax-text-source": "hsla(212, 94%, 84%)",
        "color-syntax-text-storage-type": "hsla(212, 94%, 84%)",
        "color-syntax-text-string": "hsla(7, 83%, 84%, 1)",
        "color-syntax-text-tag": "hsla(212, 94%, 84%)",
        "color-syntax-text-variable": "hsla(317, 74%, 84%)",
        "color-tag-background-1": "hsl(212, 94%, 31%)",
        "color-tag-background-2": "hsl(329,60%,30%)",
        "color-tag-background-3": "hsl(219, 12%, 30%)",
        "color-tag-border-1": "hsl(212, 94%, 97%)",
        "color-tag-border-2": "hsl(329,60%,98%)",
        "color-tag-border-3": "hsl(219, 12%, 98%)",
        "color-text-neutral": "hsl(219, 0%, 100%)",
        "color-text-neutral-inverse": "hsl(219, 0%, 0%)",
        "color-text-primary": "hsl(212, 94%, 83%)",
        "color-text-primary-inverse": "hsl(212, 0%, 100%)",
        "color-text-secondary": "hsl(329,60%,62%)",
        "color-thumbnail-fill-1": "hsl(212, 94%, 97%)",
        "color-thumbnail-fill-2": "hsl(212, 94%, 90%)",
        "color-thumbnail-fill-3": "hsl(212, 94%, 78%)",
        "color-thumbnail-fill-4": "hsl(212, 94%, 62%)",
        "color-warning-00": "hsl(43, 0%, 100%)",
        "color-warning-10": "hsl(43, 89%, 98%)",
        "color-warning-100": "hsl(43, 89%, 64%)",
        "color-warning-1000": "hsl(43, 0%, 0%)",
        "color-warning-20": "hsl(43, 89%, 95%)",
        "color-warning-200": "hsl(43, 89%, 60%)",
        "color-warning-30": "hsl(43, 89%, 92%)",
        "color-warning-300": "hsl(43, 89%, 56%)",
        "color-warning-40": "hsl(43, 89%, 88%)",
        "color-warning-400": "hsl(43, 89%, 52%)",
        "color-warning-450": "hsl(43, 89%, 44%)",
        "color-warning-50": "hsl(43, 89%, 84%)",
        "color-warning-500": "hsl(43, 89%, 39%)",
        "color-warning-550": "hsl(43, 89%, 35%)",
        "color-warning-60": "hsl(43, 89%, 79%)",
        "color-warning-600": "hsl(43, 89%, 31%)",
        "color-warning-650": "hsl(43, 89%, 27%)",
        "color-warning-70": "hsl(43, 89%, 76%)",
        "color-warning-700": "hsl(43, 89%, 24%)",
        "color-warning-750": "hsl(43, 89%, 17%)",
        "color-warning-80": "hsl(43, 89%, 72%)",
        "color-warning-800": "hsl(43, 89%, 12%)",
        "color-warning-850": "hsl(43, 89%, 8%)",
        "color-warning-90": "hsl(43, 89%, 68%)",
        "color-warning-900": "hsl(43, 89%, 3%)",
        "color-zero-state-base-fill-1": "hsl(219, 0%, 0%)",
        "color-zero-state-base-fill-2": "hsl(219, 12%, 72%)",
        "color-zero-state-base-fill-3": "hsl(219, 12%, 59%)",
        "color-zero-state-modifier-fill-1": "hsl(219, 12%, 22%)",
        "color-zero-state-modifier-fill-2": "hsl(212, 94%, 76%)",
        "color-zero-state-modifier-fill-3": "hsl(212, 94%, 57%)",
        "color-zero-state-modifier-fill-4": "hsl(219, 12%, 30%)",
        "color-zero-state-modifier-fill-5": "hsl(219, 12%, 88%)",
        "duration-100": "100ms",
        "duration-1000": "1s",
        "duration-200": "200ms",
        "duration-250": "250ms",
        "duration-300": "300ms",
        "duration-400": "400ms",
        "duration-450": "450ms",
        "duration-500": "500ms",
        "duration-700": "700ms",
        "ease-in": "cubic-bezier(0, 0.5, 0.2, 1)",
        "ease-in-out": "cubic-bezier(0.5, 0, 0.2, 1)",
        "ease-out": "cubic-bezier(0.5, 0, 0.8, 1)",
        "font-family-monospace": "Consolas, Menlo, 'Lucida Console', Courier, Monaco, monospace",
        "font-family-primary": "'Anova UI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "font-family-secondary": "'Anova', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "font-size-base-text": "16px",
        "font-size-body-text-l": "1rem",
        "font-size-body-text-m": "0.875rem",
        "font-size-body-text-s": "0.75rem",
        "font-size-body-text-xl": "1.125rem",
        "font-size-body-text-xs": "0.6875rem",
        "font-size-body-text-xxl": "1.25rem",
        "font-size-body-text-xxs": "0.625rem",
        "font-size-body-text-xxxl": "1.375rem",
        "font-size-body-text-xxxs": "0.5625rem",
        "font-size-body-text-xxxxl": "1.5625rem",
        "font-size-display-text-1": "4.5625rem",
        "font-size-display-text-2": "3.625rem",
        "font-size-display-text-3": "2.5rem",
        "font-size-heading-text-l": "1rem",
        "font-size-heading-text-m": "0.875rem",
        "font-size-heading-text-s": "0.75rem",
        "font-size-heading-text-xl": "1.125rem",
        "font-size-heading-text-xxl": "1.25rem",
        "font-size-heading-text-xxxl": "1.375rem",
        "font-size-heading-text-xxxxl": "1.75rem",
        "font-size-heading-text-xxxxxl": "2.25rem",
        "font-size-heading-text-xxxxxxl": "3.625rem",
        "font-size-ratio": "1.125",
        "font-size-ratio-major-second": "1.125",
        "font-size-ratio-major-third": "1.25",
        "font-size-ratio-minor-third": "1.2",
        "font-space-letter-spacing": "normal",
        "font-space-letter-spacing-l": "2px",
        "font-space-letter-spacing-m": "1px",
        "font-space-letter-spacing-s": "normal",
        "font-space-letter-spacing-xs": "-1px",
        "font-space-line-height": "1.4",
        "font-space-line-height-l": "1.6",
        "font-space-line-height-m": "1.5",
        "font-space-line-height-s": "1.4",
        "font-space-line-height-xl": "1.7",
        "font-space-line-height-xxl": "1.8",
        "font-space-word": "normal",
        "font-space-word-l": "2px",
        "font-space-word-m": "normal",
        "font-space-word-s": "1px",
        "font-style-expression": "normal",
        "font-style-expression-italic": "italic",
        "font-style-expression-normal": "normal",
        "font-style-expression-oblique": "oblique",
        "font-style-overflow-wrap": "anywhere",
        "font-style-overflow-wrap-anywhere": "anywhere",
        "font-style-overflow-wrap-break-word": "break-word",
        "font-style-overflow-wrap-normal": "normal",
        "font-style-text-transform": "none",
        "font-style-text-transform-capitalize": "capitalize",
        "font-style-text-transform-lowercase": "lowercase",
        "font-style-text-transform-none": "none",
        "font-style-text-transform-uppercase": "uppercase",
        "font-style-weight-300": "300",
        "font-style-weight-400": "400",
        "font-style-weight-500": "500",
        "font-style-weight-600": "600",
        "font-style-weight-700": "700",
        "font-style-word-break": "break-all",
        "font-style-word-break-break-all": "break-all",
        "font-style-word-break-break-word": "break-word",
        "font-style-word-break-keep-all": "keep-all",
        "font-style-word-break-normal": "normal",
        "shadow-depth-l": "0 8px 12px rgba(0, 0, 0, 0.04), 0 16px 24px rgba(0, 0, 0, 0.08)",
        "shadow-depth-m": "0 2px 4px rgba(0, 0, 0, 0.04), 0 8px 16px rgba(0, 0, 0, 0.08)",
        "shadow-depth-s": "0 2px 2px rgba(0, 0, 0, 0.04), 0 4px 8px rgba(0, 0, 0, 0.08)",
        "shadow-depth-xl": "0 16px 24px rgba(0, 0, 0, 0.04), 0 32px 48px rgba(0, 0, 0, 0.08)",
        "shadow-depth-xs": "0 1px 2px rgba(0, 0, 0, 0.04), 0 2px 4px rgba(0, 0, 0, 0.08)",
        "size-action-border-width-focus": "2px",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-border-width-l": "3px",
        "size-border-width-m": "2px",
        "size-border-width-null": "0",
        "size-border-width-s": "1px",
        "size-container-l": "400px",
        "size-container-m": "320px",
        "size-container-null": "0",
        "size-container-s": "240px",
        "size-container-xl": "640px",
        "size-container-xs": "192px",
        "size-container-xxl": "960px",
        "size-container-xxs": "96px",
        "size-icon-l": "1rem",
        "size-icon-m": "0.875rem",
        "size-icon-s": "0.75rem",
        "size-icon-xl": "1.125rem",
        "size-icon-xs": "0.75rem",
        "size-icon-xxl": "1.25rem",
        "size-icon-xxs": "0.75rem",
        "size-icon-xxxl": "1.375rem",
        "size-icon-xxxs": "0.75rem",
        "size-icon-xxxxl": "1.5625rem",
        "size-outline-width-l": "3px",
        "size-outline-width-m": "2px",
        "size-outline-width-s": "1px",
        "size-outline-width-xl": "4px",
        "size-zero-state-border-width": "1px",
        "space-base-l": "1.5rem",
        "space-base-m": "1rem",
        "space-base-null": "0",
        "space-base-s": "0.5rem",
        "space-base-size": "1rem",
        "space-base-xl": "2rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.5625rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "2.875rem",
        "space-base-xxxxl": "3.625rem",
        "space-base-xxxxxl": "4.125rem",
        "style-action-border-focus": "solid"
    }
};

const JapaneseTokens = {
    name: "japanese",
    selectors: [":lang(jp)"],
    tokens: {
        "font-family-monospace": "Consolas, Menlo, 'Lucida Console', Courier, Monaco, monospace",
        "font-family-primary": "'Anova UI', 'ヒラギノ角ゴ Pro W3', 'Hiragino Kaku Gothic Pro', 'Osaka', 'メイリオ', 'Meiryo', 'ＭＳ Ｐゴシック', 'MS PGothic', 'Noto Sans JP', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-family-secondary": "'Anova', 'ヒラギノ角ゴ Pro W3', 'Hiragino Kaku Gothic Pro', 'Osaka', 'メイリオ', 'Meiryo', 'ＭＳ Ｐゴシック', 'MS PGothic', 'Noto Sans JP', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-size-body-text-l": "1rem",
        "font-size-body-text-m": "0.875rem",
        "font-size-body-text-s": "0.75rem",
        "font-size-body-text-xl": "1.125rem",
        "font-size-body-text-xs": "0.6875rem",
        "font-size-body-text-xxl": "1.25rem",
        "font-size-body-text-xxs": "0.625rem",
        "font-size-body-text-xxxl": "1.375rem",
        "font-size-body-text-xxxs": "0.5625rem",
        "font-size-body-text-xxxxl": "1.5625rem",
        "font-size-display-text-1": "4.5625rem",
        "font-size-display-text-2": "3.625rem",
        "font-size-display-text-3": "2.5rem",
        "font-size-heading-text-l": "1rem",
        "font-size-heading-text-m": "0.875rem",
        "font-size-heading-text-s": "0.75rem",
        "font-size-heading-text-xl": "1.125rem",
        "font-size-heading-text-xxl": "1.25rem",
        "font-size-heading-text-xxxl": "1.375rem",
        "font-size-heading-text-xxxxl": "1.75rem",
        "font-size-heading-text-xxxxxl": "2.25rem",
        "font-size-heading-text-xxxxxxl": "3.625rem",
        "font-space-letter-spacing": "normal",
        "font-space-letter-spacing-l": "normal",
        "font-space-letter-spacing-m": "normal",
        "font-space-letter-spacing-s": "normal",
        "font-space-letter-spacing-xs": "normal",
        "font-space-line-height": "1.5",
        "font-space-line-height-l": "1.7",
        "font-space-line-height-m": "1.6",
        "font-space-line-height-s": "1.5",
        "font-space-line-height-xl": "1.8",
        "font-space-line-height-xxl": "1.9",
        "font-style-expression-italic": "normal",
        "font-style-weight-300": "400",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-icon-l": "1rem",
        "size-icon-m": "0.875rem",
        "size-icon-s": "0.75rem",
        "size-icon-xl": "1.125rem",
        "size-icon-xs": "0.75rem",
        "size-icon-xxl": "1.25rem",
        "size-icon-xxs": "0.75rem",
        "size-icon-xxxl": "1.375rem",
        "size-icon-xxxs": "0.75rem",
        "size-icon-xxxxl": "1.5625rem",
        "space-base-l": "1.5rem",
        "space-base-m": "1rem",
        "space-base-null": "0",
        "space-base-s": "0.5rem",
        "space-base-size": "1rem",
        "space-base-xl": "2rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.5625rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "2.875rem",
        "space-base-xxxxl": "3.625rem",
        "space-base-xxxxxl": "4.125rem"
    }
};

const KoreanTokens = {
    name: "korean",
    selectors: [":lang(ko)"],
    tokens: {
        "font-family-monospace": "Consolas, Menlo, 'Lucida Console', Courier, Monaco, monospace",
        "font-family-primary": "'Anova UI', '맑은 고딕', 'Malgun Gothic', 'Apple SD Gothic Neo', 'NanumBarunGothic', '굴림', 'Gulim', '돋움', 'Dotum', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-family-secondary": "'Anova', '맑은 고딕', 'Malgun Gothic', 'Apple SD Gothic Neo', 'NanumBarunGothic', '굴림', 'Gulim', '돋움', 'Dotum', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-size-body-text-l": "1rem",
        "font-size-body-text-m": "0.875rem",
        "font-size-body-text-s": "0.75rem",
        "font-size-body-text-xl": "1.125rem",
        "font-size-body-text-xs": "0.6875rem",
        "font-size-body-text-xxl": "1.25rem",
        "font-size-body-text-xxs": "0.625rem",
        "font-size-body-text-xxxl": "1.375rem",
        "font-size-body-text-xxxs": "0.5625rem",
        "font-size-body-text-xxxxl": "1.5625rem",
        "font-size-display-text-1": "4.5625rem",
        "font-size-display-text-2": "3.625rem",
        "font-size-display-text-3": "2.5rem",
        "font-size-heading-text-l": "1rem",
        "font-size-heading-text-m": "0.875rem",
        "font-size-heading-text-s": "0.75rem",
        "font-size-heading-text-xl": "1.125rem",
        "font-size-heading-text-xxl": "1.25rem",
        "font-size-heading-text-xxxl": "1.375rem",
        "font-size-heading-text-xxxxl": "1.75rem",
        "font-size-heading-text-xxxxxl": "2.25rem",
        "font-size-heading-text-xxxxxxl": "3.625rem",
        "font-space-letter-spacing": "normal",
        "font-space-letter-spacing-l": "normal",
        "font-space-letter-spacing-m": "normal",
        "font-space-letter-spacing-s": "normal",
        "font-space-letter-spacing-xs": "normal",
        "font-space-line-height": "1.5",
        "font-space-line-height-l": "1.7",
        "font-space-line-height-m": "1.6",
        "font-space-line-height-s": "1.5",
        "font-space-line-height-xl": "1.8",
        "font-space-line-height-xxl": "1.9",
        "font-style-expression-italic": "normal",
        "font-style-weight-300": "400",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-icon-l": "1rem",
        "size-icon-m": "0.875rem",
        "size-icon-s": "0.75rem",
        "size-icon-xl": "1.125rem",
        "size-icon-xs": "0.75rem",
        "size-icon-xxl": "1.25rem",
        "size-icon-xxs": "0.75rem",
        "size-icon-xxxl": "1.375rem",
        "size-icon-xxxs": "0.75rem",
        "size-icon-xxxxl": "1.5625rem",
        "space-base-l": "1.5rem",
        "space-base-m": "1rem",
        "space-base-null": "0",
        "space-base-s": "0.5rem",
        "space-base-size": "1rem",
        "space-base-xl": "2rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.5625rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "2.875rem",
        "space-base-xxxxl": "3.625rem",
        "space-base-xxxxxl": "4.125rem"
    }
};

const LightTokens = {
    name: "light",
    selectors: [":root", "[data-sas-theme='light']"],
    tokens: {
        "brand-color-alert": "hsl(0, 100%, 40%)",
        "brand-color-alert-00": "hsl(0, 0%, 100%)",
        "brand-color-alert-10": "hsl(0, 100%, 98%)",
        "brand-color-alert-100": "hsl(0, 100%, 64%)",
        "brand-color-alert-1000": "hsl(0, 0%, 0%)",
        "brand-color-alert-20": "hsl(0, 100%, 95%)",
        "brand-color-alert-200": "hsl(0, 100%, 59%)",
        "brand-color-alert-30": "hsl(0, 100%, 92%)",
        "brand-color-alert-300": "hsl(0, 100%, 54%)",
        "brand-color-alert-40": "hsl(0, 100%, 88%)",
        "brand-color-alert-400": "hsl(0, 100%, 46%)",
        "brand-color-alert-450": "hsl(0, 100%, 40%)",
        "brand-color-alert-50": "hsl(0, 100%, 84%)",
        "brand-color-alert-500": "hsl(0, 100%, 36%)",
        "brand-color-alert-550": "hsl(0, 100%, 33%)",
        "brand-color-alert-60": "hsl(0, 100%, 79%)",
        "brand-color-alert-600": "hsl(0, 100%, 30%)",
        "brand-color-alert-650": "hsl(0, 100%, 27%)",
        "brand-color-alert-70": "hsl(0, 100%, 76%)",
        "brand-color-alert-700": "hsl(0, 100%, 22%)",
        "brand-color-alert-750": "hsl(0, 100%, 17%)",
        "brand-color-alert-80": "hsl(0, 100%, 72%)",
        "brand-color-alert-800": "hsl(0, 100%, 12%)",
        "brand-color-alert-850": "hsl(0, 100%, 8%)",
        "brand-color-alert-90": "hsl(0, 100%, 68%)",
        "brand-color-alert-900": "hsl(0, 100%, 3%)",
        "brand-color-blue": "hsl(212, 94%, 42%)",
        "brand-color-blue-00": "hsl(212, 0%, 100%)",
        "brand-color-blue-10": "hsl(212, 94%, 97%)",
        "brand-color-blue-100": "hsl(212, 94%, 62%)",
        "brand-color-blue-1000": "hsl(212, 0%, 0%)",
        "brand-color-blue-20": "hsl(212, 94%, 94%)",
        "brand-color-blue-200": "hsl(212, 94%, 57%)",
        "brand-color-blue-30": "hsl(212, 94%, 90%)",
        "brand-color-blue-300": "hsl(212, 94%, 53%)",
        "brand-color-blue-40": "hsl(212, 94%, 88%)",
        "brand-color-blue-400": "hsl(212, 94%, 47%)",
        "brand-color-blue-450": "hsl(212, 94%, 42%)",
        "brand-color-blue-50": "hsl(212, 94%, 83%)",
        "brand-color-blue-500": "hsl(212, 94%, 36%)",
        "brand-color-blue-550": "hsl(212, 94%, 35%)",
        "brand-color-blue-60": "hsl(212, 94%, 78%)",
        "brand-color-blue-600": "hsl(212, 94%, 31%)",
        "brand-color-blue-650": "hsl(212, 94%, 27%)",
        "brand-color-blue-70": "hsl(212, 94%, 76%)",
        "brand-color-blue-700": "hsl(212, 94%, 23%)",
        "brand-color-blue-750": "hsl(212, 94%, 17%)",
        "brand-color-blue-80": "hsl(212, 94%, 72%)",
        "brand-color-blue-800": "hsl(212, 94%, 12%)",
        "brand-color-blue-850": "hsl(212, 94%, 8%)",
        "brand-color-blue-90": "hsl(212, 94%, 68%)",
        "brand-color-blue-900": "hsl(212, 94%, 3%)",
        "brand-color-cranberry": "hsl(329, 60%, 40%)",
        "brand-color-cranberry-00": "hsl(329,60%,100%)",
        "brand-color-cranberry-10": "hsl(329,60%,98%)",
        "brand-color-cranberry-100": "hsl(329,60%,62%)",
        "brand-color-cranberry-1000": "hsl(329,60%,0%)",
        "brand-color-cranberry-20": "hsl(329,60%,97%)",
        "brand-color-cranberry-200": "hsl(329,60%,57%)",
        "brand-color-cranberry-30": "hsl(329,60%,92%)",
        "brand-color-cranberry-300": "hsl(329,60%,55%)",
        "brand-color-cranberry-40": "hsl(329,60%,88%)",
        "brand-color-cranberry-400": "hsl(329,60%,52%)",
        "brand-color-cranberry-450": "hsl(329,60%,40%)",
        "brand-color-cranberry-50": "hsl(329,60%,84%)",
        "brand-color-cranberry-500": "hsl(329,60%,37%)",
        "brand-color-cranberry-550": "hsl(329,60%,32%)",
        "brand-color-cranberry-60": "hsl(329,60%,78%)",
        "brand-color-cranberry-600": "hsl(329,60%,30%)",
        "brand-color-cranberry-650": "hsl(329,60%,27%)",
        "brand-color-cranberry-70": "hsl(329,60%,76%)",
        "brand-color-cranberry-700": "hsl(329,60%,22%)",
        "brand-color-cranberry-750": "hsl(329,60%,16%)",
        "brand-color-cranberry-80": "hsl(329,60%,72%)",
        "brand-color-cranberry-800": "hsl(329,60%,11%)",
        "brand-color-cranberry-850": "hsl(329,60%,9%)",
        "brand-color-cranberry-90": "hsl(329,60%,68%)",
        "brand-color-cranberry-900": "hsl(329,60%,4%)",
        "brand-color-grey": "hsl(219, 12%, 42%)",
        "brand-color-grey-00": "hsl(219, 0%, 100%)",
        "brand-color-grey-10": "hsl(219, 12%, 98%)",
        "brand-color-grey-100": "hsl(219, 12%, 64%)",
        "brand-color-grey-1000": "hsl(219, 0%, 0%)",
        "brand-color-grey-20": "hsl(219, 12%, 96%)",
        "brand-color-grey-200": "hsl(219, 12%, 59%)",
        "brand-color-grey-30": "hsl(219, 12%, 92%)",
        "brand-color-grey-300": "hsl(219, 12%, 55%)",
        "brand-color-grey-40": "hsl(219, 12%, 88%)",
        "brand-color-grey-400": "hsl(219, 12%, 48%)",
        "brand-color-grey-450": "hsl(219, 12%, 42%)",
        "brand-color-grey-50": "hsl(219, 12%, 84%)",
        "brand-color-grey-500": "hsl(219, 12%, 36%)",
        "brand-color-grey-550": "hsl(219, 12%, 33%)",
        "brand-color-grey-60": "hsl(219, 12%, 79%)",
        "brand-color-grey-600": "hsl(219, 12%, 30%)",
        "brand-color-grey-650": "hsl(219, 12%, 27%)",
        "brand-color-grey-70": "hsl(219, 12%, 76%)",
        "brand-color-grey-700": "hsl(219, 12%, 22%)",
        "brand-color-grey-750": "hsl(219, 12%, 17%)",
        "brand-color-grey-80": "hsl(219, 12%, 72%)",
        "brand-color-grey-800": "hsl(219, 12%, 12%)",
        "brand-color-grey-850": "hsl(219, 12%, 8%)",
        "brand-color-grey-90": "hsl(219, 12%, 68%)",
        "brand-color-grey-900": "hsl(219, 12%, 3%)",
        "brand-color-info": "hsl(212, 94%, 42%)",
        "brand-color-info-00": "hsl(212, 0%, 100%)",
        "brand-color-info-10": "hsl(212, 94%, 97%)",
        "brand-color-info-100": "hsl(212, 94%, 62%)",
        "brand-color-info-1000": "hsl(212, 0%, 0%)",
        "brand-color-info-20": "hsl(212, 94%, 94%)",
        "brand-color-info-200": "hsl(212, 94%, 57%)",
        "brand-color-info-30": "hsl(212, 94%, 90%)",
        "brand-color-info-300": "hsl(212, 94%, 53%)",
        "brand-color-info-40": "hsl(212, 94%, 88%)",
        "brand-color-info-400": "hsl(212, 94%, 47%)",
        "brand-color-info-450": "hsl(212, 94%, 42%)",
        "brand-color-info-50": "hsl(212, 94%, 83%)",
        "brand-color-info-500": "hsl(212, 94%, 36%)",
        "brand-color-info-550": "hsl(212, 94%, 35%)",
        "brand-color-info-60": "hsl(212, 94%, 78%)",
        "brand-color-info-600": "hsl(212, 94%, 31%)",
        "brand-color-info-650": "hsl(212, 94%, 27%)",
        "brand-color-info-70": "hsl(212, 94%, 76%)",
        "brand-color-info-700": "hsl(212, 94%, 23%)",
        "brand-color-info-750": "hsl(212, 94%, 17%)",
        "brand-color-info-80": "hsl(212, 94%, 72%)",
        "brand-color-info-800": "hsl(212, 94%, 12%)",
        "brand-color-info-850": "hsl(212, 94%, 8%)",
        "brand-color-info-90": "hsl(212, 94%, 68%)",
        "brand-color-info-900": "hsl(212, 94%, 3%)",
        "brand-color-success": "hsl(123, 46%, 43%)",
        "brand-color-success-00": "hsl(123, 0%, 100%)",
        "brand-color-success-10": "hsl(123, 46%, 98%)",
        "brand-color-success-100": "hsl(123, 46%, 63%)",
        "brand-color-success-1000": "hsl(123, 0%, 0%)",
        "brand-color-success-20": "hsl(123, 46%, 95%)",
        "brand-color-success-200": "hsl(123, 46%, 58%)",
        "brand-color-success-30": "hsl(123, 46%, 90%)",
        "brand-color-success-300": "hsl(123, 46%, 55%)",
        "brand-color-success-40": "hsl(123, 46%, 87%)",
        "brand-color-success-400": "hsl(123, 46%, 48%)",
        "brand-color-success-450": "hsl(123, 46%, 43%)",
        "brand-color-success-50": "hsl(123, 46%, 82%)",
        "brand-color-success-500": "hsl(123, 46%, 36%)",
        "brand-color-success-550": "hsl(123, 46%, 34%)",
        "brand-color-success-60": "hsl(123, 46%, 78%)",
        "brand-color-success-600": "hsl(123, 46%, 30%)",
        "brand-color-success-650": "hsl(123, 46%, 25%)",
        "brand-color-success-70": "hsl(123, 46%, 75%)",
        "brand-color-success-700": "hsl(123, 46%, 22%)",
        "brand-color-success-750": "hsl(123, 46%, 17%)",
        "brand-color-success-80": "hsl(123, 46%, 70%)",
        "brand-color-success-800": "hsl(123, 46%, 12%)",
        "brand-color-success-850": "hsl(123, 46%, 8%)",
        "brand-color-success-90": "hsl(123, 46%, 66%)",
        "brand-color-success-900": "hsl(123, 46%, 3%)",
        "brand-color-warning": "hsl(43, 89%, 44%)",
        "brand-color-warning-00": "hsl(43, 0%, 100%)",
        "brand-color-warning-10": "hsl(43, 89%, 98%)",
        "brand-color-warning-100": "hsl(43, 89%, 64%)",
        "brand-color-warning-1000": "hsl(43, 0%, 0%)",
        "brand-color-warning-20": "hsl(43, 89%, 95%)",
        "brand-color-warning-200": "hsl(43, 89%, 60%)",
        "brand-color-warning-30": "hsl(43, 89%, 92%)",
        "brand-color-warning-300": "hsl(43, 89%, 56%)",
        "brand-color-warning-40": "hsl(43, 89%, 88%)",
        "brand-color-warning-400": "hsl(43, 89%, 52%)",
        "brand-color-warning-450": "hsl(43, 89%, 44%)",
        "brand-color-warning-50": "hsl(43, 89%, 84%)",
        "brand-color-warning-500": "hsl(43, 89%, 39%)",
        "brand-color-warning-550": "hsl(43, 89%, 35%)",
        "brand-color-warning-60": "hsl(43, 89%, 79%)",
        "brand-color-warning-600": "hsl(43, 89%, 31%)",
        "brand-color-warning-650": "hsl(43, 89%, 27%)",
        "brand-color-warning-70": "hsl(43, 89%, 76%)",
        "brand-color-warning-700": "hsl(43, 89%, 24%)",
        "brand-color-warning-750": "hsl(43, 89%, 17%)",
        "brand-color-warning-80": "hsl(43, 89%, 72%)",
        "brand-color-warning-800": "hsl(43, 89%, 12%)",
        "brand-color-warning-850": "hsl(43, 89%, 8%)",
        "brand-color-warning-90": "hsl(43, 89%, 68%)",
        "brand-color-warning-900": "hsl(43, 89%, 3%)",
        "color-accent-background-1": "hsla(212, 94%, 84%)",
        "color-accent-background-2": "hsla(25, 87%, 84%)",
        "color-accent-background-3": "hsla(169, 40%, 84%)",
        "color-accent-background-4": "hsla(317, 74%, 84%)",
        "color-accent-background-5": "hsla(79, 51%, 84%, 1)",
        "color-accent-background-6": "hsla(266, 72%, 84%, 1)",
        "color-accent-background-7": "hsla(48, 80%, 84%, 1)",
        "color-accent-background-8": "hsla(7, 83%, 84%, 1)",
        "color-accent-border-1": "hsla(212, 94%, 40%)",
        "color-accent-border-2": "hsla(25, 87%, 40%)",
        "color-accent-border-3": "hsla(169, 40%, 40%)",
        "color-accent-border-4": "hsla(317, 74%, 40%)",
        "color-accent-border-5": "hsla(79, 51%, 40%, 1)",
        "color-accent-border-6": "hsla(267, 72%, 40%, 1)",
        "color-accent-border-7": "hsla(48, 80%, 40%, 1)",
        "color-accent-border-8": "hsla(7, 83%, 40%, 1)",
        "color-accent-icon-1": "hsla(212, 94%, 27%)",
        "color-accent-icon-2": "hsla(25, 87%, 27%)",
        "color-accent-icon-3": "hsla(169, 40%, 27%)",
        "color-accent-icon-4": "hsla(317, 74%, 27%)",
        "color-accent-icon-5": "hsla(79, 51%, 27%, 1)",
        "color-accent-icon-6": "hsla(267, 72%, 27%, 1)",
        "color-accent-icon-7": "hsla(48, 80%, 27%, 1)",
        "color-accent-icon-8": "hsla(7, 83%, 27%, 1)",
        "color-accent-spectrum-1-00": "hsla(0, 0%, 100%)",
        "color-accent-spectrum-1-10": "hsla(212, 94%, 98%)",
        "color-accent-spectrum-1-100": "hsla(212, 94%, 62%)",
        "color-accent-spectrum-1-1000": "hsla(0, 0%, 0%)",
        "color-accent-spectrum-1-20": "hsla(212, 94%, 95%)",
        "color-accent-spectrum-1-200": "hsla(212, 94%, 59%)",
        "color-accent-spectrum-1-30": "hsla(212, 94%, 92%)",
        "color-accent-spectrum-1-300": "hsla(212, 94%, 54%)",
        "color-accent-spectrum-1-40": "hsla(212, 94%, 88%)",
        "color-accent-spectrum-1-400": "hsla(212, 94%, 46%)",
        "color-accent-spectrum-1-450": "hsla(212, 94%, 40%)",
        "color-accent-spectrum-1-50": "hsla(212, 94%, 84%)",
        "color-accent-spectrum-1-500": "hsla(212, 94%, 36%)",
        "color-accent-spectrum-1-550": "hsla(212, 94%, 33%)",
        "color-accent-spectrum-1-60": "hsla(212, 94%, 79%)",
        "color-accent-spectrum-1-600": "hsla(212, 94%, 30%)",
        "color-accent-spectrum-1-650": "hsla(212, 94%, 27%)",
        "color-accent-spectrum-1-70": "hsla(212, 94%, 76%)",
        "color-accent-spectrum-1-700": "hsla(212, 94%, 22%)",
        "color-accent-spectrum-1-750": "hsla(212, 94%, 17%)",
        "color-accent-spectrum-1-80": "hsla(212, 94%, 72%)",
        "color-accent-spectrum-1-800": "hsla(212, 94%, 12%)",
        "color-accent-spectrum-1-850": "hsla(212, 94%, 8%)",
        "color-accent-spectrum-1-90": "hsla(212, 94%, 68%)",
        "color-accent-spectrum-1-900": "hsla(212, 94%, 3%)",
        "color-accent-spectrum-2-00": "hsla(0, 0%, 100%)",
        "color-accent-spectrum-2-10": "hsla(25, 87%, 98%)",
        "color-accent-spectrum-2-100": "hsla(25, 87%, 61%)",
        "color-accent-spectrum-2-1000": "hsla(0, 0%, 0%)",
        "color-accent-spectrum-2-20": "hsla(25, 87%, 95%)",
        "color-accent-spectrum-2-200": "hsla(25, 87%, 59%)",
        "color-accent-spectrum-2-30": "hsla(25, 87%, 92%)",
        "color-accent-spectrum-2-300": "hsla(25, 87%, 54%)",
        "color-accent-spectrum-2-40": "hsla(25, 87%, 88%)",
        "color-accent-spectrum-2-400": "hsla(25, 87%, 46%)",
        "color-accent-spectrum-2-450": "hsla(25, 87%, 40%)",
        "color-accent-spectrum-2-50": "hsla(25, 87%, 84%)",
        "color-accent-spectrum-2-500": "hsla(25, 87%, 36%)",
        "color-accent-spectrum-2-550": "hsla(25, 87%, 33%)",
        "color-accent-spectrum-2-60": "hsla(25, 87%, 79%)",
        "color-accent-spectrum-2-600": "hsla(25, 87%, 30%)",
        "color-accent-spectrum-2-650": "hsla(25, 87%, 27%)",
        "color-accent-spectrum-2-70": "hsla(25, 87%, 76%)",
        "color-accent-spectrum-2-700": "hsla(25, 87%, 22%)",
        "color-accent-spectrum-2-750": "hsla(25, 87%, 17%)",
        "color-accent-spectrum-2-80": "hsla(25, 87%, 72%)",
        "color-accent-spectrum-2-800": "hsla(25, 87%, 12%)",
        "color-accent-spectrum-2-850": "hsla(25, 87%, 8%)",
        "color-accent-spectrum-2-90": "hsla(25, 87%, 68%)",
        "color-accent-spectrum-2-900": "hsla(25, 87%, 3%)",
        "color-accent-spectrum-3-00": "hsla(0, 0%, 100%)",
        "color-accent-spectrum-3-10": "hsla(169, 40%, 98%)",
        "color-accent-spectrum-3-100": "hsla(163, 40%, 64%)",
        "color-accent-spectrum-3-1000": "hsla(0, 0%, 0%)",
        "color-accent-spectrum-3-20": "hsla(169, 40%, 95%)",
        "color-accent-spectrum-3-200": "hsla(169, 40%, 59%)",
        "color-accent-spectrum-3-30": "hsla(169, 40%, 92%)",
        "color-accent-spectrum-3-300": "hsla(169, 40%, 52%)",
        "color-accent-spectrum-3-40": "hsla(169, 40%, 88%)",
        "color-accent-spectrum-3-400": "hsla(169, 40%, 46%)",
        "color-accent-spectrum-3-450": "hsla(169, 40%, 40%)",
        "color-accent-spectrum-3-50": "hsla(169, 40%, 84%)",
        "color-accent-spectrum-3-500": "hsla(169, 40%, 36%)",
        "color-accent-spectrum-3-550": "hsla(169, 40%, 33%)",
        "color-accent-spectrum-3-60": "hsla(169, 40%, 79%)",
        "color-accent-spectrum-3-600": "hsla(169, 40%, 30%)",
        "color-accent-spectrum-3-650": "hsla(169, 40%, 27%)",
        "color-accent-spectrum-3-70": "hsla(169, 40%, 76%)",
        "color-accent-spectrum-3-700": "hsla(169, 40%, 22%)",
        "color-accent-spectrum-3-750": "hsla(169, 40%, 17%)",
        "color-accent-spectrum-3-80": "hsla(169, 40%, 72%)",
        "color-accent-spectrum-3-800": "hsla(169, 40%, 12%)",
        "color-accent-spectrum-3-850": "hsla(169, 40%, 8%)",
        "color-accent-spectrum-3-90": "hsla(169, 40%, 68%)",
        "color-accent-spectrum-3-900": "hsla(169, 40%, 3%)",
        "color-accent-spectrum-4-00": "hsla(0, 0%, 100%)",
        "color-accent-spectrum-4-10": "hsla(317, 74%, 98%)",
        "color-accent-spectrum-4-100": "hsla(317, 74%, 64%)",
        "color-accent-spectrum-4-1000": "hsla(0, 0%, 0%)",
        "color-accent-spectrum-4-20": "hsla(317, 74%, 95%)",
        "color-accent-spectrum-4-200": "hsla(317, 74%, 59%)",
        "color-accent-spectrum-4-30": "hsla(317, 74%, 92%)",
        "color-accent-spectrum-4-300": "hsla(317, 74%, 54%)",
        "color-accent-spectrum-4-40": "hsla(317, 74%, 88%)",
        "color-accent-spectrum-4-400": "hsla(317, 74%, 46%)",
        "color-accent-spectrum-4-450": "hsla(317, 74%, 40%)",
        "color-accent-spectrum-4-50": "hsla(317, 74%, 84%)",
        "color-accent-spectrum-4-500": "hsla(317, 74%, 36%)",
        "color-accent-spectrum-4-550": "hsla(317, 74%, 33%)",
        "color-accent-spectrum-4-60": "hsla(317, 74%, 79%)",
        "color-accent-spectrum-4-600": "hsla(317, 74%, 30%)",
        "color-accent-spectrum-4-650": "hsla(317, 74%, 27%)",
        "color-accent-spectrum-4-70": "hsla(317, 74%, 76%)",
        "color-accent-spectrum-4-700": "hsla(317, 74%, 22%)",
        "color-accent-spectrum-4-750": "hsla(317, 74%, 17%)",
        "color-accent-spectrum-4-80": "hsla(317, 74%, 71%)",
        "color-accent-spectrum-4-800": "hsla(317, 74%, 12%)",
        "color-accent-spectrum-4-850": "hsla(317, 74%, 8%)",
        "color-accent-spectrum-4-90": "hsla(317, 74%, 68%)",
        "color-accent-spectrum-4-900": "hsla(317, 74%, 3%)",
        "color-accent-spectrum-5-00": "hsla(0, 0%, 100%, 1)",
        "color-accent-spectrum-5-10": "hsla(79, 51%, 98%, 1)",
        "color-accent-spectrum-5-100": "hsla(79, 51%, 64%, 1)",
        "color-accent-spectrum-5-1000": "hsla(0, 0%, 0%, 1)",
        "color-accent-spectrum-5-20": "hsla(79, 51%, 95%, 1)",
        "color-accent-spectrum-5-200": "hsla(79, 51%, 59%, 1)",
        "color-accent-spectrum-5-30": "hsla(79, 51%, 92%, 1)",
        "color-accent-spectrum-5-300": "hsla(79, 51%, 50%, 1)",
        "color-accent-spectrum-5-40": "hsla(79, 51%, 88%, 1)",
        "color-accent-spectrum-5-400": "hsla(79, 51%, 46%, 1)",
        "color-accent-spectrum-5-450": "hsla(79, 51%, 40%, 1)",
        "color-accent-spectrum-5-50": "hsla(79, 51%, 84%, 1)",
        "color-accent-spectrum-5-500": "hsla(79, 51%, 36%, 1)",
        "color-accent-spectrum-5-550": "hsla(79, 51%, 33%, 1)",
        "color-accent-spectrum-5-60": "hsla(79, 51%, 79%, 1)",
        "color-accent-spectrum-5-600": "hsla(79, 51%, 30%, 1)",
        "color-accent-spectrum-5-650": "hsla(79, 51%, 27%, 1)",
        "color-accent-spectrum-5-70": "hsla(79, 51%, 76%, 1)",
        "color-accent-spectrum-5-700": "hsla(79, 51%, 22%, 1)",
        "color-accent-spectrum-5-750": "hsla(79, 51%, 17%, 1)",
        "color-accent-spectrum-5-80": "hsla(79, 51%, 72%, 1)",
        "color-accent-spectrum-5-800": "hsla(79, 51%, 12%, 1)",
        "color-accent-spectrum-5-850": "hsla(79, 51%, 8%, 1)",
        "color-accent-spectrum-5-90": "hsla(79, 51%, 68%, 1)",
        "color-accent-spectrum-5-900": "hsla(79, 51%, 3%, 1)",
        "color-accent-spectrum-6-00": "hsla(0, 0%, 100%, 1)",
        "color-accent-spectrum-6-10": "hsla(266, 72%, 98%, 1)",
        "color-accent-spectrum-6-100": "hsla(267, 72%, 64%, 1)",
        "color-accent-spectrum-6-1000": "hsla(0, 0%, 0%, 1)",
        "color-accent-spectrum-6-20": "hsla(266, 72%, 95%, 1)",
        "color-accent-spectrum-6-200": "hsla(267, 72%, 59%, 1)",
        "color-accent-spectrum-6-30": "hsla(267, 72%, 92%, 1)",
        "color-accent-spectrum-6-300": "hsla(267, 72%, 54%, 1)",
        "color-accent-spectrum-6-40": "hsla(267, 72%, 88%, 1)",
        "color-accent-spectrum-6-400": "hsla(267, 72%, 46%, 1)",
        "color-accent-spectrum-6-450": "hsla(267, 72%, 40%, 1)",
        "color-accent-spectrum-6-50": "hsla(266, 72%, 84%, 1)",
        "color-accent-spectrum-6-500": "hsla(267, 72%, 36%, 1)",
        "color-accent-spectrum-6-550": "hsla(267, 72%, 33%, 1)",
        "color-accent-spectrum-6-60": "hsla(267, 72%, 79%, 1)",
        "color-accent-spectrum-6-600": "hsla(267, 72%, 30%, 1)",
        "color-accent-spectrum-6-650": "hsla(267, 72%, 27%, 1)",
        "color-accent-spectrum-6-70": "hsla(267, 72%, 76%, 1)",
        "color-accent-spectrum-6-700": "hsla(266, 72%, 22%, 1)",
        "color-accent-spectrum-6-750": "hsla(267, 72%, 17%, 1)",
        "color-accent-spectrum-6-80": "hsla(267, 72%, 72%, 1)",
        "color-accent-spectrum-6-800": "hsla(267, 72%, 12%, 1)",
        "color-accent-spectrum-6-850": "hsla(266, 72%, 8%, 1)",
        "color-accent-spectrum-6-90": "hsla(267, 72%, 67%, 1)",
        "color-accent-spectrum-6-900": "hsla(267, 72%, 3%, 1)",
        "color-accent-spectrum-7-00": "hsla(0, 0%, 100%, 1)",
        "color-accent-spectrum-7-10": "hsla(48, 80%, 98%, 1)",
        "color-accent-spectrum-7-100": "hsla(48, 80%, 64%, 1)",
        "color-accent-spectrum-7-1000": "hsla(0, 0%, 0%, 1)",
        "color-accent-spectrum-7-20": "hsla(48, 80%, 95%, 1)",
        "color-accent-spectrum-7-200": "hsla(48, 80%, 59%, 1)",
        "color-accent-spectrum-7-30": "hsla(48, 80%, 92%, 1)",
        "color-accent-spectrum-7-300": "hsla(48, 80%, 54%, 1)",
        "color-accent-spectrum-7-40": "hsla(48, 80%, 88%, 1)",
        "color-accent-spectrum-7-400": "hsla(48, 80%, 48%, 1)",
        "color-accent-spectrum-7-450": "hsla(48, 80%, 40%, 1)",
        "color-accent-spectrum-7-50": "hsla(48, 80%, 84%, 1)",
        "color-accent-spectrum-7-500": "hsla(48, 80%, 36%, 1)",
        "color-accent-spectrum-7-550": "hsla(48, 80%, 33%, 1)",
        "color-accent-spectrum-7-60": "hsla(48, 80%, 79%, 1)",
        "color-accent-spectrum-7-600": "hsla(48, 80%, 30%, 1)",
        "color-accent-spectrum-7-650": "hsla(48, 80%, 27%, 1)",
        "color-accent-spectrum-7-70": "hsla(48, 80%, 76%, 1)",
        "color-accent-spectrum-7-700": "hsla(48, 80%, 22%, 1)",
        "color-accent-spectrum-7-750": "hsla(48, 80%, 17%, 1)",
        "color-accent-spectrum-7-80": "hsla(48, 80%, 72%, 1)",
        "color-accent-spectrum-7-800": "hsla(48, 80%, 12%, 1)",
        "color-accent-spectrum-7-850": "hsla(48, 80%, 8%, 1)",
        "color-accent-spectrum-7-90": "hsla(48, 80%, 68%, 1)",
        "color-accent-spectrum-7-900": "hsla(48, 80%, 3%, 1)",
        "color-accent-spectrum-8-00": "hsla(0, 0%, 100%, 1)",
        "color-accent-spectrum-8-10": "hsla(7, 83%, 98%, 1)",
        "color-accent-spectrum-8-100": "hsla(7, 83%, 65%, 1)",
        "color-accent-spectrum-8-1000": "hsla(0, 0%, 0%, 1)",
        "color-accent-spectrum-8-20": "hsla(7, 83%, 95%, 1)",
        "color-accent-spectrum-8-200": "hsla(7, 83%, 59%, 1)",
        "color-accent-spectrum-8-30": "hsla(7, 83%, 92%, 1)",
        "color-accent-spectrum-8-300": "hsla(7, 83%, 54%, 1)",
        "color-accent-spectrum-8-40": "hsla(7, 83%, 88%, 1)",
        "color-accent-spectrum-8-400": "hsla(7, 83%, 46%, 1)",
        "color-accent-spectrum-8-450": "hsla(7, 83%, 40%, 1)",
        "color-accent-spectrum-8-50": "hsla(7, 83%, 84%, 1)",
        "color-accent-spectrum-8-500": "hsla(7, 83%, 36%, 1)",
        "color-accent-spectrum-8-550": "hsla(7, 83%, 33%, 1)",
        "color-accent-spectrum-8-60": "hsla(7, 83%, 79%, 1)",
        "color-accent-spectrum-8-600": "hsla(7, 83%, 30%, 1)",
        "color-accent-spectrum-8-650": "hsla(7, 83%, 27%, 1)",
        "color-accent-spectrum-8-70": "hsla(7, 83%, 76%, 1)",
        "color-accent-spectrum-8-700": "hsla(7, 83%, 22%, 1)",
        "color-accent-spectrum-8-750": "hsla(7, 83%, 17%, 1)",
        "color-accent-spectrum-8-80": "hsla(7, 83%, 72%, 1)",
        "color-accent-spectrum-8-800": "hsla(7, 83%, 12%, 1)",
        "color-accent-spectrum-8-850": "hsla(7, 83%, 8%, 1)",
        "color-accent-spectrum-8-90": "hsla(7, 83%, 68%, 1)",
        "color-accent-spectrum-8-900": "hsla(7, 83%, 3%, 1)",
        "color-accent-text-1": "hsla(212, 94%, 27%)",
        "color-accent-text-2": "hsla(25, 87%, 27%)",
        "color-accent-text-3": "hsla(169, 40%, 27%)",
        "color-accent-text-4": "hsla(317, 74%, 27%)",
        "color-accent-text-5": "hsla(79, 51%, 27%, 1)",
        "color-accent-text-6": "hsla(267, 72%, 27%, 1)",
        "color-accent-text-7": "hsla(48, 80%, 27%, 1)",
        "color-accent-text-8": "hsla(7, 83%, 27%, 1)",
        "color-action-background-control-alert": "hsl(0, 100%, 95%)",
        "color-action-background-control-disabled": "hsl(219, 0%, 100%)",
        "color-action-background-control-hover": "hsl(219, 12%, 96%)",
        "color-action-background-control-normal": "hsl(219, 12%, 98%)",
        "color-action-background-control-primary": "hsl(212, 94%, 42%)",
        "color-action-background-control-read-only": "hsl(219, 0%, 100%)",
        "color-action-background-control-selected": "hsl(212, 94%, 94%)",
        "color-action-background-control-warning": "hsl(43, 89%, 95%)",
        "color-action-background-emphasis-active": "hsl(212, 94%, 31%)",
        "color-action-background-emphasis-disabled": "hsl(219, 12%, 96%)",
        "color-action-background-emphasis-hover": "hsl(212, 94%, 31%)",
        "color-action-background-emphasis-normal": "hsl(212, 94%, 42%)",
        "color-action-background-emphasis-selected": "hsl(212, 94%, 31%)",
        "color-action-background-emphasis-visited": "hsl(212, 94%, 42%)",
        "color-action-background-focus": "hsl(205, 97%, 35%)",
        "color-action-background-focus-inverse": "hsl(0, 100%, 100%)",
        "color-action-background-on-off-disabled": "hsl(219, 12%, 96%)",
        "color-action-background-on-off-hover": "hsl(219, 12%, 96%)",
        "color-action-background-on-off-normal": "hsl(219, 0%, 100%)",
        "color-action-background-on-off-read-only": "hsl(219, 12%, 98%)",
        "color-action-background-on-off-selected": "hsl(212, 94%, 42%)",
        "color-action-background-on-off-selected-disabled": "hsl(212, 94%, 94%)",
        "color-action-background-standard-active": "hsl(212, 94%, 94%)",
        "color-action-background-standard-disabled": "hsl(219, 12%, 96%)",
        "color-action-background-standard-hover": "hsl(219, 12%, 96%)",
        "color-action-background-standard-normal": "hsl(219, 12%, 98%)",
        "color-action-background-standard-selected": "hsl(212, 94%, 94%)",
        "color-action-background-standard-selected-disabled": "hsl(212, 94%, 94%)",
        "color-action-background-standard-selected-inactive": "hsl(212, 94%, 97%)",
        "color-action-background-standard-visited": "hsl(219, 12%, 98%)",
        "color-action-background-subtle-disabled": "hsla(0, 0%, 100%, 0)",
        "color-action-background-subtle-hover": "hsl(219, 12%, 96%)",
        "color-action-background-subtle-normal": "hsla(0, 0%, 100%, 0)",
        "color-action-background-subtle-selected": "hsl(212, 94%, 94%)",
        "color-action-background-subtle-selected-disabled": "hsl(212, 94%, 94%)",
        "color-action-background-subtle-selected-inactive": "hsl(212, 94%, 97%)",
        "color-action-border-bottom-control-alert": "hsl(0, 100%, 46%)",
        "color-action-border-bottom-control-hover": "hsl(219, 12%, 59%)",
        "color-action-border-bottom-control-normal": "hsl(219, 12%, 59%)",
        "color-action-border-bottom-control-selected": "hsl(212, 94%, 42%)",
        "color-action-border-bottom-control-warning": "hsl(43, 89%, 52%)",
        "color-action-border-control-alert": "hsl(0, 100%, 46%)",
        "color-action-border-control-disabled": "hsl(219, 12%, 79%)",
        "color-action-border-control-hover": "hsl(219, 12%, 96%)",
        "color-action-border-control-normal": "hsl(219, 12%, 98%)",
        "color-action-border-control-read-only": "hsl(219, 0%, 100%)",
        "color-action-border-control-selected": "hsl(212, 94%, 94%)",
        "color-action-border-control-warning": "hsl(43, 89%, 52%)",
        "color-action-border-emphasis-active": "hsl(212, 94%, 31%)",
        "color-action-border-emphasis-disabled": "hsl(219, 12%, 96%)",
        "color-action-border-emphasis-hover": "hsl(212, 94%, 31%)",
        "color-action-border-emphasis-normal": "hsl(212, 94%, 42%)",
        "color-action-border-emphasis-selected": "hsl(212, 94%, 31%)",
        "color-action-border-emphasis-visited": "hsl(212, 94%, 42%)",
        "color-action-border-focus": "hsl(212, 94%, 31%)",
        "color-action-border-focus-inverse": "hsl(212, 0%, 100%)",
        "color-action-border-on-off-disabled": "hsl(219, 12%, 96%)",
        "color-action-border-on-off-hover": "hsl(219, 12%, 59%)",
        "color-action-border-on-off-normal": "hsl(219, 12%, 59%)",
        "color-action-border-on-off-read-only": "hsl(219, 12%, 59%)",
        "color-action-border-on-off-selected": "hsl(212, 94%, 42%)",
        "color-action-border-on-off-selected-disabled": "hsl(212, 94%, 94%)",
        "color-action-border-standard-active": "hsl(212, 94%, 42%)",
        "color-action-border-standard-disabled": "hsl(219, 12%, 96%)",
        "color-action-border-standard-hover": "hsl(219, 12%, 59%)",
        "color-action-border-standard-normal": "hsl(219, 12%, 88%)",
        "color-action-border-standard-selected": "hsl(212, 94%, 42%)",
        "color-action-border-standard-selected-disabled": "hsl(212, 94%, 94%)",
        "color-action-border-standard-selected-inactive": "hsl(219, 12%, 92%)",
        "color-action-border-standard-visited": "hsl(219, 12%, 88%)",
        "color-action-border-subtle-disabled": "hsla(0, 0%, 100%, 0)",
        "color-action-border-subtle-hover": "hsl(219, 12%, 96%)",
        "color-action-border-subtle-normal": "hsla(0, 0%, 100%, 0)",
        "color-action-border-subtle-selected": "hsl(212, 94%, 90%)",
        "color-action-border-subtle-selected-disabled": "hsl(212, 94%, 94%)",
        "color-action-border-subtle-selected-inactive": "hsl(219, 12%, 92%)",
        "color-action-focus": "hsl(212, 94%, 31%)",
        "color-action-icon-control-alert": "hsl(219, 12%, 12%)",
        "color-action-icon-control-disabled": "hsl(219, 12%, 79%)",
        "color-action-icon-control-hover": "hsl(219, 12%, 12%)",
        "color-action-icon-control-normal": "hsl(219, 12%, 12%)",
        "color-action-icon-control-read-only": "hsl(219, 12%, 12%)",
        "color-action-icon-control-selected": "hsl(219, 12%, 12%)",
        "color-action-icon-control-warning": "hsl(219, 12%, 12%)",
        "color-action-icon-emphasis-active": "hsl(212, 0%, 100%)",
        "color-action-icon-emphasis-disabled": "hsl(219, 12%, 79%)",
        "color-action-icon-emphasis-hover": "hsl(212, 94%, 94%)",
        "color-action-icon-emphasis-normal": "hsl(212, 0%, 100%)",
        "color-action-icon-emphasis-selected": "hsl(212, 0%, 100%)",
        "color-action-icon-emphasis-visited": "hsl(219, 12%, 88%)",
        "color-action-icon-on-off-disabled": "hsl(219, 12%, 79%)",
        "color-action-icon-on-off-hover": "hsl(219, 12%, 12%)",
        "color-action-icon-on-off-normal": "hsl(219, 12%, 12%)",
        "color-action-icon-on-off-read-only": "hsl(219, 12%, 12%)",
        "color-action-icon-on-off-selected": "hsl(219, 0%, 100%)",
        "color-action-icon-on-off-selected-disabled": "hsl(219, 12%, 79%)",
        "color-action-icon-standard-active": "hsl(212, 94%, 31%)",
        "color-action-icon-standard-disabled": "hsl(219, 12%, 79%)",
        "color-action-icon-standard-hover": "hsl(219, 12%, 12%)",
        "color-action-icon-standard-normal": "hsl(219, 12%, 12%)",
        "color-action-icon-standard-selected": "hsl(212, 94%, 31%)",
        "color-action-icon-standard-selected-disabled": "hsl(212, 94%, 88%)",
        "color-action-icon-standard-selected-inactive": "hsl(219, 12%, 12%)",
        "color-action-icon-standard-visited": "hsl(219, 12%, 12%)",
        "color-action-icon-subtle-disabled": "hsl(219, 12%, 79%)",
        "color-action-icon-subtle-hover": "hsl(219, 12%, 12%)",
        "color-action-icon-subtle-normal": "hsl(219, 12%, 12%)",
        "color-action-icon-subtle-selected": "hsl(219, 12%, 12%)",
        "color-action-icon-subtle-selected-disabled": "hsl(219, 12%, 79%)",
        "color-action-icon-subtle-selected-inactive": "hsl(219, 12%, 12%)",
        "color-action-link-active": "hsl(219, 12%, 12%)",
        "color-action-link-hover": "hsl(212, 94%, 42%)",
        "color-action-link-normal": "hsl(212, 94%, 42%)",
        "color-action-link-visited": "hsl(212, 94%, 42%)",
        "color-action-text-control-alert": "hsl(219, 12%, 12%)",
        "color-action-text-control-disabled": "hsl(219, 12%, 79%)",
        "color-action-text-control-hover": "hsl(219, 12%, 12%)",
        "color-action-text-control-normal": "hsl(219, 12%, 12%)",
        "color-action-text-control-placeholder": "hsl(219, 12%, 36%)",
        "color-action-text-control-read-only": "hsl(219, 12%, 12%)",
        "color-action-text-control-selected": "hsl(219, 12%, 12%)",
        "color-action-text-control-warning": "hsl(219, 12%, 12%)",
        "color-action-text-emphasis-active": "hsl(212, 0%, 100%)",
        "color-action-text-emphasis-disabled": "hsl(219, 12%, 79%)",
        "color-action-text-emphasis-hover": "hsl(212, 94%, 94%)",
        "color-action-text-emphasis-normal": "hsl(212, 0%, 100%)",
        "color-action-text-emphasis-selected": "hsl(212, 0%, 100%)",
        "color-action-text-emphasis-visited": "hsl(212, 0%, 100%)",
        "color-action-text-on-off-disabled": "hsl(219, 12%, 79%)",
        "color-action-text-on-off-hover": "hsl(219, 12%, 12%)",
        "color-action-text-on-off-normal": "hsl(219, 12%, 12%)",
        "color-action-text-on-off-read-only": "hsl(219, 12%, 12%)",
        "color-action-text-on-off-selected": "hsl(219, 0%, 100%)",
        "color-action-text-on-off-selected-disabled": "hsl(219, 12%, 79%)",
        "color-action-text-standard-active": "hsl(219, 12%, 12%)",
        "color-action-text-standard-disabled": "hsl(219, 12%, 79%)",
        "color-action-text-standard-hover": "hsl(219, 12%, 12%)",
        "color-action-text-standard-normal": "hsl(219, 12%, 12%)",
        "color-action-text-standard-selected": "hsl(219, 12%, 12%)",
        "color-action-text-standard-selected-disabled": "hsl(219, 12%, 79%)",
        "color-action-text-standard-selected-inactive": "hsl(219, 12%, 12%)",
        "color-action-text-standard-visited": "hsl(219, 12%, 12%)",
        "color-action-text-subtle-disabled": "hsl(219, 12%, 79%)",
        "color-action-text-subtle-hover": "hsl(219, 12%, 12%)",
        "color-action-text-subtle-normal": "hsl(219, 12%, 12%)",
        "color-action-text-subtle-selected": "hsl(219, 12%, 12%)",
        "color-action-text-subtle-selected-disabled": "hsl(219, 12%, 79%)",
        "color-action-text-subtle-selected-inactive": "hsl(219, 12%, 12%)",
        "color-alert-00": "hsl(0, 0%, 100%)",
        "color-alert-10": "hsl(0, 100%, 98%)",
        "color-alert-100": "hsl(0, 100%, 64%)",
        "color-alert-1000": "hsl(0, 0%, 0%)",
        "color-alert-20": "hsl(0, 100%, 95%)",
        "color-alert-200": "hsl(0, 100%, 59%)",
        "color-alert-30": "hsl(0, 100%, 92%)",
        "color-alert-300": "hsl(0, 100%, 54%)",
        "color-alert-40": "hsl(0, 100%, 88%)",
        "color-alert-400": "hsl(0, 100%, 46%)",
        "color-alert-450": "hsl(0, 100%, 40%)",
        "color-alert-50": "hsl(0, 100%, 84%)",
        "color-alert-500": "hsl(0, 100%, 36%)",
        "color-alert-550": "hsl(0, 100%, 33%)",
        "color-alert-60": "hsl(0, 100%, 79%)",
        "color-alert-600": "hsl(0, 100%, 30%)",
        "color-alert-650": "hsl(0, 100%, 27%)",
        "color-alert-70": "hsl(0, 100%, 76%)",
        "color-alert-700": "hsl(0, 100%, 22%)",
        "color-alert-750": "hsl(0, 100%, 17%)",
        "color-alert-80": "hsl(0, 100%, 72%)",
        "color-alert-800": "hsl(0, 100%, 12%)",
        "color-alert-850": "hsl(0, 100%, 8%)",
        "color-alert-90": "hsl(0, 100%, 68%)",
        "color-alert-900": "hsl(0, 100%, 3%)",
        "color-body-icon": "hsl(219, 12%, 12%)",
        "color-body-text": "hsl(219, 12%, 12%)",
        "color-container-background-0": "hsl(219, 0%, 100%)",
        "color-container-background-1": "hsl(219, 12%, 98%)",
        "color-container-background-2": "hsl(219, 12%, 96%)",
        "color-container-background-3": "hsl(212, 94%, 42%)",
        "color-container-background-4": "hsl(219, 12%, 88%)",
        "color-container-border-4": "hsl(219, 12%, 88%)",
        "color-dataviz-graph-alt1": "#3C89E0",
        "color-dataviz-graph-alt2": "#D97D3D",
        "color-dataviz-graph-alt3": "#489C8C",
        "color-dataviz-graph-alt4": "#D473B8",
        "color-dataviz-graph-alt5": "#82A637",
        "color-dataviz-graph-alt6": "#9364CF",
        "color-dataviz-graph-alt7": "#C29F16",
        "color-dataviz-graph-alt8": "#D66354",
        "color-dataviz-graph1": "#4398F9",
        "color-dataviz-graph2": "#F28D44",
        "color-dataviz-graph3": "#54B6A4",
        "color-dataviz-graph4": "#EC80CE",
        "color-dataviz-graph5": "#97C03F",
        "color-dataviz-graph6": "#A570E8",
        "color-dataviz-graph7": "#DCB519",
        "color-dataviz-graph8": "#F06F5E",
        "color-dataviz-kpi-alt1": "#E54040",
        "color-dataviz-kpi-alt3": "#DBC549",
        "color-dataviz-kpi-alt5": "#56AB5A",
        "color-dataviz-kpi1": "#FF4747",
        "color-dataviz-kpi3": "#F5DC51",
        "color-dataviz-kpi5": "#63C568",
        "color-display-icon": "hsl(219, 12%, 12%)",
        "color-display-text": "hsl(219, 12%, 12%)",
        "color-heading-icon": "hsl(219, 12%, 12%)",
        "color-heading-text": "hsl(219, 12%, 12%)",
        "color-highlight-text": "hsl(212, 94%, 42%)",
        "color-highlight-text-inverse": "hsl(212, 0%, 100%)",
        "color-icon-neutral": "hsl(219, 12%, 12%)",
        "color-icon-primary": "hsl(212, 94%, 42%)",
        "color-icon-secondary": "hsl(329,60%,30%)",
        "color-info-00": "hsl(212, 0%, 100%)",
        "color-info-10": "hsl(212, 94%, 97%)",
        "color-info-100": "hsl(212, 94%, 62%)",
        "color-info-1000": "hsl(212, 0%, 0%)",
        "color-info-20": "hsl(212, 94%, 94%)",
        "color-info-200": "hsl(212, 94%, 57%)",
        "color-info-30": "hsl(212, 94%, 90%)",
        "color-info-300": "hsl(212, 94%, 53%)",
        "color-info-40": "hsl(212, 94%, 88%)",
        "color-info-400": "hsl(212, 94%, 47%)",
        "color-info-450": "hsl(212, 94%, 42%)",
        "color-info-50": "hsl(212, 94%, 83%)",
        "color-info-500": "hsl(212, 94%, 36%)",
        "color-info-550": "hsl(212, 94%, 35%)",
        "color-info-60": "hsl(212, 94%, 78%)",
        "color-info-600": "hsl(212, 94%, 31%)",
        "color-info-650": "hsl(212, 94%, 27%)",
        "color-info-70": "hsl(212, 94%, 76%)",
        "color-info-700": "hsl(212, 94%, 23%)",
        "color-info-750": "hsl(212, 94%, 17%)",
        "color-info-80": "hsl(212, 94%, 72%)",
        "color-info-800": "hsl(212, 94%, 12%)",
        "color-info-850": "hsl(212, 94%, 8%)",
        "color-info-90": "hsl(212, 94%, 68%)",
        "color-info-900": "hsl(212, 94%, 3%)",
        "color-label-text": "hsl(219, 12%, 48%)",
        "color-neutral": "hsl(219, 12%, 42%)",
        "color-neutral-00": "hsl(219, 0%, 100%)",
        "color-neutral-10": "hsl(219, 12%, 98%)",
        "color-neutral-100": "hsl(219, 12%, 64%)",
        "color-neutral-1000": "hsl(219, 0%, 0%)",
        "color-neutral-20": "hsl(219, 12%, 96%)",
        "color-neutral-200": "hsl(219, 12%, 59%)",
        "color-neutral-30": "hsl(219, 12%, 92%)",
        "color-neutral-300": "hsl(219, 12%, 55%)",
        "color-neutral-40": "hsl(219, 12%, 88%)",
        "color-neutral-400": "hsl(219, 12%, 48%)",
        "color-neutral-450": "hsl(219, 12%, 42%)",
        "color-neutral-50": "hsl(219, 12%, 84%)",
        "color-neutral-500": "hsl(219, 12%, 36%)",
        "color-neutral-550": "hsl(219, 12%, 33%)",
        "color-neutral-60": "hsl(219, 12%, 79%)",
        "color-neutral-600": "hsl(219, 12%, 30%)",
        "color-neutral-650": "hsl(219, 12%, 27%)",
        "color-neutral-70": "hsl(219, 12%, 76%)",
        "color-neutral-700": "hsl(219, 12%, 22%)",
        "color-neutral-750": "hsl(219, 12%, 17%)",
        "color-neutral-80": "hsl(219, 12%, 72%)",
        "color-neutral-800": "hsl(219, 12%, 12%)",
        "color-neutral-850": "hsl(219, 12%, 8%)",
        "color-neutral-90": "hsl(219, 12%, 68%)",
        "color-neutral-900": "hsl(219, 12%, 3%)",
        "color-primary": "hsl(212, 94%, 42%)",
        "color-primary-00": "hsl(212, 0%, 100%)",
        "color-primary-10": "hsl(212, 94%, 97%)",
        "color-primary-100": "hsl(212, 94%, 62%)",
        "color-primary-1000": "hsl(212, 0%, 0%)",
        "color-primary-20": "hsl(212, 94%, 94%)",
        "color-primary-200": "hsl(212, 94%, 57%)",
        "color-primary-30": "hsl(212, 94%, 90%)",
        "color-primary-300": "hsl(212, 94%, 53%)",
        "color-primary-40": "hsl(212, 94%, 88%)",
        "color-primary-400": "hsl(212, 94%, 47%)",
        "color-primary-450": "hsl(212, 94%, 42%)",
        "color-primary-50": "hsl(212, 94%, 83%)",
        "color-primary-500": "hsl(212, 94%, 36%)",
        "color-primary-550": "hsl(212, 94%, 35%)",
        "color-primary-60": "hsl(212, 94%, 78%)",
        "color-primary-600": "hsl(212, 94%, 31%)",
        "color-primary-650": "hsl(212, 94%, 27%)",
        "color-primary-70": "hsl(212, 94%, 76%)",
        "color-primary-700": "hsl(212, 94%, 23%)",
        "color-primary-750": "hsl(212, 94%, 17%)",
        "color-primary-80": "hsl(212, 94%, 72%)",
        "color-primary-800": "hsl(212, 94%, 12%)",
        "color-primary-850": "hsl(212, 94%, 8%)",
        "color-primary-90": "hsl(212, 94%, 68%)",
        "color-primary-900": "hsl(212, 94%, 3%)",
        "color-secondary": "hsl(329,60%,30%)",
        "color-secondary-00": "hsl(329,60%,100%)",
        "color-secondary-10": "hsl(329,60%,98%)",
        "color-secondary-100": "hsl(329,60%,62%)",
        "color-secondary-1000": "hsl(329,60%,0%)",
        "color-secondary-20": "hsl(329,60%,97%)",
        "color-secondary-200": "hsl(329,60%,57%)",
        "color-secondary-30": "hsl(329,60%,92%)",
        "color-secondary-300": "hsl(329,60%,55%)",
        "color-secondary-40": "hsl(329,60%,88%)",
        "color-secondary-400": "hsl(329,60%,52%)",
        "color-secondary-450": "hsl(329,60%,40%)",
        "color-secondary-50": "hsl(329,60%,84%)",
        "color-secondary-500": "hsl(329,60%,37%)",
        "color-secondary-550": "hsl(329,60%,32%)",
        "color-secondary-60": "hsl(329,60%,78%)",
        "color-secondary-600": "hsl(329,60%,30%)",
        "color-secondary-650": "hsl(329,60%,27%)",
        "color-secondary-70": "hsl(329,60%,76%)",
        "color-secondary-700": "hsl(329,60%,22%)",
        "color-secondary-750": "hsl(329,60%,16%)",
        "color-secondary-80": "hsl(329,60%,72%)",
        "color-secondary-800": "hsl(329,60%,11%)",
        "color-secondary-850": "hsl(329,60%,9%)",
        "color-secondary-90": "hsl(329,60%,68%)",
        "color-secondary-900": "hsl(329,60%,4%)",
        "color-status-alert": "hsl(0, 100%, 36%)",
        "color-status-background-alert": "hsl(0, 100%, 98%)",
        "color-status-background-info": "hsl(212, 94%, 97%)",
        "color-status-background-neutral": "hsl(219, 12%, 98%)",
        "color-status-background-success": "hsl(123, 46%, 98%)",
        "color-status-background-warning": "hsl(43, 89%, 98%)",
        "color-status-border-alert": "hsl(0, 100%, 46%)",
        "color-status-border-info": "hsl(212, 94%, 42%)",
        "color-status-border-neutral": "hsl(219, 12%, 48%)",
        "color-status-border-success": "hsl(123, 46%, 48%)",
        "color-status-border-warning": "hsl(43, 89%, 52%)",
        "color-status-icon-alert": "hsl(0, 100%, 36%)",
        "color-status-icon-info": "hsl(212, 94%, 31%)",
        "color-status-icon-neutral": "hsl(219, 12%, 30%)",
        "color-status-icon-success": "hsl(123, 46%, 30%)",
        "color-status-icon-warning": "hsl(43, 89%, 31%)",
        "color-status-info": "hsl(212, 94%, 36%)",
        "color-status-neutral": "hsl(219, 12%, 36%)",
        "color-status-success": "hsl(123, 46%, 36%)",
        "color-status-text-alert": "hsl(0, 100%, 36%)",
        "color-status-text-info": "hsl(212, 94%, 31%)",
        "color-status-text-neutral": "hsl(219, 12%, 30%)",
        "color-status-text-success": "hsl(123, 46%, 30%)",
        "color-status-text-warning": "hsl(43, 89%, 27%)",
        "color-status-warning": "hsl(43, 89%, 39%)",
        "color-success-00": "hsl(123, 0%, 100%)",
        "color-success-10": "hsl(123, 46%, 98%)",
        "color-success-100": "hsl(123, 46%, 63%)",
        "color-success-1000": "hsl(123, 0%, 0%)",
        "color-success-20": "hsl(123, 46%, 95%)",
        "color-success-200": "hsl(123, 46%, 58%)",
        "color-success-30": "hsl(123, 46%, 90%)",
        "color-success-300": "hsl(123, 46%, 55%)",
        "color-success-40": "hsl(123, 46%, 87%)",
        "color-success-400": "hsl(123, 46%, 48%)",
        "color-success-450": "hsl(123, 46%, 43%)",
        "color-success-50": "hsl(123, 46%, 82%)",
        "color-success-500": "hsl(123, 46%, 36%)",
        "color-success-550": "hsl(123, 46%, 34%)",
        "color-success-60": "hsl(123, 46%, 78%)",
        "color-success-600": "hsl(123, 46%, 30%)",
        "color-success-650": "hsl(123, 46%, 25%)",
        "color-success-70": "hsl(123, 46%, 75%)",
        "color-success-700": "hsl(123, 46%, 22%)",
        "color-success-750": "hsl(123, 46%, 17%)",
        "color-success-80": "hsl(123, 46%, 70%)",
        "color-success-800": "hsl(123, 46%, 12%)",
        "color-success-850": "hsl(123, 46%, 8%)",
        "color-success-90": "hsl(123, 46%, 66%)",
        "color-success-900": "hsl(123, 46%, 3%)",
        "color-syntax-text-01": "hsl(219, 0%, 0%)",
        "color-syntax-text-02": "hsl(219, 12%, 36%)",
        "color-syntax-text-03": "hsla(25, 87%, 27%)",
        "color-syntax-text-04": "hsla(7, 83%, 27%, 1)",
        "color-syntax-text-05": "hsla(267, 72%, 27%, 1)",
        "color-syntax-text-06": "hsla(212, 94%, 27%)",
        "color-syntax-text-07": "hsla(317, 74%, 27%)",
        "color-syntax-text-08": "hsla(169, 40%, 27%)",
        "color-syntax-text-09": "hsla(79, 51%, 27%, 1)",
        "color-syntax-text-attribute-name": "hsla(317, 74%, 27%)",
        "color-syntax-text-attribute-value": "hsla(7, 83%, 27%, 1)",
        "color-syntax-text-boolean": "hsla(267, 72%, 27%, 1)",
        "color-syntax-text-character-constant": "hsla(169, 40%, 27%)",
        "color-syntax-text-class-name": "hsla(169, 40%, 27%)",
        "color-syntax-text-comment": "hsla(79, 51%, 27%, 1)",
        "color-syntax-text-control": "hsla(267, 72%, 27%, 1)",
        "color-syntax-text-data": "hsla(25, 87%, 27%)",
        "color-syntax-text-declaration": "hsla(212, 94%, 27%)",
        "color-syntax-text-default": "hsl(219, 0%, 0%)",
        "color-syntax-text-function": "hsla(267, 72%, 27%, 1)",
        "color-syntax-text-identifier": "hsl(219, 0%, 0%)",
        "color-syntax-text-keyword": "hsla(212, 94%, 27%)",
        "color-syntax-text-namespace": "hsla(169, 40%, 27%)",
        "color-syntax-text-normal": "hsl(219, 0%, 0%)",
        "color-syntax-text-numeric-constant": "hsla(169, 40%, 27%)",
        "color-syntax-text-operator": "hsla(317, 74%, 27%)",
        "color-syntax-text-proc-name": "hsla(317, 74%, 27%)",
        "color-syntax-text-property": "hsla(212, 94%, 27%)",
        "color-syntax-text-punctuation": "hsl(219, 12%, 36%)",
        "color-syntax-text-punctuation-brackets": "hsl(219, 12%, 36%)",
        "color-syntax-text-section": "hsla(317, 74%, 27%)",
        "color-syntax-text-separator": "hsl(219, 0%, 0%)",
        "color-syntax-text-source": "hsla(212, 94%, 27%)",
        "color-syntax-text-storage-type": "hsla(212, 94%, 27%)",
        "color-syntax-text-string": "hsla(7, 83%, 27%, 1)",
        "color-syntax-text-tag": "hsla(212, 94%, 27%)",
        "color-syntax-text-variable": "hsla(317, 74%, 27%)",
        "color-tag-background-1": "hsl(212, 94%, 88%)",
        "color-tag-background-2": "hsl(329,60%,88%)",
        "color-tag-background-3": "hsl(219, 12%, 88%)",
        "color-tag-border-1": "hsl(212, 94%, 42%)",
        "color-tag-border-2": "hsl(329,60%,40%)",
        "color-tag-border-3": "hsl(219, 12%, 42%)",
        "color-text-neutral": "hsl(219, 12%, 12%)",
        "color-text-neutral-inverse": "hsl(219, 0%, 100%)",
        "color-text-primary": "hsl(212, 94%, 42%)",
        "color-text-primary-inverse": "hsl(212, 0%, 100%)",
        "color-text-secondary": "hsl(329,60%,30%)",
        "color-thumbnail-fill-1": "hsl(212, 94%, 94%)",
        "color-thumbnail-fill-2": "hsl(212, 94%, 83%)",
        "color-thumbnail-fill-3": "hsl(212, 94%, 62%)",
        "color-thumbnail-fill-4": "hsl(212, 94%, 42%)",
        "color-warning-00": "hsl(43, 0%, 100%)",
        "color-warning-10": "hsl(43, 89%, 98%)",
        "color-warning-100": "hsl(43, 89%, 64%)",
        "color-warning-1000": "hsl(43, 0%, 0%)",
        "color-warning-20": "hsl(43, 89%, 95%)",
        "color-warning-200": "hsl(43, 89%, 60%)",
        "color-warning-30": "hsl(43, 89%, 92%)",
        "color-warning-300": "hsl(43, 89%, 56%)",
        "color-warning-40": "hsl(43, 89%, 88%)",
        "color-warning-400": "hsl(43, 89%, 52%)",
        "color-warning-450": "hsl(43, 89%, 44%)",
        "color-warning-50": "hsl(43, 89%, 84%)",
        "color-warning-500": "hsl(43, 89%, 39%)",
        "color-warning-550": "hsl(43, 89%, 35%)",
        "color-warning-60": "hsl(43, 89%, 79%)",
        "color-warning-600": "hsl(43, 89%, 31%)",
        "color-warning-650": "hsl(43, 89%, 27%)",
        "color-warning-70": "hsl(43, 89%, 76%)",
        "color-warning-700": "hsl(43, 89%, 24%)",
        "color-warning-750": "hsl(43, 89%, 17%)",
        "color-warning-80": "hsl(43, 89%, 72%)",
        "color-warning-800": "hsl(43, 89%, 12%)",
        "color-warning-850": "hsl(43, 89%, 8%)",
        "color-warning-90": "hsl(43, 89%, 68%)",
        "color-warning-900": "hsl(43, 89%, 3%)",
        "color-zero-state-base-fill-1": "hsl(219, 0%, 100%)",
        "color-zero-state-base-fill-2": "hsl(219, 12%, 79%)",
        "color-zero-state-base-fill-3": "hsl(219, 12%, 84%)",
        "color-zero-state-modifier-fill-1": "hsl(219, 12%, 96%)",
        "color-zero-state-modifier-fill-2": "hsl(212, 94%, 42%)",
        "color-zero-state-modifier-fill-3": "hsl(212, 94%, 78%)",
        "color-zero-state-modifier-fill-4": "hsl(219, 12%, 92%)",
        "color-zero-state-modifier-fill-5": "hsl(219, 12%, 64%)",
        "duration-100": "100ms",
        "duration-1000": "1s",
        "duration-200": "200ms",
        "duration-250": "250ms",
        "duration-300": "300ms",
        "duration-400": "400ms",
        "duration-450": "450ms",
        "duration-500": "500ms",
        "duration-700": "700ms",
        "ease-in": "cubic-bezier(0, 0.5, 0.2, 1)",
        "ease-in-out": "cubic-bezier(0.5, 0, 0.2, 1)",
        "ease-out": "cubic-bezier(0.5, 0, 0.8, 1)",
        "font-family-monospace": "Consolas, Menlo, 'Lucida Console', Courier, Monaco, monospace",
        "font-family-primary": "'Anova UI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "font-family-secondary": "'Anova', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "font-size-base-text": "16px",
        "font-size-body-text-l": "1rem",
        "font-size-body-text-m": "0.875rem",
        "font-size-body-text-s": "0.75rem",
        "font-size-body-text-xl": "1.125rem",
        "font-size-body-text-xs": "0.6875rem",
        "font-size-body-text-xxl": "1.25rem",
        "font-size-body-text-xxs": "0.625rem",
        "font-size-body-text-xxxl": "1.375rem",
        "font-size-body-text-xxxs": "0.5625rem",
        "font-size-body-text-xxxxl": "1.5625rem",
        "font-size-display-text-1": "4.5625rem",
        "font-size-display-text-2": "3.625rem",
        "font-size-display-text-3": "2.5rem",
        "font-size-heading-text-l": "1rem",
        "font-size-heading-text-m": "0.875rem",
        "font-size-heading-text-s": "0.75rem",
        "font-size-heading-text-xl": "1.125rem",
        "font-size-heading-text-xxl": "1.25rem",
        "font-size-heading-text-xxxl": "1.375rem",
        "font-size-heading-text-xxxxl": "1.75rem",
        "font-size-heading-text-xxxxxl": "2.25rem",
        "font-size-heading-text-xxxxxxl": "3.625rem",
        "font-size-ratio": "1.125",
        "font-size-ratio-major-second": "1.125",
        "font-size-ratio-major-third": "1.25",
        "font-size-ratio-minor-third": "1.2",
        "font-space-letter-spacing": "normal",
        "font-space-letter-spacing-l": "2px",
        "font-space-letter-spacing-m": "1px",
        "font-space-letter-spacing-s": "normal",
        "font-space-letter-spacing-xs": "-1px",
        "font-space-line-height": "1.4",
        "font-space-line-height-l": "1.6",
        "font-space-line-height-m": "1.5",
        "font-space-line-height-s": "1.4",
        "font-space-line-height-xl": "1.7",
        "font-space-line-height-xxl": "1.8",
        "font-space-word": "normal",
        "font-space-word-l": "2px",
        "font-space-word-m": "normal",
        "font-space-word-s": "1px",
        "font-style-expression": "normal",
        "font-style-expression-italic": "italic",
        "font-style-expression-normal": "normal",
        "font-style-expression-oblique": "oblique",
        "font-style-overflow-wrap": "anywhere",
        "font-style-overflow-wrap-anywhere": "anywhere",
        "font-style-overflow-wrap-break-word": "break-word",
        "font-style-overflow-wrap-normal": "normal",
        "font-style-text-transform": "none",
        "font-style-text-transform-capitalize": "capitalize",
        "font-style-text-transform-lowercase": "lowercase",
        "font-style-text-transform-none": "none",
        "font-style-text-transform-uppercase": "uppercase",
        "font-style-weight-300": "300",
        "font-style-weight-400": "400",
        "font-style-weight-500": "500",
        "font-style-weight-600": "600",
        "font-style-weight-700": "700",
        "font-style-word-break": "break-all",
        "font-style-word-break-break-all": "break-all",
        "font-style-word-break-break-word": "break-word",
        "font-style-word-break-keep-all": "keep-all",
        "font-style-word-break-normal": "normal",
        "shadow-depth-l": "0 8px 12px rgba(0, 0, 0, 0.04), 0 16px 24px rgba(0, 0, 0, 0.08)",
        "shadow-depth-m": "0 2px 4px rgba(0, 0, 0, 0.04), 0 8px 16px rgba(0, 0, 0, 0.08)",
        "shadow-depth-s": "0 2px 2px rgba(0, 0, 0, 0.04), 0 4px 8px rgba(0, 0, 0, 0.08)",
        "shadow-depth-xl": "0 16px 24px rgba(0, 0, 0, 0.04), 0 32px 48px rgba(0, 0, 0, 0.08)",
        "shadow-depth-xs": "0 1px 2px rgba(0, 0, 0, 0.04), 0 2px 4px rgba(0, 0, 0, 0.08)",
        "size-action-border-width-focus": "2px",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-border-width-l": "3px",
        "size-border-width-m": "2px",
        "size-border-width-null": "0",
        "size-border-width-s": "1px",
        "size-container-l": "400px",
        "size-container-m": "320px",
        "size-container-null": "0",
        "size-container-s": "240px",
        "size-container-xl": "640px",
        "size-container-xs": "192px",
        "size-container-xxl": "960px",
        "size-container-xxs": "96px",
        "size-icon-l": "1rem",
        "size-icon-m": "0.875rem",
        "size-icon-s": "0.75rem",
        "size-icon-xl": "1.125rem",
        "size-icon-xs": "0.75rem",
        "size-icon-xxl": "1.25rem",
        "size-icon-xxs": "0.75rem",
        "size-icon-xxxl": "1.375rem",
        "size-icon-xxxs": "0.75rem",
        "size-icon-xxxxl": "1.5625rem",
        "size-outline-width-l": "3px",
        "size-outline-width-m": "2px",
        "size-outline-width-s": "1px",
        "size-outline-width-xl": "4px",
        "size-zero-state-border-width": "0",
        "space-base-l": "1.5rem",
        "space-base-m": "1rem",
        "space-base-null": "0",
        "space-base-s": "0.5rem",
        "space-base-size": "1rem",
        "space-base-xl": "2rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.5625rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "2.875rem",
        "space-base-xxxxl": "3.625rem",
        "space-base-xxxxxl": "4.125rem",
        "style-action-border-focus": "solid"
    }
};

const SpaciousDensityChineseVariantsLocalesTokens = {
    name: "spacious-density-chinese-variants-locales",
    selectors: ["[data-sas-theme='spacious-density']:lang(zh)", "[data-sas-theme='spacious-density']:lang(zh-cn)", "[data-sas-theme='spacious-density']:lang(zh-sg)", "[data-sas-theme='spacious-density']:lang(zh-hans)", "[data-sas-theme='spacious-density']:lang(zh-cn-pseudo)", "[data-sas-theme='spacious-density']:lang(zh-hk)", "[data-sas-theme='spacious-density']:lang(zh-tw)", "[data-sas-theme='spacious-density']:lang(zh-hant)"],
    tokens: {
        "font-size-body-text-l": "1.25rem",
        "font-size-body-text-m": "1.125rem",
        "font-size-body-text-s": "1rem",
        "font-size-body-text-xl": "1.4375rem",
        "font-size-body-text-xs": "0.875rem",
        "font-size-body-text-xxl": "1.625rem",
        "font-size-body-text-xxs": "0.75rem",
        "font-size-body-text-xxxl": "1.8125rem",
        "font-size-body-text-xxxs": "0.6875rem",
        "font-size-body-text-xxxxl": "2rem",
        "font-size-display-text-1": "5.25rem",
        "font-size-display-text-2": "4.625rem",
        "font-size-display-text-3": "3.25rem",
        "font-size-heading-text-l": "1.25rem",
        "font-size-heading-text-m": "1.125rem",
        "font-size-heading-text-s": "1rem",
        "font-size-heading-text-xl": "1.4375rem",
        "font-size-heading-text-xxl": "1.625rem",
        "font-size-heading-text-xxxl": "1.8125rem",
        "font-size-heading-text-xxxxl": "2.25rem",
        "font-size-heading-text-xxxxxl": "2.875rem",
        "font-size-heading-text-xxxxxxl": "4.625rem",
        "font-space-line-height": "1.6",
        "font-space-line-height-l": "1.8",
        "font-space-line-height-m": "1.7",
        "font-space-line-height-s": "1.6",
        "font-space-line-height-xl": "1.9",
        "font-space-line-height-xxl": "2.0",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "36px",
        "size-border-radius-m": "24px",
        "size-border-radius-s": "12px",
        "size-border-radius-xs": "6px",
        "size-border-radius-xxs": "3px",
        "size-icon-l": "1.25rem",
        "size-icon-m": "1.125rem",
        "size-icon-s": "1rem",
        "size-icon-xl": "1.4375rem",
        "size-icon-xs": "1rem",
        "size-icon-xxl": "1.625rem",
        "size-icon-xxs": "1rem",
        "size-icon-xxxl": "1.8125rem",
        "size-icon-xxxs": "1rem",
        "size-icon-xxxxl": "2rem",
        "space-base-l": "1.75rem",
        "space-base-m": "1.25rem",
        "space-base-null": "0",
        "space-base-s": "0.6875rem",
        "space-base-size": "1rem",
        "space-base-xl": "2.5625rem",
        "space-base-xs": "0.3125rem",
        "space-base-xxl": "3.1875rem",
        "space-base-xxs": "0.1875rem",
        "space-base-xxxl": "3.625rem",
        "space-base-xxxxl": "4.5625rem",
        "space-base-xxxxxl": "5.125rem"
    }
};

const SpaciousDensityEuroSlavicLocalesTokens = {
    name: "spacious-density-euro-slavic-locales",
    selectors: ["[data-sas-theme='spacious-density']:lang(en)"],
    tokens: {
        "font-size-body-text-l": "1.125rem",
        "font-size-body-text-m": "1rem",
        "font-size-body-text-s": "0.875rem",
        "font-size-body-text-xl": "1.25rem",
        "font-size-body-text-xs": "0.75rem",
        "font-size-body-text-xxl": "1.4375rem",
        "font-size-body-text-xxs": "0.6875rem",
        "font-size-body-text-xxxl": "1.625rem",
        "font-size-body-text-xxxs": "0.625rem",
        "font-size-body-text-xxxxl": "1.8125rem",
        "font-size-display-text-1": "5.1875rem",
        "font-size-display-text-2": "4.125rem",
        "font-size-display-text-3": "2.875rem",
        "font-size-heading-text-l": "1.125rem",
        "font-size-heading-text-m": "1rem",
        "font-size-heading-text-s": "0.875rem",
        "font-size-heading-text-xl": "1.25rem",
        "font-size-heading-text-xxl": "1.4375rem",
        "font-size-heading-text-xxxl": "1.625rem",
        "font-size-heading-text-xxxxl": "2rem",
        "font-size-heading-text-xxxxxl": "2.5625rem",
        "font-size-heading-text-xxxxxxl": "4.125re",
        "font-space-line-height": "1.5",
        "font-space-line-height-l": "1.7",
        "font-space-line-height-m": "1.6",
        "font-space-line-height-s": "1.5",
        "font-space-line-height-xl": "1.8",
        "font-space-line-height-xxl": "1.9",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "36px",
        "size-border-radius-m": "24px",
        "size-border-radius-s": "12px",
        "size-border-radius-xs": "6px",
        "size-border-radius-xxs": "3px",
        "size-icon-l": "1.125rem",
        "size-icon-m": "1rem",
        "size-icon-s": "0.875rem",
        "size-icon-xl": "1.25rem",
        "size-icon-xs": "0.75rem",
        "size-icon-xxl": "1.4375rem",
        "size-icon-xxs": "0.75rem",
        "size-icon-xxxl": "1.625rem",
        "size-icon-xxxs": "0.75rem",
        "size-icon-xxxxl": "1.8125rem",
        "space-base-l": "1.625rem",
        "space-base-m": "1.125rem",
        "space-base-null": "0",
        "space-base-s": "0.5625rem",
        "space-base-size": "1rem",
        "space-base-xl": "2.25rem",
        "space-base-xs": "0.3125rem",
        "space-base-xxl": "2.875rem",
        "space-base-xxs": "0.1875rem",
        "space-base-xxxl": "3.25rem",
        "space-base-xxxxl": "4.125rem",
        "space-base-xxxxxl": "4.625rem"
    }
};

const SpaciousDensityMenaAsianLocalesTokens = {
    name: "spacious-density-mena-asian-locales",
    selectors: ["[data-sas-theme='spacious-density']:lang(ar)", "[data-sas-theme='spacious-density']:lang(ar-xx)", "[data-sas-theme='spacious-density']:lang(he)", "[data-sas-theme='spacious-density']:lang(jp)", "[data-sas-theme='spacious-density']:lang(ko)", "[data-sas-theme='spacious-density']:lang(th)", "[data-sas-theme='spacious-density']:lang(vi)", "[data-sas-theme='spacious-density']:lang(vi-VN)"],
    tokens: {
        "font-size-body-text-l": "1.125rem",
        "font-size-body-text-m": "1rem",
        "font-size-body-text-s": "0.875rem",
        "font-size-body-text-xl": "1.25rem",
        "font-size-body-text-xs": "0.8125rem",
        "font-size-body-text-xxl": "1.4375rem",
        "font-size-body-text-xxs": "0.6875rem",
        "font-size-body-text-xxxl": "1.625rem",
        "font-size-body-text-xxxs": "0.625rem",
        "font-size-body-text-xxxxl": "1.8125rem",
        "font-size-display-text-1": "5.1875rem",
        "font-size-display-text-2": "4.125rem",
        "font-size-display-text-3": "2.875rem",
        "font-size-heading-text-l": "1.125rem",
        "font-size-heading-text-m": "1rem",
        "font-size-heading-text-s": "0.875rem",
        "font-size-heading-text-xl": "1.25rem",
        "font-size-heading-text-xxl": "1.4375rem",
        "font-size-heading-text-xxxl": "1.625rem",
        "font-size-heading-text-xxxxl": "2rem",
        "font-size-heading-text-xxxxxl": "2.5625rem",
        "font-size-heading-text-xxxxxxl": "4.125rem",
        "font-space-line-height": "1.6",
        "font-space-line-height-l": "1.8",
        "font-space-line-height-m": "1.7",
        "font-space-line-height-s": "1.6",
        "font-space-line-height-xl": "1.9",
        "font-space-line-height-xxl": "2.0",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "36px",
        "size-border-radius-m": "24px",
        "size-border-radius-s": "12px",
        "size-border-radius-xs": "6px",
        "size-border-radius-xxs": "3px",
        "size-icon-l": "1.125rem",
        "size-icon-m": "1rem",
        "size-icon-s": "0.875rem",
        "size-icon-xl": "1.25rem",
        "size-icon-xs": "0.875rem",
        "size-icon-xxl": "1.4375rem",
        "size-icon-xxs": "0.875rem",
        "size-icon-xxxl": "1.625rem",
        "size-icon-xxxs": "0.875rem",
        "size-icon-xxxxl": "1.8125rem",
        "space-base-l": "1.625rem",
        "space-base-m": "1.125rem",
        "space-base-null": "0",
        "space-base-s": "0.5625rem",
        "space-base-size": "1rem",
        "space-base-xl": "2.25rem",
        "space-base-xs": "0.3125rem",
        "space-base-xxl": "2.875rem",
        "space-base-xxs": "0.1875rem",
        "space-base-xxxl": "3.25rem",
        "space-base-xxxxl": "4.125rem",
        "space-base-xxxxxl": "4.625rem"
    }
};

const SpaciousDensityTokens = {
    name: "spacious-density",
    selectors: ["[data-sas-theme='spacious-density']"],
    tokens: {
        "font-size-body-text-l": "1.125rem",
        "font-size-body-text-m": "1rem",
        "font-size-body-text-s": "0.875rem",
        "font-size-body-text-xl": "1.25rem",
        "font-size-body-text-xs": "0.75rem",
        "font-size-body-text-xxl": "1.4375rem",
        "font-size-body-text-xxs": "0.6875rem",
        "font-size-body-text-xxxl": "1.625rem",
        "font-size-body-text-xxxs": "0.625rem",
        "font-size-body-text-xxxxl": "1.8125rem",
        "font-size-display-text-1": "5.1875rem",
        "font-size-display-text-2": "4.125rem",
        "font-size-display-text-3": "2.875rem",
        "font-size-heading-text-l": "1.125rem",
        "font-size-heading-text-m": "1rem",
        "font-size-heading-text-s": "0.875rem",
        "font-size-heading-text-xl": "1.25rem",
        "font-size-heading-text-xxl": "1.4375rem",
        "font-size-heading-text-xxxl": "1.625rem",
        "font-size-heading-text-xxxxl": "2rem",
        "font-size-heading-text-xxxxxl": "2.5625rem",
        "font-size-heading-text-xxxxxxl": "4.125rem",
        "font-space-line-height": "1.5",
        "font-space-line-height-l": "1.7",
        "font-space-line-height-m": "1.6",
        "font-space-line-height-s": "1.5",
        "font-space-line-height-xl": "1.8",
        "font-space-line-height-xxl": "1.9",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "36px",
        "size-border-radius-m": "24px",
        "size-border-radius-s": "12px",
        "size-border-radius-xs": "6px",
        "size-border-radius-xxs": "3px",
        "size-icon-l": "1.125rem",
        "size-icon-m": "1rem",
        "size-icon-s": "0.875rem",
        "size-icon-xl": "1.25rem",
        "size-icon-xs": "0.75rem",
        "size-icon-xxl": "1.4375rem",
        "size-icon-xxs": "0.75rem",
        "size-icon-xxxl": "1.625rem",
        "size-icon-xxxs": "0.75rem",
        "size-icon-xxxxl": "1.8125rem",
        "space-base-l": "1.625rem",
        "space-base-m": "1.125rem",
        "space-base-null": "0",
        "space-base-s": "0.5625rem",
        "space-base-size": "1rem",
        "space-base-xl": "2.25rem",
        "space-base-xs": "0.3125rem",
        "space-base-xxl": "2.875rem",
        "space-base-xxs": "0.1875rem",
        "space-base-xxxl": "3.25rem",
        "space-base-xxxxl": "4.125rem",
        "space-base-xxxxxl": "4.625rem"
    }
};

const StandardDensityChineseVariantsLocalesTokens = {
    name: "standard-density-chinese-variants-locales",
    selectors: ["[data-sas-theme='spacious-density']:lang(zh)", "[data-sas-theme='spacious-density']:lang(zh-cn)", "[data-sas-theme='spacious-density']:lang(zh-sg)", "[data-sas-theme='spacious-density']:lang(zh-hans)", "[data-sas-theme='spacious-density']:lang(zh-cn-pseudo)", "[data-sas-theme='spacious-density']:lang(zh-hk)", "[data-sas-theme='spacious-density']:lang(zh-tw)", "[data-sas-theme='spacious-density']:lang(zh-hant)"],
    tokens: {
        "font-size-body-text-l": "1.125rem",
        "font-size-body-text-m": "1rem",
        "font-size-body-text-s": "0.875rem",
        "font-size-body-text-xl": "1.25rem",
        "font-size-body-text-xs": "0.8125rem",
        "font-size-body-text-xxl": "1.4375rem",
        "font-size-body-text-xxs": "0.6875rem",
        "font-size-body-text-xxxl": "1.625rem",
        "font-size-body-text-xxxs": "0.625rem",
        "font-size-body-text-xxxxl": "1.8125rem",
        "font-size-display-text-1": "5.1875rem",
        "font-size-display-text-2": "4.125rem",
        "font-size-display-text-3": "2.875rem",
        "font-size-heading-text-l": "1.125rem",
        "font-size-heading-text-m": "1rem",
        "font-size-heading-text-s": "0.875rem",
        "font-size-heading-text-xl": "1.25rem",
        "font-size-heading-text-xxl": "1.4375rem",
        "font-size-heading-text-xxxl": "1.625rem",
        "font-size-heading-text-xxxxl": "2rem",
        "font-size-heading-text-xxxxxl": "2.5625rem",
        "font-size-heading-text-xxxxxxl": "4.125rem",
        "font-space-line-height": "1.5",
        "font-space-line-height-l": "1.7",
        "font-space-line-height-m": "1.6",
        "font-space-line-height-s": "1.5",
        "font-space-line-height-xl": "1.8",
        "font-space-line-height-xxl": "1.9",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-icon-l": "1.125rem",
        "size-icon-m": "1rem",
        "size-icon-s": "0.875rem",
        "size-icon-xl": "1.25rem",
        "size-icon-xs": "0.875rem",
        "size-icon-xxl": "1.4375rem",
        "size-icon-xxs": "0.875rem",
        "size-icon-xxxl": "1.625rem",
        "size-icon-xxxs": "0.875rem",
        "size-icon-xxxxl": "1.8125rem",
        "space-base-l": "1.625rem",
        "space-base-m": "1.125rem",
        "space-base-null": "0",
        "space-base-s": "0.5625rem",
        "space-base-size": "1.125rem",
        "space-base-xl": "2.25rem",
        "space-base-xs": "0.3125rem",
        "space-base-xxl": "2.875rem",
        "space-base-xxs": "0.1875rem",
        "space-base-xxxl": "3.25rem",
        "space-base-xxxxl": "4.125rem",
        "space-base-xxxxxl": "4.625rem"
    }
};

const StandardDensityEuroSlavicLocalesTokens = {
    name: "standard-density-euro-slavic-locales",
    selectors: ["[data-sas-theme='standard-density']:lang(en)"],
    tokens: {
        "font-size-body-text-l": "1rem",
        "font-size-body-text-m": "0.875rem",
        "font-size-body-text-s": "0.75rem",
        "font-size-body-text-xl": "1.125rem",
        "font-size-body-text-xs": "0.6875rem",
        "font-size-body-text-xxl": "1.25rem",
        "font-size-body-text-xxs": "0.625rem",
        "font-size-body-text-xxxl": "1.375rem",
        "font-size-body-text-xxxs": "0.5625rem",
        "font-size-body-text-xxxxl": "1.5625rem",
        "font-size-display-text-1": "4.5625rem",
        "font-size-display-text-2": "3.625rem",
        "font-size-display-text-3": "2.5rem",
        "font-size-heading-text-l": "1rem",
        "font-size-heading-text-m": "0.875rem",
        "font-size-heading-text-s": "0.75rem",
        "font-size-heading-text-xl": "1.125rem",
        "font-size-heading-text-xxl": "1.25rem",
        "font-size-heading-text-xxxl": "1.375rem",
        "font-size-heading-text-xxxxl": "1.75rem",
        "font-size-heading-text-xxxxxl": "2.25rem",
        "font-size-heading-text-xxxxxxl": "3.625rem",
        "font-space-line-height": "1.4",
        "font-space-line-height-l": "1.6",
        "font-space-line-height-m": "1.5",
        "font-space-line-height-s": "1.4",
        "font-space-line-height-xl": "1.7",
        "font-space-line-height-xxl": "1.8",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-icon-l": "1rem",
        "size-icon-m": "0.875rem",
        "size-icon-s": "0.75rem",
        "size-icon-xl": "1.125rem",
        "size-icon-xs": "0.75rem",
        "size-icon-xxl": "1.25rem",
        "size-icon-xxs": "0.75rem",
        "size-icon-xxxl": "1.375rem",
        "size-icon-xxxs": "0.75rem",
        "size-icon-xxxxl": "1.5625rem",
        "space-base-l": "1.5rem",
        "space-base-m": "1rem",
        "space-base-null": "0",
        "space-base-s": "0.5rem",
        "space-base-size": "1rem",
        "space-base-xl": "2rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.5625rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "2.875rem",
        "space-base-xxxxl": "3.625rem",
        "space-base-xxxxxl": "4.125rem"
    }
};

const StandardDensityMenaAsianLocalesTokens = {
    name: "standard-density-mena-asian-locales",
    selectors: ["[data-sas-theme='standard-density']:lang(ar)", "[data-sas-theme='standard-density']:lang(ar-xx)", "[data-sas-theme='standard-density']:lang(he)", "[data-sas-theme='standard-density']:lang(jp)", "[data-sas-theme='standard-density']:lang(ko)", "[data-sas-theme='standard-density']:lang(th)", "[data-sas-theme='standard-density']:lang(vi)", "[data-sas-theme='standard-density']:lang(vi-VN)"],
    tokens: {
        "font-size-body-text-l": "1rem",
        "font-size-body-text-m": "0.875rem",
        "font-size-body-text-s": "0.75rem",
        "font-size-body-text-xl": "1.125rem",
        "font-size-body-text-xs": "0.6875rem",
        "font-size-body-text-xxl": "1.25rem",
        "font-size-body-text-xxs": "0.625rem",
        "font-size-body-text-xxxl": "1.375rem",
        "font-size-body-text-xxxs": "0.5625rem",
        "font-size-body-text-xxxxl": "1.5625rem",
        "font-size-display-text-1": "4.5625rem",
        "font-size-display-text-2": "3.625rem",
        "font-size-display-text-3": "2.5rem",
        "font-size-heading-text-l": "1rem",
        "font-size-heading-text-m": "0.875rem",
        "font-size-heading-text-s": "0.75rem",
        "font-size-heading-text-xl": "1.125rem",
        "font-size-heading-text-xxl": "1.25rem",
        "font-size-heading-text-xxxl": "1.375rem",
        "font-size-heading-text-xxxxl": "1.75rem",
        "font-size-heading-text-xxxxxl": "2.25rem",
        "font-size-heading-text-xxxxxxl": "3.625rem",
        "font-space-line-height": "1.5",
        "font-space-line-height-l": "1.7",
        "font-space-line-height-m": "1.6",
        "font-space-line-height-s": "1.5",
        "font-space-line-height-xl": "1.8",
        "font-space-line-height-xxl": "1.9",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-icon-l": "1rem",
        "size-icon-m": "0.875rem",
        "size-icon-s": "0.75rem",
        "size-icon-xl": "1.125rem",
        "size-icon-xs": "0.75rem",
        "size-icon-xxl": "1.25rem",
        "size-icon-xxs": "0.75rem",
        "size-icon-xxxl": "1.375rem",
        "size-icon-xxxs": "0.75rem",
        "size-icon-xxxxl": "1.5625rem",
        "space-base-l": "1.5rem",
        "space-base-m": "1rem",
        "space-base-null": "0",
        "space-base-s": "0.5rem",
        "space-base-size": "1rem",
        "space-base-xl": "2rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.5625rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "2.875rem",
        "space-base-xxxxl": "3.625rem",
        "space-base-xxxxxl": "4.125rem"
    }
};

const StandardDensityTokens = {
    name: "standard-density",
    selectors: ["[data-sas-theme='standard-density']"],
    tokens: {
        "font-size-body-text-l": "1rem",
        "font-size-body-text-m": "0.875rem",
        "font-size-body-text-s": "0.75rem",
        "font-size-body-text-xl": "1.125rem",
        "font-size-body-text-xs": "0.6875rem",
        "font-size-body-text-xxl": "1.25rem",
        "font-size-body-text-xxs": "0.625rem",
        "font-size-body-text-xxxl": "1.375rem",
        "font-size-body-text-xxxs": "0.5625rem",
        "font-size-body-text-xxxxl": "1.5625rem",
        "font-size-display-text-1": "4.5625rem",
        "font-size-display-text-2": "3.625rem",
        "font-size-display-text-3": "2.5rem",
        "font-size-heading-text-l": "1rem",
        "font-size-heading-text-m": "0.875rem",
        "font-size-heading-text-s": "0.75rem",
        "font-size-heading-text-xl": "1.125rem",
        "font-size-heading-text-xxl": "1.25rem",
        "font-size-heading-text-xxxl": "1.375rem",
        "font-size-heading-text-xxxxl": "1.75rem",
        "font-size-heading-text-xxxxxl": "2.25rem",
        "font-size-heading-text-xxxxxxl": "3.625rem",
        "font-space-line-height": "1.4",
        "font-space-line-height-l": "1.6",
        "font-space-line-height-m": "1.5",
        "font-space-line-height-s": "1.4",
        "font-space-line-height-xl": "1.7",
        "font-space-line-height-xxl": "1.8",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-icon-l": "1rem",
        "size-icon-m": "0.875rem",
        "size-icon-s": "0.75rem",
        "size-icon-xl": "1.125rem",
        "size-icon-xs": "0.75rem",
        "size-icon-xxl": "1.25rem",
        "size-icon-xxs": "0.75rem",
        "size-icon-xxxl": "1.375rem",
        "size-icon-xxxs": "0.75rem",
        "size-icon-xxxxl": "1.5625rem",
        "space-base-l": "1.5rem",
        "space-base-m": "1rem",
        "space-base-null": "0",
        "space-base-s": "0.5rem",
        "space-base-size": "1rem",
        "space-base-xl": "2rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.5625rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "2.875rem",
        "space-base-xxxxl": "3.625rem",
        "space-base-xxxxxl": "4.125rem"
    }
};

const TaiwaneseTokens = {
    name: "taiwanese",
    selectors: [":lang(zh-tw)", ":lang(zh-hant)"],
    tokens: {
        "font-family-monospace": "Consolas, Menlo, 'Lucida Console', Courier, Monaco, monospace",
        "font-family-primary": "'Anova UI', '微軟正黑體', 'Microsoft JhengHei', '黑體-繁', 'Heiti TC', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-family-secondary": "'Anova', '微軟正黑體', 'Microsoft JhengHei', '黑體-繁', 'Heiti TC', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-size-body-text-l": "1.125rem",
        "font-size-body-text-m": "1rem",
        "font-size-body-text-s": "0.875rem",
        "font-size-body-text-xl": "1.25rem",
        "font-size-body-text-xs": "0.8125rem",
        "font-size-body-text-xxl": "1.4375rem",
        "font-size-body-text-xxs": "0.6875rem",
        "font-size-body-text-xxxl": "1.625rem",
        "font-size-body-text-xxxs": "0.625rem",
        "font-size-body-text-xxxxl": "1.8125rem",
        "font-size-display-text-1": "5.1875rem",
        "font-size-display-text-2": "4.125rem",
        "font-size-display-text-3": "2.875rem",
        "font-size-heading-text-l": "1.125rem",
        "font-size-heading-text-m": "1rem",
        "font-size-heading-text-s": "0.875rem",
        "font-size-heading-text-xl": "1.25rem",
        "font-size-heading-text-xxl": "1.4375rem",
        "font-size-heading-text-xxxl": "1.625rem",
        "font-size-heading-text-xxxxl": "2rem",
        "font-size-heading-text-xxxxxl": "2.5625rem",
        "font-size-heading-text-xxxxxxl": "4.125rem",
        "font-space-letter-spacing": "normal",
        "font-space-letter-spacing-l": "normal",
        "font-space-letter-spacing-m": "normal",
        "font-space-letter-spacing-s": "normal",
        "font-space-letter-spacing-xs": "normal",
        "font-space-line-height": "1.5",
        "font-space-line-height-l": "1.7",
        "font-space-line-height-m": "1.6",
        "font-space-line-height-s": "1.5",
        "font-space-line-height-xl": "1.8",
        "font-space-line-height-xxl": "1.9",
        "font-style-expression-italic": "normal",
        "font-style-text-transform-uppercase": "initial",
        "font-style-weight-300": "400",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-icon-l": "1.125rem",
        "size-icon-m": "1rem",
        "size-icon-s": "0.875rem",
        "size-icon-xl": "1.25rem",
        "size-icon-xs": "0.875rem",
        "size-icon-xxl": "1.4375rem",
        "size-icon-xxs": "0.875rem",
        "size-icon-xxxl": "1.625rem",
        "size-icon-xxxs": "0.875rem",
        "size-icon-xxxxl": "1.8125rem",
        "space-base-l": "1.625rem",
        "space-base-m": "1.125rem",
        "space-base-null": "0",
        "space-base-s": "0.5625rem",
        "space-base-size": "1.125rem",
        "space-base-xl": "2.25rem",
        "space-base-xs": "0.3125rem",
        "space-base-xxl": "2.875rem",
        "space-base-xxs": "0.1875rem",
        "space-base-xxxl": "3.25rem",
        "space-base-xxxxl": "4.125rem",
        "space-base-xxxxxl": "4.625rem"
    }
};

const ThaiTokens = {
    name: "thai",
    selectors: [":lang(th)"],
    tokens: {
        "font-family-monospace": "Consolas, Menlo, 'Lucida Console', Courier, Monaco, monospace",
        "font-family-primary": "'Anova UI', 'Thonburi', 'Leelawadee UI', 'TH Sarabun New', 'Cordia New', Roboto, Noto, 'Noto Sans Thai', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-family-secondary": "'Anova', 'Thonburi', 'Leelawadee UI', 'TH Sarabun New', 'Cordia New', Roboto, Noto, 'Noto Sans Thai', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-size-body-text-l": "1.125rem",
        "font-size-body-text-m": "1rem",
        "font-size-body-text-s": "0.875rem",
        "font-size-body-text-xl": "1.25rem",
        "font-size-body-text-xs": "0.8125rem",
        "font-size-body-text-xxl": "1.4375rem",
        "font-size-body-text-xxs": "0.6875rem",
        "font-size-body-text-xxxl": "1.625rem",
        "font-size-body-text-xxxs": "0.625rem",
        "font-size-body-text-xxxxl": "1.8125rem",
        "font-size-display-text-1": "5.1875rem",
        "font-size-display-text-2": "4.125rem",
        "font-size-display-text-3": "2.875rem",
        "font-size-heading-text-l": "1.125rem",
        "font-size-heading-text-m": "1rem",
        "font-size-heading-text-s": "0.875rem",
        "font-size-heading-text-xl": "1.25rem",
        "font-size-heading-text-xxl": "1.4375rem",
        "font-size-heading-text-xxxl": "1.625rem",
        "font-size-heading-text-xxxxl": "2rem",
        "font-size-heading-text-xxxxxl": "2.5625rem",
        "font-size-heading-text-xxxxxxl": "4.125rem",
        "font-space-letter-spacing": "normal",
        "font-space-letter-spacing-l": "normal",
        "font-space-letter-spacing-m": "normal",
        "font-space-letter-spacing-s": "normal",
        "font-space-letter-spacing-xs": "normal",
        "font-space-line-height": "1.5",
        "font-space-line-height-l": "1.7",
        "font-space-line-height-m": "1.6",
        "font-space-line-height-s": "1.5",
        "font-space-line-height-xl": "1.8",
        "font-space-line-height-xxl": "1.9",
        "font-style-expression-italic": "normal",
        "font-style-weight-300": "400",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-icon-l": "1.125rem",
        "size-icon-m": "1rem",
        "size-icon-s": "0.875rem",
        "size-icon-xl": "1.25rem",
        "size-icon-xs": "0.875rem",
        "size-icon-xxl": "1.4375rem",
        "size-icon-xxs": "0.875rem",
        "size-icon-xxxl": "1.625rem",
        "size-icon-xxxs": "0.875rem",
        "size-icon-xxxxl": "1.8125rem",
        "space-base-l": "1.625rem",
        "space-base-m": "1.125rem",
        "space-base-null": "0",
        "space-base-s": "0.5625rem",
        "space-base-size": "1.125rem",
        "space-base-xl": "2.25rem",
        "space-base-xs": "0.3125rem",
        "space-base-xxl": "2.875rem",
        "space-base-xxs": "0.1875rem",
        "space-base-xxxl": "3.25rem",
        "space-base-xxxxl": "4.125rem",
        "space-base-xxxxxl": "4.625rem"
    }
};

const VietnameseTokens = {
    name: "vietnamese",
    selectors: [":lang(vi)", ":lang(vi-VN)"],
    tokens: {
        "font-family-monospace": "Consolas, Menlo, 'Lucida Console', Courier, Monaco, monospace",
        "font-family-primary": "'Anova UI', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-family-secondary": "'Anova', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-size-body-text-l": "1rem",
        "font-size-body-text-m": "0.875rem",
        "font-size-body-text-s": "0.75rem",
        "font-size-body-text-xl": "1.125rem",
        "font-size-body-text-xs": "0.6875rem",
        "font-size-body-text-xxl": "1.25rem",
        "font-size-body-text-xxs": "0.625rem",
        "font-size-body-text-xxxl": "1.375rem",
        "font-size-body-text-xxxs": "0.5625rem",
        "font-size-body-text-xxxxl": "1.5625rem",
        "font-size-display-text-1": "4.5625rem",
        "font-size-display-text-2": "3.625rem",
        "font-size-display-text-3": "2.5rem",
        "font-size-heading-text-l": "1rem",
        "font-size-heading-text-m": "0.875rem",
        "font-size-heading-text-s": "0.75rem",
        "font-size-heading-text-xl": "1.125rem",
        "font-size-heading-text-xxl": "1.25rem",
        "font-size-heading-text-xxxl": "1.375rem",
        "font-size-heading-text-xxxxl": "1.75rem",
        "font-size-heading-text-xxxxxl": "2.25rem",
        "font-size-heading-text-xxxxxxl": "3.625rem",
        "font-space-line-height": "1.5",
        "font-space-line-height-l": "1.7",
        "font-space-line-height-m": "1.6",
        "font-space-line-height-s": "1.5",
        "font-space-line-height-xl": "1.8",
        "font-space-line-height-xxl": "1.9",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-icon-l": "1rem",
        "size-icon-m": "0.875rem",
        "size-icon-s": "0.75rem",
        "size-icon-xl": "1.125rem",
        "size-icon-xs": "0.75rem",
        "size-icon-xxl": "1.25rem",
        "size-icon-xxs": "0.75rem",
        "size-icon-xxxl": "1.375rem",
        "size-icon-xxxs": "0.75rem",
        "size-icon-xxxxl": "1.5625rem",
        "space-base-l": "1.5rem",
        "space-base-m": "1rem",
        "space-base-null": "0",
        "space-base-s": "0.5rem",
        "space-base-size": "1rem",
        "space-base-xl": "2rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.5625rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "2.875rem",
        "space-base-xxxxl": "3.625rem",
        "space-base-xxxxxl": "4.125rem"
    }
};

export { ArabicPseudoTokens, ArabicTokens, ChineseChinaTokens, ChineseHongKongTokens, ChinesePseudoTokens, CompactDensityChineseVariantsTokens, CompactDensityEuroSlavicLocalesTokens, CompactDensityMenaAsianLocalesTokens, CompactDensityTokens, DarkTokens, EnglishTokens, HebrewTokens, HighContrastTokens, JapaneseTokens, KoreanTokens, LightTokens, SpaciousDensityChineseVariantsLocalesTokens, SpaciousDensityEuroSlavicLocalesTokens, SpaciousDensityMenaAsianLocalesTokens, SpaciousDensityTokens, StandardDensityChineseVariantsLocalesTokens, StandardDensityEuroSlavicLocalesTokens, StandardDensityMenaAsianLocalesTokens, StandardDensityTokens, TaiwaneseTokens, ThaiTokens, VietnameseTokens };
//# sourceMappingURL=index.js.map
